var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAboutUsRightEx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 960 729.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #9d9fa2;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #5e5e61;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #868d8c;\r\n      }\r\n\r\n      .cls-5 {\r\n        opacity: .5;\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: #ccb090;\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: #e0c79d;\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: #c1a251;\r\n      }\r\n\r\n      .cls-9 {\r\n        fill: #a2a3a6;\r\n      }\r\n\r\n      .cls-10 {\r\n        fill: #c4c5c7;\r\n      }\r\n\r\n      .cls-11 {\r\n        fill: #7f8487;\r\n      }\r\n\r\n      .cls-12 {\r\n        fill: #4d5655;\r\n      }\r\n\r\n      .cls-13 {\r\n        fill: #747577;\r\n      }\r\n\r\n      .cls-14 {\r\n        fill: #272525;\r\n      }\r\n\r\n      .cls-15 {\r\n        fill: #bebcc0;\r\n      }\r\n\r\n      .cls-16 {\r\n        fill: #adabae;\r\n      }\r\n\r\n      .cls-17 {\r\n        fill: #5a7774;\r\n      }\r\n\r\n      .cls-18 {\r\n        fill: #d0d0d3;\r\n      }\r\n\r\n      .cls-19 {\r\n        fill: #e5e6e7;\r\n      }\r\n\r\n      .cls-20 {\r\n        fill: #5f3324;\r\n      }\r\n\r\n      .cls-21 {\r\n        fill: #626a68;\r\n      }\r\n\r\n      .cls-22 {\r\n        fill: #959296;\r\n      }\r\n\r\n      .cls-23 {\r\n        fill: #dfc07f;\r\n      }\r\n\r\n      .cls-24 {\r\n        fill: #b2b3b3;\r\n      }\r\n\r\n      .cls-25 {\r\n        fill: #eec83d;\r\n      }\r\n\r\n      .cls-26 {\r\n        fill: #d1d0d2;\r\n      }\r\n\r\n      .cls-27 {\r\n        fill: #efca46;\r\n      }\r\n\r\n      .cls-28 {\r\n        fill: #e9e8e9;\r\n      }\r\n\r\n      .cls-29 {\r\n        fill: #8d949c;\r\n      }\r\n\r\n      .cls-30 {\r\n        fill: #bc9653;\r\n      }\r\n\r\n      .cls-31 {\r\n        fill: #dfdfdf;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "655.07 197 707.36 166.03 643.99 119.17 591.59 149.44 637.05 175.7 655.07 197"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M607.04,173.84v-25.47c-7.98-4.61-15.45-8.93-15.45-8.93v100.04l63.57,36.74v-68.86l-43.83-25.3c-2.36-1.36-4.3-5.06-4.3-8.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M623.39,167.56c-3.5-2.02-10.08-5.82-16.35-9.45v15.73c0,3.15,1.93,6.85,4.3,8.21l43.83,25.3v-8.39c0-8.07-4.3-15.53-11.29-19.56-7.3-4.22-16.2-9.36-20.49-11.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M675.58,137.2c-3.5-2.02-10.08-5.82-16.35-9.45v15.73c0,3.15,1.93,6.85,4.3,8.21l43.83,25.3v-8.39c0-8.07-4.3-15.53-11.29-19.56-7.3-4.22-16.2-9.36-20.49-11.84Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "607.04 158.11 659.58 128.17 659.58 118.27 607.04 148.37 607.04 158.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "707.36 166.03 655.16 196.18 655.16 276.22 707.36 246.07 707.36 166.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "591.59 232.81 655.16 269.61 655.16 268.29 591.59 231.62 591.59 232.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "591.59 221.95 655.16 258.76 655.16 257.44 591.59 220.77 591.59 221.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "591.59 211.38 655.16 248.19 655.16 246.87 591.59 210.2 591.59 211.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "591.59 200.53 655.16 237.33 655.16 236.02 591.59 199.35 591.59 200.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "591.59 189.96 655.16 226.76 655.16 225.44 591.59 188.78 591.59 189.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "591.59 179.18 655.16 215.99 655.16 214.67 591.59 178 591.59 179.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "677.45 201.81 655.16 214.67 655.16 215.99 677.45 203.09 677.45 201.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "677.45 212.59 655.16 225.44 655.16 226.76 677.45 213.86 677.45 212.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "677.45 223.24 655.16 236.1 655.16 237.42 677.45 224.51 677.45 223.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "677.45 234.01 655.16 246.87 655.16 248.19 677.45 235.29 677.45 234.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "677.45 244.66 655.16 257.52 655.16 258.84 677.45 245.93 677.45 244.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "677.45 255.44 655.16 268.29 655.16 269.61 677.45 256.71 677.45 255.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M605.71,222.57s6.66,7.03,14.51,11.6c9.06,5.28,16.85,6.52,16.85,6.52l-31.36-18.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M605.71,211.71s6.66,7.03,14.51,11.6c9.06,5.28,16.85,6.52,16.85,6.52l-31.36-18.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M605.71,201.14s6.66,7.03,14.51,11.6c9.06,5.28,16.85,6.52,16.85,6.52l-31.36-18.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M605.71,190.29s6.66,7.03,14.51,11.6c9.06,5.28,16.85,6.52,16.85,6.52l-31.36-18.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "686.21 130.53 644 106.07 610.84 125.14 653.22 149.61 686.21 130.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "634.16 159.96 652.53 170.57 676.57 156.79 679.98 145.3 654.67 141.95 634.16 159.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M639.64,161.08l13.58-7.85-42.38-24.47-19.24,11.07,36.8,21.26c3.48,2.01,7.77,2.01,11.25,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "634.02 160.57 653.22 153.23 686.47 133.91 686.47 130.28 634.02 160.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M639.64,157.36l13.58-7.85-42.38-24.47-19.24,11.07,36.8,21.26c3.48,2.01,7.77,2.01,11.25,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M617.52,147.21l-18.02-10.4c-.95-.55-.83-1.51,.27-2.14l9.63-5.56c1.09-.63,2.76-.7,3.71-.15l18.02,10.4c.95,.55,.83,1.51-.27,2.14l-9.63,5.56c-1.09,.63-2.76,.7-3.71,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M610.62,125.16s-.86-8.7,3.11-10.86c3.97-2.17,30.37-17.5,30.37-17.5l-.31,9.39-33.17,18.97Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "644.09 96.8 647.77 98.96 646.89 103.39 686.47 124.47 653.08 149.61 610.62 125.16 644.09 96.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M615.86,121.33s6.66,7.03,14.51,11.6c9.06,5.28,16.85,6.52,16.85,6.52l-31.36-18.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "673.51 138.19 673.51 150.94 686.47 143.49 686.47 130.28 673.51 138.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "655.07 196.09 655.16 207.35 707.36 176.99 707.36 166.03 655.07 196.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "591.59 139.83 591.59 136.1 597.63 139.59 591.59 139.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M622.29,119.15l33.9,19.59v3.21l30.28-17.49-38.65-22.27-24.8,14.33c-.85,.49-1.45,1.05-1.87,1.64,.28,.36,.64,.7,1.14,.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M623.02,113.31c-2.4,1.39-3.05,3.36-1.87,4.85,.41-.59,1.02-1.15,1.87-1.64l24.72-14.28v-3.21l-24.72,14.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M656.19,138.75c-3.97,2.17-3.11,10.86-3.11,10.86l33.39-19.34v-5.81l-30.28,17.49v-3.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M624.23,120.25l26.11-20.24c1.21-.94,2.86-1.05,4.19-.29l20.21,11.68c2.26,1.31,2.53,4.46,.53,6.14l-22.81,19.04-28.24-16.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M623.38,119.78l26.97-20.99c1.21-.94,2.86-1.05,4.19-.29l20.21,11.68c2.26,1.31,2.53,4.46,.53,6.14l-23.66,19.79-28.24-16.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "709.8 145.29 657.07 145.43 657.07 147.33 709.8 147.33 709.8 145.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M681.08,161.19l-24.01-13.86,27.55-15.78,23.9,13.8c1.91,1.1,1.67,3.05-.54,4.32l-19.42,11.21c-2.21,1.27-5.57,1.41-7.48,.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M681.08,159.29l-24.01-13.86,27.55-15.78,23.9,13.8c1.91,1.1,1.67,3.05-.54,4.32l-19.42,11.21c-2.21,1.27-5.57,1.41-7.48,.31Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "657.07 145.43 657.07 142.78 684.62 126.89 684.62 129.65 657.07 145.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "681 131.73 704.91 145.57 685.17 156.89 661.19 143.08 681 131.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "626.11 121.33 652.64 101.1 672.77 113.26 648.65 134.39 626.11 121.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "676.64 194.86 676.64 263.81 677.95 263.06 677.95 194.1 676.64 194.86"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "250.34 406.11 566.72 223.89 563.46 222 247.12 404.26 250.34 406.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "250.34 406.11 250.34 525.83 566.72 343.61 566.72 223.89 250.34 406.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "247.12 404.26 247.12 524.13 250.34 525.98 250.34 406.11 247.12 404.26"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "615.11 396.13 568.5 369.02 568.5 302.56 615.11 329.67 615.11 396.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "615.11 396.13 618.22 394.34 618.22 327.88 615.11 329.67 615.11 396.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "570.58 370.18 567.47 368.39 567.47 301.93 570.58 303.73 570.58 370.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "488.82 411.7 628.89 330.45 628.89 327.14 488.82 408.38 488.82 411.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "628.89 327.14 570.82 293.54 488.66 341.21 546.68 374.82 628.89 327.14"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M612.9,370.43s-.41,16.43-.41,20.12,.51,11.42-5.99,14.16c-6.5,2.75-15.71,6.34-15.71,6.34l8.72,5.61s8.79-3.83,13.31-6.61c6.36-3.92,5.69-14.63,5.69-21.43s-1.16-15.68-1.16-15.68l-4.46-2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M590.79,446.78h0c-1.91,0-3.48-1.57-3.48-3.48v-32.12c0-1.91,1.57-3.48,3.48-3.48h0c1.91,0,3.48,1.57,3.48,3.48v32.12c0,1.91-1.57,3.48-3.48,3.48Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M612.81,412.72c0,6.47-9.86,11.71-22.02,11.71s-22.02-5.24-22.02-11.71,9.86-11.71,22.02-11.71,22.02,5.24,22.02,11.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 568.77,
    y: 410.51,
    width: 44.04,
    height: 2.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M612.81,410.51c0,6.47-9.86,11.71-22.02,11.71s-22.02-5.24-22.02-11.71,9.86-11.71,22.02-11.71,22.02,5.24,22.02,11.71Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 590.79,
    cy: 409.24,
    rx: 20.98,
    ry: 11.16
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "570.92 402.07 569.81 409.24 611.77 409.24 610.66 402.07 570.92 402.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M610.95,403.84c0,5.92-9.02,10.72-20.16,10.72s-20.16-4.8-20.16-10.72,9.02-10.72,20.16-10.72,20.16,4.8,20.16,10.72Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M633.38,396.6v-24.09c0-8.44-5.18-18.33-11.5-21.98l-6-3.47c-6.33-3.65-11.5,.26-11.5,8.7v24.09l29.01,16.75Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "608.23 346.55 603.31 349.47 607.71 352.39 608.23 346.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "628.59 399.44 633.38 396.6 627.71 391.02 628.59 399.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M628.59,399.44v-24.09c0-8.44-5.18-18.33-11.5-21.98l-6-3.47c-6.33-3.65-11.5,.26-11.5,8.7v24.09l29.01,16.75Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M570.15,463.34c0,2.16-1.31,4.67-2.93,5.6-1.62,.93-2.93-.06-2.93-2.22s1.31-4.67,2.93-5.6c1.62-.93,2.93,.06,2.93,2.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "571.26 462.23 569 460.9 565.31 469.1 567.66 470.46 571.26 462.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M572.52,464.71c0,2.16-1.31,4.67-2.93,5.6-1.62,.93-2.93-.06-2.93-2.22s1.31-4.67,2.93-5.6c1.62-.93,2.93,.06,2.93,2.22Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M565.52,462.01h0c-.67-1.17-.27-2.66,.89-3.33l46.31-26.73c1.17-.67,2.66-.27,3.33,.89h0c.67,1.17,.27,2.66-.89,3.33l-46.31,26.73c-1.17,.67-2.66,.27-3.33-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M612.73,462.91l-46.31-26.73c-1.17-.67-1.57-2.17-.89-3.33h0c.67-1.17,2.17-1.57,3.33-.89l46.31,26.73c1.17,.67,1.57,2.17,.89,3.33h0c-.67,1.17-2.17,1.57-3.33,.89Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M615.55,436.59c0,2.16-1.31,4.67-2.93,5.6-1.62,.93-2.93-.06-2.93-2.22s1.31-4.67,2.93-5.6c1.62-.93,2.93,.06,2.93,2.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "616.66 435.48 614.4 434.15 610.71 442.35 613.07 443.71 616.66 435.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M617.92,437.96c0,2.16-1.31,4.67-2.93,5.6-1.62,.93-2.93-.06-2.93-2.22s1.31-4.67,2.93-5.6c1.62-.93,2.93,.06,2.93,2.22Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M612.7,464.02c0,2.16-1.31,4.67-2.93,5.6s-2.93-.06-2.93-2.22,1.31-4.67,2.93-5.6,2.93,.06,2.93,2.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "613.81 462.91 611.54 461.58 607.86 469.78 610.21 471.14 613.81 462.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M615.07,465.39c0,2.16-1.31,4.67-2.93,5.6-1.62,.93-2.93-.06-2.93-2.22s1.31-4.67,2.93-5.6c1.62-.93,2.93,.06,2.93,2.22Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M568.3,438.11c0,2.16-1.31,4.67-2.93,5.6s-2.93-.06-2.93-2.22,1.31-4.67,2.93-5.6c1.62-.93,2.93,.06,2.93,2.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "569.41 437 567.14 435.67 563.46 443.87 565.81 445.23 569.41 437"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M570.67,439.48c0,2.16-1.31,4.67-2.93,5.6-1.62,.93-2.93-.06-2.93-2.22s1.31-4.67,2.93-5.6,2.93,.06,2.93,2.22Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M555.31,461.9s-2.1,2.29-4.91,5.02c-2.6,2.53-3.4,3.26-5.81,5.62-1.41,1.37-.25,2.64,2.44,2.53,2.36-.09,7.7-1.24,10.69-2.31,2.12-.76,6.02-2.91,8-4.17,1.99-1.26,2.38-3,2.38-3v-4.23l-12.78,.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M555.54,414.55c-2.39,16.9-1.33,46.28-1.33,46.28,0,0,.31,3.65,6.58,3.63,4.8-.02,8.77-3.93,8.77-3.93l.5-35.03,2.08-10.3c-5.52-.4-11.05-.61-16.59-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M572.4,472.55s-2.1,2.29-4.91,5.02c-2.6,2.53-3.4,3.26-5.81,5.62-1.41,1.37-.25,2.64,2.43,2.53,2.36-.09,7.7-1.24,10.69-2.31,2.12-.76,6.02-2.91,8-4.17,1.99-1.26,2.38-3,2.38-3v-4.23l-12.78,.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M572.63,425.2c-2.39,16.9-1.33,46.28-1.33,46.28,0,0,.31,3.65,6.58,3.63,4.8-.02,8.77-3.93,8.77-3.93l.5-35.03,2.08-10.3c-5.52-.4-11.05-.61-16.59-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M577.98,406.28c3.26,5.8,12.48,1.11,18.52,.7,8.19-.55,12.97,3.93,17.59,1.67,2.52-6.86,.39-14.01,0-20.98-.46-8.29,4.49-16.81,3.81-26.27-2.45-8.06-12.46-15.5-12.46-15.5l-12.8-.23s-4.68,0-7.46,2.87c-4.23,4.37-4.55,13.96-5.04,21.89-.52,8.28,1.83,18.01,1.05,25.06-.17,1.56-1.73,4.2-3.21,10.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M593.76,350.83l4.14,2.96s.87,6.62-2.17,10.33c-3.03,3.71-6.01,11.96-6.01,11.96,0,0-3.54-10.78-1.74-15.69,1.8-4.91,3.73-10.05,3.73-10.05l2.04,.49Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "590.63 353.28 591.72 357.14 594.39 358.34 597.91 355.91 595.24 351.95 590.63 353.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M592.2,356.03s-3.09,6.96-3.82,8.48c-.73,1.52,0,5.28,0,5.28l1.35,6.29s2.03-6.51,3.23-8.53c.36-3.31,1.65-10.61,1.65-10.61l-2.42-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M592.93,344.69s-2.57,.84-4.62,3.84c-1.26,1.85-2.35,3.5-2.35,3.5l3.1,1.87-3.5,1.29s-.49,4.78,.46,9.21,3.71,11.68,3.71,11.68c0,0-.55-11.97,0-15.2,1.29-7.53,3.71-10.9,3.71-10.9,0,0,1.96-4.23,1.8-4.31-.17-.07-2.3-.97-2.3-.97Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M594.08,343.84l-1.11,6.49s1.14,.51,2.28,1.62c1.54,1.51,3.43,3.53,5.84,1.47,4.17-3.58,4.77-5.22,4.77-5.22l-2.05-11.42-9.72,7.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M604.94,324.23c-2.77-3.53-10.72-6.49-15.9,1.17-5.43,8.04-.3,21.18,4.46,20.41,2.67-.43,8.66-2.86,11.29-7.15,2.96-4.83,2.29-11.7,.14-14.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M586.71,328.12c1.04,1.82,3.59,3.88,8.06,4.29,3.65,.33,6.59-.65,6.59-.65l-1.23,8.61s1.25,.05,2.02-5.07c.56-1.84,2.21-1.66,2.73-.63,.61,1.21-.08,3.99-.08,3.99,0,0,4.36-2.46,4.56-8.06,.13-3.49-2.63-11.16-8.99-12.2-6.36-1.04-11.39,2.16-13.09,5.51-.85,1.68-1.04,3.37-.57,4.19Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "593.73 345.85 591.72 353.45 595.24 351.95 597.13 357.14 603.31 349.47 595.24 351.95 593.73 345.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M587.76,339.88c-.57,1.65,.57,5.88,3.07,7.1,2.5,1.22,6.72-1.2,8.42-2.81,.87-.82,1.8-2.4,2.31-6.09,.34-2.48-.64-2.21-1-.7-1.31,5.45-4.49,6.25-6.31,6.79-3.19,.96-4.91-.66-6.48-4.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M605.03,343.64s-3.74,7.56-5.45,9.81c-1.71,2.25-5.86,9.15-7.77,13.42-.92,2.06-2.07,9.21-2.07,9.21,0,0,1.63-3.09,6.74-8.36,3.17-3.28,6.23-5.7,6.23-5.7l-2.3-4.06,5.04,1.59s2-2.81,2.43-5.29c.47-2.69,.64-5.09,.37-6.02-.84-2.86-3.2-4.58-3.2-4.58Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "488.92 469.41 468.46 457.58 468.46 391.12 488.92 402.95 488.92 469.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "488.92 469.41 492.03 467.62 492.03 401.16 488.92 402.95 488.92 469.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "488.92 438.97 592.53 498.79 592.53 470.38 488.92 410.09 488.92 438.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "595.64 531.46 644.17 503.61 644.17 437.15 595.64 465.01 595.64 531.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "595.64 531.46 592.53 529.67 592.53 463.21 595.64 465.01 595.64 531.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "642.61 504.51 645.72 502.72 645.72 436.26 642.61 438.05 642.61 504.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "595.74 473.75 468.46 399.88 468.46 396.56 595.74 470.43 595.74 473.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "595.74 470.43 653.83 436.88 653.83 439.99 595.74 473.55 595.74 470.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M546.68,377.92l-58.02-33.61-19.56,11.35c-17.08,9.91-17.05,34.57,.04,44.45l19.68,11.37,106.92,62.05v-3.1l-49.06-92.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M546.68,374.82l-58.02-33.61-19.56,11.35c-17.08,9.91-17.05,34.57,.04,44.45l19.68,11.37,106.92,62.05,58.09-33.56-107.14-62.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M589.66,346.1c-.37-.51-3.21-2.92-7.4,1.2-5.72,5.63-10.22,14.7-15.12,18.55-1.14,.9-20.85,10.98-20.85,10.98l4.24,8.76s12.07-6.34,16.61-8.39c5.24-2.36,10.9-5.59,13.14-9.12,.44-18.68,9.38-21.99,9.38-21.99Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "587.99 409.37 564.01 395.5 555.14 400.61 579.16 414.48 587.99 409.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "579.16 415.74 587.99 410.61 587.99 409.37 579.16 414.48 579.16 415.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "579.16 414.48 579.16 415.74 555.14 401.79 555.14 400.61 579.16 414.48"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "576.05 412.69 575.6 412.43 584.44 407.32 584.89 407.58 576.05 412.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "572.55 410.67 572.1 410.41 580.94 405.3 581.4 405.56 572.55 410.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "569.06 408.65 568.61 408.39 577.45 403.28 577.9 403.54 569.06 408.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "565.59 406.63 565.14 406.37 573.98 401.26 574.44 401.52 565.59 406.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "586.28 410.36 586.73 410.1 562.72 396.23 562.26 396.48 586.28 410.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "584.54 411.41 584.98 411.16 560.95 397.27 560.49 397.53 584.54 411.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "582.72 412.43 583.17 412.17 559.16 398.29 558.7 398.55 582.72 412.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "580.91 413.52 581.4 413.29 557.31 399.36 556.86 399.62 580.91 413.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "562.19 404.66 561.74 404.4 570.58 399.29 571.03 399.54 562.19 404.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "558.82 402.71 558.37 402.45 567.21 397.34 567.66 397.6 558.82 402.71"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M564.35,388.63l-4.93-2.84h0c-.18-.11-.39-.19-.63-.19-3.54,0-7.5,6.31-7.5,6.31l5.01,2.87,8.29-5.55-.24-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M556.27,394.78l8.92-5.15s-.47-1.15-1.42-1.15c-3.54,0-7.5,6.31-7.5,6.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M553.21,393.01l.53,.3s.67-1.06,1.69-2.3l-.53-.3c-1.02,1.24-1.68,2.3-1.68,2.3Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M543.04,364.14l-14.33,8.27c-1.12,.64-3.08,.56-4.37-.18l-24.57-14.19c-1.29-.74-1.43-1.88-.31-2.52l14.33-8.27c1.12-.64,3.08-.56,4.37,.18l24.57,14.19c1.29,.74,1.43,1.88,.31,2.52Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 498.7,
    y: 354.91,
    width: 1.42,
    height: 1.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 542.36,
    y: 361.48,
    width: 1.42,
    height: 1.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M543.04,362.54l-14.33,8.27c-1.12,.64-3.08,.56-4.37-.18l-24.57-14.19c-1.29-.74-1.43-1.88-.31-2.52l14.33-8.27c1.12-.64,3.08-.56,4.37,.18l24.57,14.19c1.29,.74,1.43,1.88,.31,2.52Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "503.26 355 516.54 347.3 540.13 361.47 526.86 369.17 503.26 355"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M502.89,351.94l3.97,2.47,8.68-5.24-3.78-2.35s-1.17,.71-1.91,1.08-1.76-1.1-4.11,.15c-2.67,1.41,.08,2.22-.79,2.71-.64,.36-2.06,1.19-2.06,1.19Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "541.58 414.95 530.37 408.48 526.19 414.95 532.75 420.65 541.58 414.95"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M555.42,376.31v32.81c0,2.45-2.65,3.99-4.78,2.76l-38.61-22.29c-.99-.57-1.59-1.62-1.59-2.76v-32.81c0-2.45,2.65-3.99,4.78-2.76l38.61,22.29c.99,.57,1.59,1.62,1.59,2.76Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "553.84 411.88 551.71 413.12 549.21 410.51 554.16 407.48 553.84 411.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "511.82 351.39 509.98 352.46 513.67 352.52 511.82 351.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M553.35,377.52v32.81c0,2.45-2.65,3.99-4.78,2.76l-38.61-22.29c-.99-.57-1.59-1.62-1.59-2.76v-32.81c0-2.45,2.65-3.99,4.78-2.76l38.61,22.29c.99,.57,1.59,1.62,1.59,2.76Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "523.06 387.67 523.06 416.68 531.89 421.8 531.89 392.8 523.06 387.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "523.06 387.67 524.22 387.02 533.05 392.15 531.89 392.8 523.06 387.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "533.05 392.15 531.89 392.8 531.89 421.8 533.05 421.15 533.05 392.15"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "532.75 421.32 541.58 416.19 541.58 414.95 532.75 420.06 532.75 421.32"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "599.84 419.85 574.89 434.31 591.73 444.05 616.68 429.56 599.84 419.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "589.85 427.93 582.96 431.91 596.14 439.46 603.04 435.48 589.85 427.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "591.74 426.84 591.19 427.16 604.38 434.7 604.92 434.39 591.74 426.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "592.97 426.13 592.42 426.45 605.6 434 606.15 433.68 592.97 426.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "594.26 425.38 593.71 425.7 606.9 433.25 607.45 432.93 594.26 425.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "595.51 424.67 594.96 424.98 608.15 432.52 608.7 432.21 595.51 424.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "596.74 423.95 596.19 424.27 609.38 431.82 609.92 431.5 596.74 423.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "598.04 423.21 597.49 423.52 610.67 431.08 611.22 430.76 598.04 423.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "581.57 432.72 581.02 433.03 594.21 440.58 594.76 440.26 581.57 432.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "600.69 421.65 598.77 422.76 611.94 430.31 613.88 429.2 600.69 421.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "574.89 434.31 574.89 435.53 591.73 445.27 591.73 444.05 574.89 434.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "616.66 429.57 591.73 444.05 591.73 445.27 616.66 430.79 616.66 429.57"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "599.84 417.35 574.89 431.81 591.73 441.56 616.68 427.07 599.84 417.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "589.85 425.44 582.96 429.41 596.14 436.96 603.04 432.98 589.85 425.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "591.74 424.35 591.19 424.66 604.38 432.2 604.92 431.89 591.74 424.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "592.97 423.63 592.42 423.95 605.6 431.5 606.15 431.18 592.97 423.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "594.26 422.89 593.71 423.21 606.9 430.76 607.45 430.44 594.26 422.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "595.51 422.17 594.96 422.48 608.15 430.03 608.7 429.72 595.51 422.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "596.74 421.46 596.19 421.77 609.38 429.33 609.92 429.01 596.74 421.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "598.04 420.71 597.49 421.03 610.67 428.58 611.22 428.26 598.04 420.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "581.57 430.22 581.02 430.53 594.21 438.08 594.76 437.77 581.57 430.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "600.69 419.16 598.77 420.26 611.94 427.82 613.88 426.7 600.69 419.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "574.89 431.81 574.89 433.03 591.73 442.77 591.73 441.56 574.89 431.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "616.66 427.08 591.73 441.56 591.73 442.77 616.66 428.3 616.66 427.08"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "599.84 414.37 574.89 428.82 591.73 438.57 616.68 424.08 599.84 414.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "589.85 422.45 582.96 426.42 596.14 433.97 603.04 430 589.85 422.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "591.74 421.36 591.19 421.67 604.38 429.22 604.92 428.91 591.74 421.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "592.97 420.65 592.42 420.96 605.6 428.52 606.15 428.19 592.97 420.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "594.26 419.9 593.71 420.22 606.9 427.77 607.45 427.45 594.26 419.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "595.51 419.18 594.96 419.49 608.15 427.04 608.7 426.73 595.51 419.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "596.74 418.47 596.19 418.79 609.38 426.34 609.92 426.02 596.74 418.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "598.04 417.72 597.49 418.04 610.67 425.59 611.22 425.27 598.04 417.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "581.57 427.23 581.02 427.54 594.21 435.09 594.76 434.78 581.57 427.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "600.69 416.17 598.77 417.28 611.94 424.83 613.88 423.72 600.69 416.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "574.89 428.82 574.89 430.04 591.73 439.79 591.73 438.57 574.89 428.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "616.66 424.09 591.73 438.57 591.73 439.79 616.66 425.31 616.66 424.09"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M599.84,439.43c-2.79,0-5.06,1.2-5.06,2.69s2.26,2.69,5.06,2.69,5.06-1.2,5.06-2.69-2.26-2.69-5.06-2.69Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M598.96,436.31c-.39,0-.71-.17-.71-.38v12.82h1.43v-12.82c0,.21-.32,.38-.71,.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M598.24,434.07v1.87c0-.21,.32-.38,.71-.38s.71,.17,.71,.38v-1.87h-1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M598.96,435.55c-.39,0-.71,.17-.71,.38s.32,.38,.71,.38,.71-.17,.71-.38-.32-.38-.71-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M599.67,434.07c0,.21-.32,.38-.71,.38s-.71-.17-.71-.38,.32-.38,.71-.38,.71,.17,.71,.38Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M604.05,437.67c-.38-.09-.65-.33-.61-.53l-2.97,12.47,1.39,.33,2.97-12.47c-.05,.2-.4,.3-.78,.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M603.88,435.32l-.43,1.82c.05-.2,.4-.3,.78-.2,.38,.09,.65,.33,.61,.53l.43-1.82-1.39-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M604.23,436.93c-.38-.09-.73,0-.78,.2-.05,.2,.22,.44,.61,.53,.38,.09,.73,0,.78-.2,.05-.2-.22-.44-.61-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M605.26,435.65c-.05,.2-.4,.3-.78,.2-.38-.09-.65-.33-.61-.53,.05-.2,.4-.3,.78-.2,.38,.09,.65,.33,.61,.53Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M595.25,438.25c-.38,.12-.73,.05-.79-.15l3.85,12.23,1.36-.43-3.85-12.23c.06,.2-.19,.46-.57,.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M593.9,436.32l.56,1.78c-.06-.2,.19-.46,.57-.58,.38-.12,.73-.05,.79,.15l-.56-1.78-1.36,.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M595.02,437.53c-.38,.12-.63,.38-.57,.58,.06,.2,.42,.27,.79,.15,.38-.12,.63-.38,.57-.58-.06-.2-.42-.27-.79-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M595.26,435.89c.06,.2-.19,.46-.57,.58-.38,.12-.73,.05-.79-.15-.06-.2,.19-.46,.57-.58s.73-.05,.79,.15Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M599.84,444.81c-2.79,0-5.06-1.2-5.06-2.69v13.31h10.12v-13.31c0,1.49-2.26,2.69-5.06,2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M604.9,455.43c0,1.49-2.26,2.69-5.06,2.69s-5.06-1.2-5.06-2.69,2.26-2.69,5.06-2.69,5.06,1.2,5.06,2.69Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M567.16,422.36l-8.95,5.17c-.44,.26-1.22,.22-1.73-.07l-4.34-2.51c-.51-.3-.57-.74-.12-1l8.95-5.17c.44-.26,1.22-.22,1.73,.07l4.34,2.51c.51,.3,.57,.74,.12,1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 551.7,
    y: 423.47,
    width: 0.95,
    height: 0.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 564.92,
    y: 421,
    width: 2.53,
    height: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M567.16,421.4l-8.95,5.17c-.44,.26-1.22,.22-1.73-.07l-4.34-2.51c-.51-.3-.57-.74-.12-1l8.95-5.17c.44-.26,1.22-.22,1.73,.07l4.34,2.51c.51,.3,.57,.74,.12,1Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "552.8 423.33 557.3 426.05 565.27 421.45 560.76 418.73 552.8 423.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M564.33,419.62c0,.17-.25,.3-.57,.3s-.57-.14-.57-.3,.26-.3,.57-.3,.57,.14,.57,.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M584.81,392.66c-3.49,1.04-6.71,1.75-10.36,2.9-3.31,1.04-6.56,3.56-6.16,6.73,.69,5.49,14.61,1.32,16.55-.12,1.03-.76,5.2-2.99,5.2-2.99,0,0-.65-3.42-5.23-6.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M614.3,354.83c-6.74,.75-9.78,30.18-9.78,30.18,0,0-14.45,3.88-21.66,6.68,6.56,4.54,4.46,10.28,4.46,10.28,0,0,5.73-1.28,12.85-2.93,6.06-1.41,10.46-2.82,12.6-6.25s2.99-4.8,3.9-11.22c.97-6.86,6.61-16.92-2.37-26.74Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "575.6 300.24 575.6 289.61 565.37 283.44 565.37 305.8 584.94 317.57 584.94 305.88 575.6 300.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "584.94 305.88 586.28 305.09 586.28 316.78 584.94 317.57 584.94 305.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "575.6 289.6 576.95 288.81 576.95 299.45 575.6 300.24 575.6 289.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "576.95 299.45 575.6 300.24 584.94 305.88 586.28 305.09 576.95 299.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "566.72 282.65 565.37 283.44 575.6 289.61 576.95 288.82 566.72 282.65"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "566.67 284.22 566.67 295.23 557.84 288.81 566.67 284.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "561.79 277.31 580.72 288.71 580.72 318.95 561.79 307.42 561.79 277.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "560.08 279.03 579.01 290.43 579.01 320.67 560.08 309.14 560.08 279.03"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "567.01 305.25 567.01 294.61 556.77 288.44 556.77 310.8 576.34 322.58 576.34 310.89 567.01 305.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "576.34 310.89 586.03 305.23 586.03 316.92 576.34 322.58 576.34 310.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "567.01 294.61 568.36 293.82 568.36 304.45 567.01 305.24 567.01 294.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "568.36 304.45 567.01 305.24 576.34 310.89 577.69 310.1 568.36 304.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "558.12 287.65 556.77 288.44 567.01 294.62 568.36 293.83 558.12 287.65"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "556.77 288.44 560.08 286.52 560.08 288.02 558.03 289.2 556.77 288.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "575.75 309.58 584.46 304.57 585.76 305.39 576.95 310.53 575.75 309.58"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "559.58 309.44 559.58 298.8 549.35 292.63 549.35 314.99 568.91 326.77 568.91 315.07 559.58 309.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "568.91 315.07 570.26 314.28 570.26 325.98 568.91 326.77 568.91 315.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "559.58 298.8 560.93 298.01 560.93 308.64 559.58 309.43 559.58 298.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "560.93 308.64 559.58 309.43 568.91 315.07 570.26 314.28 560.93 308.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "550.7 291.84 549.35 292.63 559.58 298.8 560.93 298.02 550.7 291.84"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "550.65 293.41 550.65 304.42 541.82 298.01 550.65 293.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "545.77 286.51 564.7 297.91 564.7 328.15 545.77 316.62 545.77 286.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "544.05 288.22 562.99 299.63 562.99 329.87 544.05 318.33 544.05 288.22"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "550.99 314.44 550.99 303.81 540.75 297.64 540.75 320 560.32 331.78 560.32 320.08 550.99 314.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "560.32 320.08 570.01 314.42 570.01 326.12 560.32 331.78 560.32 320.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "550.99 303.81 552.33 303.02 552.33 313.65 550.99 314.44 550.99 303.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "552.33 313.65 550.99 314.44 560.32 320.08 561.67 319.29 552.33 313.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "542.1 296.85 540.75 297.64 550.99 303.81 552.33 303.02 542.1 296.85"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "540.75 297.64 544.05 295.71 544.05 297.21 542 298.4 540.75 297.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "559.73 318.78 568.44 313.77 569.73 314.59 560.93 319.73 559.73 318.78"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M533.22,327.2l17.24,9.93c.92,.53,.93,1.85,.02,2.4l-14.71,8.86c-2.01,1.21-4.51,1.23-6.53,.06l-15.51-8.97c-1.41-.81-1.42-2.84-.03-3.68l14.19-8.54c1.64-.99,3.68-1.01,5.34-.05Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 548.76,
    y: 336.15,
    width: 2.39,
    height: 1.92,
    transform: "translate(1099.91 674.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 512.65,
    y: 335.24,
    width: 4.26,
    height: 2.25,
    transform: "translate(1029.56 672.72) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M533.22,325.09l17.24,9.93c.92,.53,.93,1.85,.02,2.4l-14.71,8.86c-2.01,1.21-4.51,1.23-6.53,.06l-15.51-8.97c-1.41-.81-1.42-2.84-.03-3.68l14.19-8.54c1.64-.99,3.68-1.01,5.34-.05Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M543.99,333.29l4.12,2.37c.22,.13,.22,.44,0,.57l-3.52,2.12c-.48,.29-1.08,.29-1.56,.01l-3.71-2.14c-.34-.19-.34-.68,0-.88l3.39-2.04c.39-.24,.88-.24,1.28-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M531.56,326.07l4.12,2.37c.22,.13,.22,.44,0,.57l-3.52,2.12c-.48,.29-1.08,.29-1.56,.01l-3.71-2.14c-.34-.19-.34-.68,0-.88l3.39-2.04c.39-.24,.88-.24,1.28-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M548.27,335.85s-2.13-5.18-7.27-8.49c-5.14-3.31-10.42-1.4-10.42-1.4v2.67s3.76-.24,6.68,1.75c2.92,1.99,5,6.31,5,6.31l6.02-.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M544.53,338.05s-2.13-5.18-7.27-8.49c-5.14-3.31-10.42-1.4-10.42-1.4l.41,.23,4.92,2.75s1.96-1.44,4.37,.22c2.91,2,2.56,4.33,2.56,4.33l5.44,2.36Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "526.23 330.94 517.29 336.36 514.95 335.03 523.91 329.64 526.23 330.94"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "528.86 332.72 527.3 333.68 525.79 332.8 527.37 331.88 528.86 332.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "526.58 334.09 525.02 335.05 523.51 334.17 525.09 333.24 526.58 334.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "524.32 335.43 522.76 336.39 521.25 335.51 522.83 334.58 524.32 335.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "521.98 336.86 520.42 337.83 518.9 336.94 520.49 336.02 521.98 336.86"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "531.72 334.37 530.16 335.33 528.64 334.45 530.23 333.52 531.72 334.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "529.44 335.73 527.88 336.7 526.37 335.81 527.95 334.89 529.44 335.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "527.18 337.07 525.62 338.04 524.1 337.15 525.69 336.23 527.18 337.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "524.84 338.51 523.27 339.47 521.76 338.59 523.35 337.66 524.84 338.51"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "534.62 336.04 533.06 337 531.55 336.12 533.13 335.19 534.62 336.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "532.34 337.41 530.78 338.37 529.27 337.49 530.85 336.56 532.34 337.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "530.08 338.75 528.52 339.71 527.01 338.83 528.59 337.9 530.08 338.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "527.74 340.18 526.18 341.14 524.66 340.26 526.25 339.33 527.74 340.18"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "537.42 337.66 535.85 338.62 534.34 337.74 535.92 336.81 537.42 337.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "535.14 339.03 533.58 339.99 532.06 339.11 533.65 338.18 535.14 339.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "532.88 340.37 531.31 341.33 529.8 340.45 531.39 339.52 532.88 340.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "530.54 341.8 528.97 342.76 527.46 341.88 529.04 340.95 530.54 341.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "540.86 339.65 537.02 341.98 535.5 341.1 539.37 338.81 540.86 339.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "536.32 342.36 532.41 344.76 530.9 343.87 534.83 341.52 536.32 342.36"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M560.32,350.33h0c2.42,0,4.22-1.84,5.03-3.41,.78-1.51,.92-3.02,.41-4.47-1.01-2.89-4.56-5.62-11.17-8.59-3.22-1.45-6.45-3.88-9.31-6.02-4-3.01-7.46-5.6-10.11-5.05-1.02,.21-1.86,.89-2.49,2l1.06,.6c.45-.8,1-1.26,1.68-1.4,2.11-.43,5.52,2.12,9.13,4.84,2.9,2.18,6.2,4.66,9.54,6.16,6.2,2.79,9.64,5.36,10.52,7.88,.4,1.14,.29,2.29-.34,3.52-.65,1.27-2.08,2.75-3.95,2.75h0c-2.01,0-3.96-1.72-5.64-4.97-2.48-4.79-8.58-8.3-8.83-8.45l-.6,1.05c.06,.03,6.04,3.48,8.36,7.95,2.41,4.65,4.98,5.63,6.72,5.63Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-30",
    cx: 477.75,
    cy: 378.26,
    rx: 6.19,
    ry: 3.29
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "467.53 362.83 471.6 378.62 483.85 378.79 488.63 362.83 467.53 362.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M478.11,356.29c-5.91,0-10.7,2.55-10.7,5.69s4.79,5.69,10.7,5.69,10.7-2.55,10.7-5.69-4.79-5.69-10.7-5.69Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M487.63,361.68c0-2.59-4.29-4.68-9.58-4.68s-9.58,2.1-9.58,4.68c0,.56,.24,1.09,.61,1.59,.67-2.65,4.55-5.41,12.31-4.36,2.93,.4,5.43,2.43,5.27,4.81,.61-.62,.99-1.3,.99-2.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M481.38,358.91c-7.77-1.05-11.64,1.72-12.31,4.36,1.34,1.8,4.83,3.09,8.98,3.09,3.8,0,7.05-1.09,8.6-2.65,.16-2.38-2.33-4.41-5.27-4.81Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M452,330.79c.7-1.22,4.2-2.05,5.33-.78,1.14,1.27,2.01,3.53,4.9,3.53,2.89,0,4.84,1,5.26,3.56,.42,2.57-.85,3.01,1.84,3.4,2.69,.39,5.93,.83,5.79,3.71-.13,2.89-1.71,5.42-.92,6.47,.79,1.05,2.45,4.99,2.71,6.87s.44,4.28,.44,4.28c0,0-.74,1.27-1.58,.15-.26-1.36,.62-4.93-1.13-7.49-1.75-2.56-2.78-1.87-5.32-2.65-2.54-.78-5.35-2.2-6.23-3.69-.87-1.49,1.19-4.23-1.43-5.28-2.62-1.05-5.56,1.21-6.92-1.91-.89-2.04-.2-5.04,.09-6.28,.44-1.87,1.27-3.59-2.84-3.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M504.66,330.33c-.73-1.28-4.39-2.15-5.58-.82-1.19,1.33-2.11,3.69-5.13,3.7-3.02,0-5.07,1.04-5.51,3.73-.44,2.69,.89,3.15-1.93,3.56-2.82,.41-6.21,.87-6.07,3.89,.14,3.02,1.79,5.68,.96,6.77-.82,1.1-2.56,5.22-2.84,7.19s-.46,4.48-.46,4.48c0,0,.78,1.33,1.65,.16,.27-1.42-.65-5.16,1.18-7.84,1.83-2.68,2.91-1.96,5.57-2.78,2.66-.81,5.6-2.3,6.52-3.86s-1.25-4.43,1.5-5.53c2.75-1.1,5.82,1.26,7.24-2,.93-2.14,.21-5.28-.09-6.57-.46-1.96-1.33-3.76,2.97-4.07Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M474.38,363.1s-2.2-4.33-3.91-6.22c-1.72-1.88-3.6-4.66-6.69-3.74-2.58,.78-5.46,2.4-7.11,1.85s-3.64-2.26-5.56-2.52c-4.63-.62-5.28,3.42-5.28,3.42,0,0-1.58-3.79,1.24-7.53,1.49-1.98,5.6-3.49,8.07-2.51,2.47,.99,4.41,.77,4.95,.13,1.4-1.64,3.46-.65,4.01,.54,.55,1.19,1.91,1.59,3.33,.95,1.66-.76,3.11,.99,3.54,2.21,.43,1.22-.69,3.72-.48,4.65,.21,.93,4.03,6.22,4.98,8,.34,.72-.48,1.2-1.06,.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M468.92,350.18c-1.95-2.36-5.96-1.56-8.88-1.02-1.35,.25-3.91-.46-6.74-1.15-2.44-.59-4.41-.17-5.92,2.15,2.99-3.43,7.17-1.14,9.45-.53,4.05,1.07,10.1-2.51,12.61,2.1,.03-.57-.34-1.32-.53-1.55Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M482.82,364.01s.82-4.79,1.91-7.09c1.08-2.31,2.07-5.52,5.29-5.54,2.7-.02,5.92,.69,7.34-.32,1.41-1.01,2.81-3.23,4.58-4.05,4.25-1.96,6.06,1.71,6.06,1.71,0,0,.39-4.08-3.4-6.83-2.01-1.45-6.38-1.69-8.45-.02-2.07,1.67-3.98,2.04-4.69,1.59-1.82-1.16-3.5,.4-3.67,1.69-.18,1.29-1.36,2.08-2.9,1.88-1.8-.23-2.68,1.86-2.73,3.15s1.75,3.35,1.83,4.3-2.02,7.13-2.4,9.12c-.12,.79,.81,1.01,1.24,.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M484.23,350.05c1.17-2.82,5.24-3.24,8.18-3.59,1.37-.16,3.6-1.6,6.1-3.09,2.15-1.29,4.16-1.46,6.29,.31-3.87-2.4-7.18,1.02-9.19,2.28-3.55,2.22-10.39,.57-11.43,5.73-.2-.53-.06-1.36,.05-1.63Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M469.07,327.76s2.89-.5,5.63,1.09c2.75,1.59,2.93,4.79,3.16,7.16,.23,2.37,.87,2.29,2.7,3.87,1.83,1.58,3.71,5.53,1.78,7.37-1.92,1.84-4.44,4.68-2.47,6.95,1.17,1.34,1.09,4.18,.45,6.52-.43,1.58-1.5,3.38-2.47,4.06-.73,.52-1.33-.13-1.33-.13,0,0,2.7-2.87,2.11-5.26s-6.07-1.54-5.31-5.19c.76-3.64,.88-3.52-2.33-5.98-3.42-2.62-4.44-4.37-2.04-8.76,2.4-4.38,3.86-7.21,.11-11.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M472.09,329.38s2.65,2.6,2.15,6.08c-.5,3.48-2.2,6.22-.32,9.2,1.88,2.97,2.88,3.59,2.56,5.09-.32,1.5-1.64,3.25-.57,4.46,1.07,1.21,3.18,2.17,3.18,2.17,0,0-3.43-1.88-2.61-4.21s1.79-3.63,.87-5.32c-.92-1.69-4.49-2.65-3.71-5.39,.78-2.75,2.43-6.13,1.14-8.88-1.28-2.75-2.7-3.19-2.7-3.19Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "593.66 423.81 406.92 315.94 410.18 314.06 596.88 421.97 593.66 423.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "593.31 423.63 593.31 543.35 406.92 435.66 406.92 315.94 593.31 423.63"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M331.73,542.25c0,.82,1.25,1.49,2.79,1.49s2.79-.67,2.79-1.49-1.25-1.49-2.79-1.49-2.79,.67-2.79,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M331.73,539.06c0,.82,1.25,1.49,2.79,1.49s2.79-.67,2.79-1.49-1.25-1.49-2.79-1.49-2.79,.67-2.79,1.49Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 331.73,
    y: 539.06,
    width: 5.59,
    height: 3.19,
    transform: "translate(669.05 1081.32) rotate(180)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M366.83,521.99c0,.82,1.25,1.49,2.79,1.49s2.79-.67,2.79-1.49-1.25-1.49-2.79-1.49-2.79,.67-2.79,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M366.83,518.8c0,.82,1.25,1.49,2.79,1.49s2.79-.67,2.79-1.49-1.25-1.49-2.79-1.49-2.79,.67-2.79,1.49Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 366.83,
    y: 518.8,
    width: 5.59,
    height: 3.19,
    transform: "translate(739.25 1040.79) rotate(180)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M296.93,522.09c0,.82,1.25,1.49,2.79,1.49s2.79-.67,2.79-1.49-1.25-1.49-2.79-1.49-2.79,.67-2.79,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M296.93,518.91c0,.82,1.25,1.49,2.79,1.49s2.79-.67,2.79-1.49-1.25-1.49-2.79-1.49-2.79,.67-2.79,1.49Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 296.93,
    y: 518.91,
    width: 5.59,
    height: 3.19,
    transform: "translate(599.45 1041) rotate(180)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "371.98 470.77 371.98 520.96 337.07 541.11 334.52 486.5 371.98 470.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "334.52 542.58 294.73 519.56 294.73 470.77 334.52 493.75 334.52 542.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "334.52 542.58 337.07 541.11 337.07 492.47 334.52 493.95 334.52 542.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "371.64 521.16 374.19 519.69 374.19 471.06 371.64 472.53 371.64 521.16"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "334.52 495.03 374.19 472.09 374.19 469.5 334.52 492.47 334.52 495.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "294.74 469.5 334.52 492.47 334.52 495.03 294.74 472.05 294.74 469.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "334.52 446.43 374.19 469.5 334.52 492.47 294.74 469.5 334.52 446.43"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "371.64 505.57 371.64 506.14 337.07 526.1 337.07 525.48 371.64 505.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "371.64 489.46 371.64 490.03 337.07 509.98 337.07 509.36 371.64 489.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "350.47 521.91 361.01 515.83 361.01 517.61 350.47 523.73 350.47 521.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "350.47 505.8 361.01 499.72 361.01 501.5 350.47 507.61 350.47 505.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "350.47 489.69 361.01 483.61 361.01 485.39 350.47 491.5 350.47 489.69"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "444.02 477.12 417.71 462.15 417.71 395.73 444.02 410.66 444.02 477.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "444.02 477.12 447.13 475.32 447.13 408.86 444.02 410.66 444.02 477.12"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "317.83 550.4 269.02 522.38 269.3 456.14 317.83 483.94 317.83 550.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "317.83 550.4 320.94 548.6 320.94 482.14 317.83 483.94 317.83 550.4"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "270.86 523.44 267.75 521.65 267.75 455.19 270.86 456.98 270.86 523.44"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "326.09 467.13 426.45 409.18 426.45 425.76 326.09 483.71 326.09 467.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "326.09 483.71 326.09 467.13 285.47 444.46 285.47 460.1 326.09 483.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "317.73 492.68 457.8 411.44 457.8 408.12 317.73 489.36 317.73 492.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "317.73 489.36 259.64 455.81 259.64 459.13 317.73 492.68 317.73 489.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M457.8,408.12h0c-35.91-20.78-80.2-20.75-116.09,.07l-82.06,47.62,58.09,33.56,140.06-81.25Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "475.24 545.67 524.05 517.66 523.77 451.41 475.24 479.21 475.24 545.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "475.24 545.67 472.13 543.87 472.13 477.42 475.24 479.21 475.24 545.67"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "483.24 480.61 483.24 537.03 523.21 561.08 523.21 503.72 483.24 480.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "483.21 506.26 483.21 506.95 521.69 530.11 521.69 529.35 483.21 506.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "483.21 521.27 483.21 521.97 521.69 545.12 521.69 544.36 483.21 521.27"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "522.25 573.89 571.06 545.88 570.78 479.63 522.25 507.44 522.25 573.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "522.25 573.89 519.14 572.1 519.14 505.64 522.25 507.44 522.25 573.89"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "569.22 546.94 572.33 545.15 572.33 478.69 569.22 480.48 569.22 546.94"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "514 490.63 413.64 432.68 413.64 449.26 514 507.21 514 490.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "514 507.21 514 490.63 554.61 467.96 554.61 483.6 514 507.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "522.35 516.18 398.15 444.23 399.79 441.77 522.35 512.86 522.35 516.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "522.35 512.86 580.44 479.31 580.44 482.63 522.35 516.18 522.35 512.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "382.29 431.62 456.72 407.52 580.44 479.31 522.35 512.86 382.29 431.62"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "476.33 461.1 452.35 447.23 443.48 452.34 467.49 466.22 476.33 461.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "467.49 467.47 476.33 462.35 476.33 461.1 467.49 466.22 467.49 467.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "467.49 466.22 467.49 467.47 443.48 453.53 443.48 452.34 467.49 466.22"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "464.38 464.42 463.94 464.16 472.78 459.05 473.23 459.31 464.38 464.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "460.89 462.4 460.44 462.14 469.28 457.03 469.73 457.29 460.89 462.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "457.4 460.38 456.95 460.12 465.79 455.01 466.24 455.27 457.4 460.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "453.93 458.37 453.48 458.11 462.32 453 462.78 453.25 453.93 458.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "474.62 462.09 475.07 461.83 451.06 447.96 450.6 448.22 474.62 462.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "472.88 463.15 473.32 462.89 449.28 449 448.83 449.26 472.88 463.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "471.06 464.16 471.51 463.9 447.5 450.03 447.04 450.29 471.06 464.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "469.25 465.26 469.73 465.02 445.64 451.1 445.19 451.35 469.25 465.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "450.52 456.39 450.07 456.13 458.92 451.02 459.37 451.28 450.52 456.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "447.16 454.45 446.71 454.19 455.55 449.08 456 449.33 447.16 454.45"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M387.24,439.13l-15.89,9.17c-1.09,.63-3.02,.55-4.29-.18l-10.22-5.9c-1.26-.73-1.4-1.84-.31-2.48l15.89-9.17c1.09-.63,3.02-.55,4.29,.18l10.22,5.9c1.26,.73,1.4,1.84,.31,2.48Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 355.8,
    y: 439.95,
    width: 10.04,
    height: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 377.94,
    y: 437.15,
    width: 10.04,
    height: 0.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M387.24,438.11l-15.89,9.17c-1.09,.63-3.02,.55-4.29-.18l-10.22-5.9c-1.26-.73-1.4-1.84-.31-2.48l15.89-9.17c1.09-.63,3.02-.55,4.29,.18l10.22,5.9c1.26,.73,1.4,1.84,.31,2.48Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "374.11 430.11 357.49 439.74 369.43 446.58 386.09 436.98 374.11 430.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M381.18,432.96c0,.17-.25,.3-.57,.3s-.57-.14-.57-.3,.25-.3,.57-.3,.57,.14,.57,.3Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "474.82 473.21 479.83 476.08 488.12 470.53 487.88 469.93 482.95 467.09 474.82 473.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M474.82,473.21l8.92-5.15s-.47-1.16-1.42-1.15c-6.17,.08-7.5,6.31-7.5,6.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M479.81,476.08l8.92-5.15s-.47-1.14-1.42-1.15c-6.39-.1-7.5,6.31-7.5,6.31Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "388.03 392.04 369.22 402.94 382.73 410.68 401.59 399.82 388.03 392.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "378.74 398.81 371.89 402.81 382.73 409.01 389.63 405.04 378.74 398.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "381.47 397.25 380.43 397.87 391.28 404.07 392.36 403.48 381.47 397.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "383.7 395.95 382.67 396.57 393.51 402.78 394.59 402.18 383.7 395.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "382.73 410.68 382.73 414.86 401.59 404 401.59 399.82 382.73 410.68"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "369.22 402.94 369.22 403.91 381.95 411.21 381.95 413.59 369.22 406.28 369.22 407.11 382.73 414.86 382.73 410.68 369.22 402.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "381.95 411.21 369.22 403.91 369.22 406.28 381.95 413.59 381.95 411.21"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "388.03 386.79 369.22 397.69 382.73 405.44 401.59 394.57 388.03 386.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "383.01 390.9 376.16 394.9 387 401.1 393.9 397.13 383.01 390.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "385.75 389.34 384.71 389.96 395.55 396.16 396.64 395.57 385.75 389.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "387.98 388.04 386.94 388.66 397.78 394.86 398.87 394.27 387.98 388.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "382.73 405.44 382.73 409.61 401.59 398.75 401.59 394.57 382.73 405.44"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "369.22 397.69 369.22 398.66 381.95 405.97 381.95 408.34 369.22 401.04 369.22 401.87 382.73 409.61 382.73 405.44 369.22 397.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "381.95 405.97 369.22 398.66 369.22 401.04 381.95 408.34 381.95 405.97"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M424.59,433.06l13.19,7.61c1.03,.59,2.84,.52,4.02-.17l22.61-13.06c1.19-.68,1.32-1.73,.29-2.32l-13.19-7.61c-1.03-.59-2.84-.52-4.02,.17l-22.61,13.06c-1.19,.68-1.32,1.73-.29,2.32Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 464.09,
    y: 424.56,
    width: 1.31,
    height: 1.61,
    transform: "translate(929.48 850.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 423.9,
    y: 430.61,
    width: 1.31,
    height: 1.35,
    transform: "translate(849.12 862.57) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M424.59,431.59l13.19,7.61c1.03,.59,2.84,.52,4.02-.17l22.61-13.06c1.19-.68,1.32-1.73,.29-2.32l-13.19-7.61c-1.03-.59-2.84-.52-4.02,.17l-22.61,13.06c-1.19,.68-1.32,1.73-.29,2.32Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "461.2 424.65 448.98 417.56 427.27 430.6 439.48 437.68 461.2 424.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M461.54,421.83l-3.65,2.27-7.99-4.82,3.47-2.17s1.07,.65,1.76,.99c.69,.34,1.62-1.01,3.78,.13,2.46,1.3-.07,2.04,.73,2.49,.59,.33,1.9,1.1,1.9,1.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M468.24,444.89s7.36-4.03,9.37-5.44c1.45-1.02,1-1.89,.11-4.79-.89-2.9-2.84-8.22-2.84-8.22l1.8-.29s2.09,6.41,2.83,8.86,1.06,4.19-1.17,5.6c-3.04,1.92-10.1,6-10.1,6v-1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M475.11,441.83c1.64-1.01,3.46-1.62,4.02-3.8,.55-2.13-.59-4.33-1.38-6.28-1.09-2.69-1.16-5.26-2.44-7.86,5.94,.59,11.88,5.04,12.29,5.57,.45,.56,3.74,12.79,4.19,14.38,.45,1.59,0,2.54-2.75,4.18-2.74,1.64-8.13,4.16-8.13,4.16l-12.24-6.92c1.96-1.16,4.45-2.21,6.44-3.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M480.9,452.18s7.51-4.24,9.47-5.47c1.5-.94,.9-2,0-4.9-.89-2.9-2.84-8.22-2.84-8.22l1.8-.29s2.09,6.41,2.83,8.86c.74,2.45,1.25,4.36-.98,5.77-3.04,1.92-10.29,5.96-10.29,5.96v-1.71Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "480.9 452.18 480.9 453.89 468.24 446.6 468.24 444.89 480.9 452.18"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M507.44,410.42v32.81c0,2.45-2.65,3.99-4.78,2.76l-38.61-22.29c-.99-.57-1.59-1.62-1.59-2.76v-32.81c0-2.45,2.65-3.99,4.78-2.76l38.61,22.29c.99,.57,1.59,1.62,1.59,2.76Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "505.87 445.99 503.73 447.22 501.23 444.61 506.18 441.59 505.87 445.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "463.85 385.49 462 386.56 465.69 386.62 463.85 385.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M505.38,411.62v32.81c0,2.45-2.65,3.99-4.78,2.76l-38.61-22.29c-.99-.57-1.59-1.62-1.59-2.76v-32.81c0-2.45,2.65-3.99,4.78-2.76l38.61,22.29c.99,.57,1.59,1.62,1.59,2.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M477.66,432.31l3.33,1.9c.4,.23,.75,.1,.78-.28h0c.02-.38-.29-.89-.69-1.12l-3.33-1.9c-.4-.23-.75-.1-.78,.28h0c-.02,.38,.29,.89,.69,1.12Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "463.97 390.75 501.23 412.29 501.23 443.15 463.97 421.61 463.97 390.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "499.79 440.29 499.79 438.96 465.12 418.93 465.12 420.2 499.79 440.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "499.79 415.73 499.79 414.4 465.12 394.37 465.12 395.64 499.79 415.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M499.68,418.29v18.5l-34.44-19.96v-18.44l34.44,19.9Zm-4.83,14.95l4.19,2.42v-3.69l-4.19-2.43v3.69Zm0-4.44l4.19,2.42v-3.69l-4.19-2.43v3.69Zm0-4.44l4.19,2.42v-3.69l-4.19-2.43v3.69Zm0-4.44l4.19,2.42v-3.69l-4.19-2.43v3.69Zm-4.83,10.52l4.19,2.42v-3.69l-4.19-2.43v3.7Zm0-4.44l4.19,2.42v-3.69l-4.19-2.43v3.7Zm0-4.44l4.19,2.42v-3.69l-4.19-2.43v3.7Zm0-4.44l4.19,2.42v-3.69l-4.19-2.43v3.7Zm-4.83,10.52l4.19,2.42v-3.7l-4.19-2.43v3.71Zm0-4.44l4.19,2.42v-3.7l-4.19-2.43v3.71Zm0-4.44l4.19,2.42v-3.7l-4.19-2.43v3.71Zm0-4.44l4.19,2.42v-3.7l-4.19-2.43v3.71Zm-4.83,10.52l4.19,2.42v-3.71l-4.19-2.43v3.72Zm0-4.44l4.19,2.42v-3.71l-4.19-2.43v3.72Zm0-4.44l4.19,2.42v-3.71l-4.19-2.43v3.72Zm0-4.44l4.19,2.42v-3.71l-4.19-2.43v3.72Zm-4.83,10.52l4.19,2.42v-3.72l-4.19-2.43v3.73Zm0-4.44l4.19,2.42v-3.72l-4.19-2.43v3.73Zm0-4.44l4.19,2.42v-3.72l-4.19-2.43v3.73Zm0-4.44l4.19,2.42v-3.72l-4.19-2.43v3.73Zm-4.83,10.52l4.19,2.42v-3.73l-4.19-2.43v3.73Zm0-4.44l4.19,2.42v-3.73l-4.19-2.43v3.73Zm0-4.44l4.19,2.42v-3.73l-4.19-2.43v3.73Zm0-4.44l4.19,2.42v-3.73l-4.19-2.43v3.73Zm-4.83,10.52l4.19,2.42v-3.74l-4.19-2.43v3.74Zm0-4.44l4.19,2.42v-3.74l-4.19-2.43v3.74Zm0-4.44l4.19,2.42v-3.74l-4.19-2.43v3.74Zm0-4.44l4.19,2.42v-3.74l-4.19-2.43v3.74Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "498.28 419.12 498.28 421.19 495.48 419.57 495.48 417.49 498.28 419.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "493.39 420.72 493.39 422.79 490.59 421.17 490.59 419.09 493.39 420.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "488.64 422.36 488.64 424.43 485.84 422.81 485.84 420.73 488.64 422.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "483.86 424 483.86 426.08 481.06 424.45 481.06 422.38 483.86 424"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "483.86 410.78 483.86 412.85 481.06 411.23 481.06 409.15 483.86 410.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "478.96 412.38 478.96 414.45 476.16 412.83 476.16 410.75 478.96 412.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "474.21 414.02 474.21 416.09 471.41 414.47 471.41 412.39 474.21 414.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "469.43 415.66 469.43 417.74 466.63 416.11 466.63 414.04 469.43 415.66"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "508.3 525.37 495.45 517.65 495.45 519.82 508.3 527.59 508.3 525.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "508.3 509.96 495.45 502.25 495.45 504.42 508.3 512.18 508.3 509.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "508.3 539.95 495.45 532.23 495.45 534.4 508.3 542.17 508.3 539.95"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M297.2,446.17l17.24,9.93c.92,.53,.93,1.85,.02,2.4l-14.71,8.86c-2,1.21-4.51,1.23-6.53,.06l-15.51-8.97c-1.41-.81-1.42-2.84-.03-3.68l14.19-8.54c1.64-.99,3.68-1.01,5.34-.05Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 312.74,
    y: 455.12,
    width: 2.39,
    height: 1.92,
    transform: "translate(627.88 912.16) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 276.64,
    y: 454.21,
    width: 4.26,
    height: 2.25,
    transform: "translate(557.53 910.67) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M297.2,444.06l17.24,9.93c.92,.53,.93,1.85,.02,2.4l-14.71,8.86c-2,1.21-4.51,1.23-6.53,.06l-15.51-8.97c-1.41-.81-1.42-2.84-.03-3.68l14.19-8.54c1.64-.99,3.68-1.01,5.34-.05Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M307.97,452.26l4.12,2.37c.22,.13,.22,.44,0,.57l-3.52,2.12c-.48,.29-1.08,.29-1.56,.01l-3.71-2.14c-.34-.19-.34-.68,0-.88l3.39-2.04c.39-.24,.88-.24,1.28-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M295.55,445.05l4.12,2.37c.22,.13,.22,.44,0,.57l-3.52,2.12c-.48,.29-1.08,.29-1.56,.01l-3.71-2.14c-.34-.19-.34-.68,0-.88l3.39-2.04c.39-.24,.88-.24,1.28-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M312.26,454.82s-2.13-5.18-7.27-8.49c-5.14-3.31-10.42-1.4-10.42-1.4v2.67s3.76-.24,6.68,1.75c2.92,1.99,5,6.31,5,6.31l6.02-.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M308.51,457.02s-2.13-5.18-7.27-8.49c-5.14-3.31-10.42-1.4-10.42-1.4l.41,.23,4.92,2.75s1.96-1.44,4.37,.22c2.91,2,2.56,4.33,2.56,4.33l5.44,2.36Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "290.21 449.91 281.27 455.33 278.94 454 287.89 448.61 290.21 449.91"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "292.85 451.7 291.28 452.66 289.77 451.78 291.35 450.85 292.85 451.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "290.57 453.07 289.01 454.03 287.49 453.15 289.08 452.22 290.57 453.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "288.31 454.41 286.74 455.37 285.23 454.49 286.81 453.56 288.31 454.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "285.97 455.84 284.4 456.8 282.89 455.92 284.47 454.99 285.97 455.84"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "295.71 453.34 294.14 454.3 292.63 453.42 294.21 452.49 295.71 453.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "293.43 454.71 291.86 455.67 290.35 454.79 291.93 453.86 293.43 454.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "291.17 456.05 289.6 457.01 288.09 456.13 289.67 455.2 291.17 456.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "288.83 457.48 287.26 458.44 285.75 457.56 287.33 456.63 288.83 457.48"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "298.61 455.01 297.04 455.98 295.53 455.09 297.11 454.17 298.61 455.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "296.33 456.38 294.77 457.34 293.25 456.46 294.84 455.53 296.33 456.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "294.07 457.72 292.5 458.69 290.99 457.8 292.57 456.88 294.07 457.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "291.73 459.15 290.16 460.12 288.65 459.23 290.23 458.31 291.73 459.15"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "301.41 456.63 299.84 457.59 298.33 456.71 299.91 455.78 301.41 456.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "299.13 458 297.56 458.96 296.05 458.08 297.63 457.15 299.13 458"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "296.87 459.34 295.3 460.3 293.79 459.42 295.37 458.49 296.87 459.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "294.53 460.77 292.96 461.73 291.45 460.85 293.03 459.92 294.53 460.77"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "304.85 458.63 301 460.96 299.49 460.08 303.35 457.78 304.85 458.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "300.31 461.34 296.4 463.73 294.89 462.85 298.81 460.49 300.31 461.34"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M324.31,469.31h0c2.42,0,4.22-1.84,5.03-3.41,.78-1.51,.92-3.02,.41-4.47-1.01-2.89-4.56-5.62-11.17-8.59-3.22-1.45-6.45-3.88-9.31-6.02-4-3.01-7.46-5.6-10.11-5.05-1.02,.21-1.86,.89-2.49,2l1.06,.6c.45-.8,1-1.26,1.68-1.4,2.11-.43,5.52,2.12,9.13,4.84,2.9,2.18,6.2,4.66,9.54,6.16,6.2,2.79,9.64,5.36,10.52,7.88,.4,1.14,.29,2.29-.34,3.52-.65,1.27-2.08,2.75-3.95,2.75h0c-2.01,0-3.95-1.72-5.64-4.97-2.48-4.79-8.58-8.3-8.83-8.45l-.6,1.05c.06,.03,6.04,3.48,8.36,7.95,2.41,4.65,4.98,5.63,6.72,5.63Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 513.72,
    cy: 455.93,
    rx: 5.06,
    ry: 2.69
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M512.84,450.13c-.39,0-.71-.17-.71-.38v12.82h1.43v-12.82c0,.21-.32,.38-.71,.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M512.12,447.88v1.87c0-.21,.32-.38,.71-.38s.71,.17,.71,.38v-1.87h-1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M512.84,449.37c-.39,0-.71,.17-.71,.38s.32,.38,.71,.38,.71-.17,.71-.38-.32-.38-.71-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M513.55,447.88c0,.21-.32,.38-.71,.38s-.71-.17-.71-.38,.32-.38,.71-.38,.71,.17,.71,.38Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M517.93,451.48c-.38-.09-.65-.33-.61-.53l-2.97,12.47,1.39,.33,2.97-12.47c-.05,.2-.4,.3-.78,.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M517.76,449.13l-.43,1.82c.05-.2,.4-.3,.78-.2,.38,.09,.65,.33,.61,.53l.43-1.82-1.39-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M518.11,450.74c-.38-.09-.73,0-.78,.2-.05,.2,.22,.44,.61,.53,.38,.09,.73,0,.78-.2,.05-.2-.22-.44-.61-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M519.14,449.46c-.05,.2-.4,.3-.78,.2-.38-.09-.65-.33-.61-.53,.05-.2,.4-.3,.78-.2s.65,.33,.61,.53Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M509.13,452.06c-.38,.12-.73,.05-.79-.15l3.85,12.23,1.36-.43-3.85-12.23c.06,.2-.19,.46-.57,.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M507.78,450.14l.56,1.78c-.06-.2,.19-.46,.57-.58,.38-.12,.73-.05,.79,.15l-.56-1.78-1.36,.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M508.9,451.34c-.38,.12-.63,.38-.57,.58,.06,.2,.42,.27,.79,.15,.38-.12,.63-.38,.57-.58-.06-.2-.42-.27-.79-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M509.14,449.71c.06,.2-.19,.46-.57,.58-.38,.12-.73,.05-.79-.15-.06-.2,.19-.46,.57-.58,.38-.12,.73-.05,.79,.15Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M513.72,458.62c-2.79,0-5.06-1.2-5.06-2.69v13.31h10.12v-13.31c0,1.49-2.26,2.69-5.06,2.69Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 513.72,
    cy: 469.24,
    rx: 5.06,
    ry: 2.69
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "533.48 480.95 516.48 490.59 533.32 500.33 550.32 490.66 533.48 480.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "541.6 469.94 524.59 479.58 541.44 489.32 558.43 479.66 541.6 469.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "463.32 423.26 463.32 432.88 471.67 437.96 471.67 428.2 463.32 423.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "488.63 438.25 488.63 447.87 496.98 452.96 496.98 443.19 488.63 438.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "503.27 418.74 503.27 428.37 511.61 433.45 511.61 423.69 503.27 418.74"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "436.27 412.92 427.74 408 437.59 402.32 446.12 407.24 436.27 412.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "446.12 407.24 446.12 412.1 436.27 417.79 436.27 412.92 446.12 407.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "427.74 408 427.74 412.86 436.27 417.79 436.27 412.92 427.74 408"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "431.84 412.66 436.27 415.05 436.27 414.46 431.84 412.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "436.27 416.62 436.27 416.03 431.02 413.44 436.27 416.62"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M427.74,408.82l5.32,3.25-5.32-2.87v-.38Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "539.53 462.74 514.58 477.2 531.42 486.94 556.36 472.45 539.53 462.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "529.53 470.82 522.65 474.8 535.82 482.35 542.72 478.37 529.53 470.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "531.42 469.73 530.87 470.05 544.06 477.59 544.61 477.28 531.42 469.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "532.65 469.02 532.1 469.34 545.29 476.89 545.83 476.57 532.65 469.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "533.95 468.27 533.4 468.59 546.58 476.14 547.13 475.82 533.95 468.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "535.19 467.56 534.64 467.87 547.83 475.41 548.38 475.1 535.19 467.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "536.42 466.84 535.87 467.16 549.06 474.71 549.6 474.39 536.42 466.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "537.72 466.1 537.17 466.41 550.36 473.97 550.9 473.65 537.72 466.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "521.25 475.61 520.71 475.92 533.89 483.47 534.44 483.15 521.25 475.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "540.37 464.54 538.45 465.65 551.63 473.2 553.56 472.09 540.37 464.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "514.58 477.2 514.58 478.42 531.42 488.16 531.42 486.94 514.58 477.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "556.34 472.46 531.42 486.94 531.42 488.16 556.34 473.68 556.34 472.46"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "367.13 404.78 367.13 394.15 356.9 387.97 356.9 410.34 376.46 422.11 376.46 410.42 367.13 404.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "376.46 410.42 377.81 409.63 377.81 421.32 376.46 422.11 376.46 410.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "367.13 394.14 368.48 393.35 368.48 403.99 367.13 404.78 367.13 394.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "368.48 403.99 367.13 404.78 376.46 410.42 377.81 409.63 368.48 403.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "358.24 387.19 356.9 387.97 367.13 394.15 368.48 393.36 358.24 387.19"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "358.19 388.76 358.19 399.77 349.36 393.35 358.19 388.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "353.32 381.85 372.25 393.25 372.25 423.49 353.32 411.96 353.32 381.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "351.6 383.57 370.53 394.97 370.53 425.21 351.6 413.68 351.6 383.57"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "358.54 409.79 358.54 399.15 348.3 392.98 348.3 415.34 367.87 427.12 367.87 415.43 358.54 409.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "367.87 415.43 377.56 409.77 377.56 421.46 367.87 427.12 367.87 415.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "358.53 399.15 359.88 398.36 359.88 408.99 358.53 409.78 358.53 399.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "359.88 408.99 358.53 409.78 367.87 415.43 369.22 414.64 359.88 408.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "349.65 392.19 348.3 392.98 358.53 399.16 359.88 398.37 349.65 392.19"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "348.3 392.98 351.6 391.06 351.6 392.56 349.55 393.74 348.3 392.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "367.27 414.12 375.99 409.11 377.28 409.93 368.48 415.07 367.27 414.12"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "352.86 405.4 359.96 401.43 359.96 431.58 352.86 435.69 352.86 405.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "355.02 410.42 357.8 408.87 357.8 425.03 355.02 426.64 355.02 410.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "352.86 406.97 359.96 403.01 359.96 405.18 352.86 409.19 352.86 406.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M355.02,430.36c0,1.02,.62,1.49,1.39,1.05,.77-.44,1.39-1.63,1.39-2.65s-.62-1.49-1.39-1.05c-.77,.44-1.39,1.63-1.39,2.65Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "352.86 405.4 352.86 435.69 330.22 422.65 330.22 392.33 352.86 405.4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "331.28 391.72 353.02 404.28 358 401.4 336.42 388.79 337.12 388.39 359.96 401.43 352.86 405.4 330.22 392.33 331.28 391.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "353.02 404.28 331.28 391.72 336.42 388.79 358 401.4 353.02 404.28"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "342.58 411.49 349.68 407.52 349.68 437.67 342.58 441.77 342.58 411.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "344.74 416.51 347.52 414.96 347.52 431.12 344.74 432.72 344.74 416.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "342.58 413.06 349.68 409.1 349.68 411.27 342.58 415.28 342.58 413.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M344.74,436.45c0,1.02,.62,1.49,1.39,1.05,.77-.44,1.39-1.63,1.39-2.65s-.62-1.49-1.39-1.05c-.77,.44-1.39,1.63-1.39,2.65Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "342.58 411.49 342.58 441.77 319.94 428.74 319.94 398.42 342.58 411.49"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "321 397.81 342.74 410.37 347.72 407.49 326.14 394.88 326.84 394.48 349.68 407.52 342.58 411.49 319.94 398.42 321 397.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "342.74 410.37 321 397.81 326.14 394.88 347.72 407.49 342.74 410.37"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "328.87 426.89 328.87 416.26 318.64 410.08 318.64 432.45 338.21 444.22 338.21 432.53 328.87 426.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "338.21 432.53 339.56 431.74 339.56 443.43 338.21 444.22 338.21 432.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "328.87 416.25 330.22 415.46 330.22 426.1 328.87 426.89 328.87 416.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "330.22 426.1 328.87 426.89 338.21 432.53 339.56 431.74 330.22 426.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "319.99 409.3 318.64 410.08 328.87 416.26 330.22 415.47 319.99 409.3"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "319.94 410.87 319.94 421.88 311.11 415.46 319.94 410.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "315.06 403.96 333.99 415.36 333.99 445.6 315.06 434.07 315.06 403.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "313.35 405.68 332.28 417.08 332.28 447.32 313.35 435.79 313.35 405.68"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "320.28 431.9 320.28 421.26 310.05 415.09 310.05 437.45 329.61 449.23 329.61 437.54 320.28 431.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "329.61 437.54 339.3 431.88 339.3 443.57 329.61 449.23 329.61 437.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "320.28 421.26 321.63 420.47 321.63 431.1 320.28 431.89 320.28 421.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "321.63 431.1 320.28 431.89 329.61 437.54 330.96 436.75 321.63 431.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "311.39 414.3 310.05 415.09 320.28 421.27 321.63 420.48 311.39 414.3"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "310.05 415.09 313.35 413.17 313.35 414.67 311.3 415.85 310.05 415.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "329.02 436.23 337.73 431.22 339.03 432.04 330.22 437.18 329.02 436.23"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "537.04 489.21 514.73 502.08 490.95 488.26 513.21 475.44 537.04 489.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "534.92 488.67 514.66 500.36 493.07 487.81 513.28 476.17 534.92 488.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "537.04 488.01 514.73 496.57 490.95 482.75 513.21 474.24 537.04 488.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "514.73 496.57 514.73 502.08 490.95 488.26 490.95 482.75 514.73 496.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "495.2 486.81 512.64 496.98 512.64 499.28 495.2 489.1 495.2 486.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "492.15 483.45 493.52 484.25 493.52 489.76 492.15 488.96 492.15 483.45"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M436.51,516.77c2.77-1.39,5.41-3.08,4.56-4.66-.38-.71-1.26-1.03-2.12-1.17-2.56,.84-3.83,1.41-3.83,1.41,0,0,.27-14.84,1.36-20.99,.36-2.03-9.33-2.1-9.33-2.1-.35,1.42-.65,13.89,0,21.49,.22,2.55,.08,4.21-.11,5.44,.66,.29,2.02,.88,3.04,1.34,1.39,.63,3.65,.63,6.43-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M426.93,520.22c.93,2.21,3.06,2,7.38,.45,3.83-1.38,6.99-2.94,9.72-4.96,2.73-2.02,2.75-2.28,3.11-3.65,.5-1.91-2.28-2.98-6.92-1.54-.46,.14-.88,.28-1.27,.41,.85,.14,1.74,.46,2.12,1.17,.84,1.58-1.79,3.28-4.56,4.66-2.77,1.39-5.04,1.39-6.43,.76-1.01-.46-2.38-1.05-3.04-1.34-.28,1.85-.67,2.71-.11,4.04Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M417.66,534.39h0c-1.83,0-3.33-1.5-3.33-3.33v-30.7c0-1.83,1.5-3.33,3.33-3.33h0c1.83,0,3.33,1.5,3.33,3.33v30.7c0,1.83-1.5,3.33-3.33,3.33Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 417.66,
    cy: 501.84,
    rx: 21.05,
    ry: 11.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 396.62,
    y: 499.73,
    width: 42.09,
    height: 2.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M438.71,499.73c0,6.18-9.42,11.2-21.05,11.2s-21.05-5.01-21.05-11.2,9.42-11.19,21.05-11.19,21.05,5.01,21.05,11.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M437.71,498.51c0,5.89-8.98,10.67-20.05,10.67s-20.05-4.78-20.05-10.67,8.98-10.67,20.05-10.67,20.05,4.78,20.05,10.67Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "398.67 491.66 397.61 498.51 437.71 498.51 436.65 491.66 398.67 491.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M436.93,493.35c0,5.66-8.63,10.25-19.26,10.25s-19.27-4.59-19.27-10.25,8.63-10.25,19.27-10.25,19.26,4.59,19.26,10.25Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M397.93,550.22c0,2.06-1.25,4.46-2.8,5.35-1.55,.89-2.8-.05-2.8-2.12s1.25-4.46,2.8-5.35c1.55-.89,2.8,.06,2.8,2.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "398.99 549.16 396.83 547.89 393.31 555.72 395.56 557.02 398.99 549.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M400.2,551.53c0,2.06-1.25,4.46-2.8,5.35-1.55,.89-2.8-.05-2.8-2.12s1.25-4.46,2.8-5.35,2.8,.05,2.8,2.12Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M393.51,548.95h0c-.64-1.12-.26-2.54,.85-3.19l44.26-25.55c1.12-.64,2.54-.26,3.19,.85h0c.64,1.12,.26,2.54-.85,3.19l-44.26,25.55c-1.12,.64-2.54,.26-3.19-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M438.63,549.8l-44.26-25.55c-1.12-.64-1.5-2.07-.85-3.19h0c.64-1.12,2.07-1.5,3.19-.85l44.26,25.55c1.12,.64,1.5,2.07,.85,3.19h0c-.64,1.12-2.07,1.5-3.19,.85Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M441.33,524.65c0,2.06-1.25,4.46-2.8,5.35-1.55,.89-2.8-.05-2.8-2.12s1.25-4.46,2.8-5.35c1.55-.89,2.8,.06,2.8,2.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "442.39 523.59 440.23 522.32 436.7 530.16 438.95 531.45 442.39 523.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M443.59,525.96c0,2.06-1.25,4.46-2.8,5.35-1.55,.89-2.8-.06-2.8-2.12s1.25-4.46,2.8-5.35c1.55-.89,2.8,.05,2.8,2.12Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M438.6,550.87c0,2.06-1.25,4.46-2.8,5.35-1.55,.89-2.8-.05-2.8-2.12s1.25-4.46,2.8-5.35c1.55-.89,2.8,.06,2.8,2.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "439.66 549.81 437.5 548.54 433.97 556.38 436.22 557.67 439.66 549.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M440.86,552.18c0,2.06-1.25,4.46-2.8,5.35-1.55,.89-2.8-.06-2.8-2.12s1.25-4.46,2.8-5.35,2.8,.05,2.8,2.12Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M396.16,526.11c0,2.06-1.25,4.46-2.8,5.35-1.55,.89-2.8-.06-2.8-2.12s1.25-4.46,2.8-5.35c1.55-.89,2.8,.05,2.8,2.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "397.22 525.05 395.06 523.78 391.54 531.61 393.79 532.91 397.22 525.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M398.43,527.42c0,2.06-1.25,4.46-2.8,5.35-1.55,.89-2.8-.05-2.8-2.12s1.25-4.46,2.8-5.35,2.8,.05,2.8,2.12Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M454.27,526.69c2.77-1.39,5.41-3.08,4.56-4.66-.38-.71-1.26-1.03-2.12-1.17-2.56,.84-3.83,1.41-3.83,1.41,0,0,1.37-23.98,2.47-30.13,.36-2.03-10.03,1.72-10.03,1.72-.35,1.42-1.06,19.22-.41,26.81,.22,2.55,.08,4.21-.11,5.44,.66,.29,2.02,.88,3.04,1.34,1.39,.63,3.65,.63,6.43-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M444.69,530.14c.93,2.21,3.06,2,7.38,.45,3.83-1.38,6.99-2.94,9.72-4.96,2.73-2.02,2.75-2.28,3.11-3.65,.5-1.91-2.28-2.98-6.92-1.54-.46,.14-.88,.28-1.27,.41,.85,.14,1.74,.46,2.12,1.17,.84,1.58-1.79,3.28-4.56,4.66-2.77,1.39-5.04,1.39-6.43,.76-1.01-.46-2.38-1.05-3.04-1.34-.28,1.85-.67,2.71-.11,4.04Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M416.86,407.61c1.05,.73,4.91,1.63,6.04,10.23,.76,5.78-1.16,8.36-2.8,9.86-.68,.63-3.36,.74-3.36,.74l.12,6.44s-3.78,1.49-7.4,0l-3.62-1.49s1.41-2.44,1.18-6.66c-.29-5.24-2.15-12.69-.84-15.47,2.37-5.01,7.84-5.62,10.68-3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M405.71,498.51c2.93,1.62,7.81,3.85,17.94,1.21,12.17-3.17,16.33,1.22,16.33,1.22,0,0,10.74,3.1,14.39-.1,3.64-3.19,3.18-12.26,3.18-12.26,0,0-1.17-9.84-13.15-13.03-6.64-1.77-23.42-6.64-23.42-6.64,0,0-20.03,5.54-22,11.42-3.59,10.7,1.45,15.25,6.72,18.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M397.92,480.65c1.81,5.05,9.87,6.95,14.56,6.87,6.25-.1,13.41-3.36,15.52-9.31-.65-2.37-1.37-4.71-2.23-6.93-.61-1.57-3.5-8.13,.86-17.46,2.14-4.56-2.71-12.84-4.07-15.82-1.36-2.98-5.71-4.79-5.71-4.79l-11.01,.17s-3.9,6.9-4.67,12.9c-.77,5.99-1.13,8.53-.18,16.12,.26,2.11,1.02,7.1-2.54,16.23-.19,.5-.37,1.19-.52,2.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M404.82,432.69s.56,1.81,4.24,2.98c3.68,1.17,7.01,.95,10.63-.84,.02-2.38-2.89-3.45-2.89-3.45,0,0-3.31,1.33-7.02,0l-3.72-1.33-1.23,2.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M410.26,404.86c-4.91,1.04-10.08,4.14-8.25,14.59,.79,2.69,2.17,4.99,4.12,6.99,.97,.99,2.11,2.06,2.36,3.46,.48-.18,.96-.39,1.42-.66,.12-.22,.24-.4,.39-.5,4.7-3.36,5.86-5.52,8.02-7.78,2.16-2.26,4.58-3.14,4.86-6.09,.57-6.07-3.7-11.96-12.91-10.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M421.55,438.01c-2.13-.2-4.35,3.67-4.13,8.52,.28,6.2,13.4,20.72,13.4,20.72,4.35,2.57,17.23-5.4,20.37-5.77,3.15-.37,7.16-3.09,8.82-5.18,1.58-1.97-4.47-4.69-7.45-2.78-2.25,1.44-1.67,3.25-3.47,3.52-8.05,1.19-15.41,3.38-15.41,3.38,0,0-8.05-22.03-12.13-22.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M421.68,436.98c-2.74-.37-4.87,1.32-5.43,5.87-.45,3.62,2.07,6.94,2.07,6.94,0,0,.55-5.89,2.33-7.72,2.42-2.47,4.1-1.02,4.1-1.02,0,0,1.57-3.43-3.08-4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M420.64,419.11s-2.26-3.87-3.23,0c-.9,3.6,2.23,4.81,2.23,4.81l1-4.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M401.76,413.55s-1.56,10.56-2.25,14.09c-.69,3.53-.36,9.47,.24,12.7,.6,3.22,3.65,5.85,2.9,8.16-.75,2.31-3.82,1.28-3.82,1.28,0,0,1.46,2.18,3.48,2.18,1.57,0,3.41-1.89,3.41-1.89,0,0-1.61,4.81,.41,6.68,1.96,1.81,3.95-.46,3.95-.46,0,0-3.14,.02-2.69-1.64,.45-1.66,2.51-.21,3.44-2.69,.38-1-1.05-3.23-1.05-3.23,0,0,2.13,1.46,3.76,1.06,1.27-.31,2.19-2.47,2.19-2.47,0,0-2.53,1.8-3.47,.34-1.12-1.72,1.71-2.27,2.14-2.52,.85-.5,2.17-.46,2.85-4.1,.55-2.97,.29-19.21,.29-19.21l-15.77-8.28Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M409.06,496.37v-24.09c0-8.44-5.18-18.33-11.5-21.98l-6-3.47c-6.33-3.65-11.5,.26-11.5,8.7v24.09l29.01,16.75Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "383.91 446.33 378.99 449.25 383.39 452.17 383.91 446.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "404.27 499.22 409.06 496.37 403.39 490.8 404.27 499.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M404.27,499.22v-24.09c0-8.44-5.18-18.33-11.5-21.98l-6-3.47c-6.33-3.65-11.5,.26-11.5,8.7v24.09l29.01,16.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M386.16,473.06c0,5.1-.51,16.06-.43,18.6,.17,5.51-2.4,22.11,19.56,22.73,2.2,.06,10.79-.32,12.37-1.36-3.61-.17-11.16-1.65-15.76-3.63-14.26-1.31-12.16-12.33-11.97-19.13,.22-7.94,.03-14.41,0-17.07-.03-3.43-3.77-3.59-3.77-.15Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "537.76 407.81 537.76 433.75 518.36 422.59 518.36 396.61 537.76 407.81"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "519.88 399.96 536.28 409.44 536.28 410.58 519.88 401.08 519.88 399.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "519.88 402.92 536.28 412.4 536.28 413.54 519.88 404.04 519.88 402.92"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "519.88 406.32 536.28 415.79 536.28 416.93 519.88 407.43 519.88 406.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "519.88 409.28 536.28 418.75 536.28 419.89 519.88 410.39 519.88 409.28"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "519.88 412.43 536.28 421.9 536.28 423.04 519.88 413.54 519.88 412.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "519.88 415.39 536.28 424.86 536.28 426 519.88 416.5 519.88 415.39"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "566.73 442.73 566.73 453.79 547.33 442.63 547.33 431.54 566.73 442.73"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "548.85 434.89 565.25 444.36 565.25 445.5 548.85 436 548.85 434.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "548.85 437.85 565.25 447.32 565.25 448.46 548.85 438.96 548.85 437.85"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "545.66 412.58 545.66 422.2 554.01 427.28 554.01 417.52 545.66 412.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "520.55 420.54 520.55 430.17 528.9 435.25 528.9 425.49 520.55 420.54"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "440.15 515.43 756.53 333.21 753.27 331.33 436.93 513.59 440.15 515.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "440.15 515.43 440.15 635.15 756.53 452.93 756.53 333.21 440.15 515.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "436.93 513.59 436.93 633.46 440.15 635.3 440.15 515.43 436.93 513.59"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "804.63 505.53 758.02 478.42 758.02 411.96 804.63 439.07 804.63 505.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "804.63 505.53 807.74 503.74 807.74 437.28 804.63 439.07 804.63 505.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "760.11 479.58 757 477.79 757 411.33 760.11 413.13 760.11 479.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "678.35 521.1 818.41 439.86 818.41 436.54 678.35 517.78 678.35 521.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "818.41 436.54 760.34 402.94 678.19 450.61 736.21 484.22 818.41 436.54"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M815.79,490.71s-.41,16.43-.41,20.12,.51,11.42-5.99,14.16c-6.5,2.74-15.71,6.34-15.71,6.34l8.72,5.61s8.79-3.83,13.31-6.61c6.36-3.92,5.69-14.63,5.69-21.43s-1.16-15.68-1.16-15.68l-4.46-2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M793.68,567.05h0c-1.91,0-3.48-1.57-3.48-3.48v-32.12c0-1.91,1.57-3.48,3.48-3.48h0c1.91,0,3.48,1.57,3.48,3.48v32.12c0,1.91-1.57,3.48-3.48,3.48Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M815.7,532.99c0,6.47-9.86,11.71-22.02,11.71s-22.02-5.24-22.02-11.71,9.86-11.71,22.02-11.71,22.02,5.24,22.02,11.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 771.66,
    y: 530.78,
    width: 44.04,
    height: 2.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M815.7,530.78c0,6.47-9.86,11.71-22.02,11.71s-22.02-5.24-22.02-11.71,9.86-11.71,22.02-11.71,22.02,5.24,22.02,11.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M814.66,529.51c0,6.16-9.39,11.16-20.98,11.16s-20.98-5-20.98-11.16,9.39-11.16,20.98-11.16,20.98,5,20.98,11.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "773.82 522.34 772.7 529.51 814.66 529.51 813.55 522.34 773.82 522.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M813.84,524.12c0,5.92-9.02,10.72-20.16,10.72s-20.16-4.8-20.16-10.72,9.02-10.72,20.16-10.72,20.16,4.8,20.16,10.72Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M836.27,516.88v-24.09c0-8.44-5.18-18.33-11.5-21.98l-6-3.47c-6.33-3.65-11.5,.26-11.5,8.7v24.09l29.01,16.75Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "811.12 466.83 806.21 469.75 810.6 472.67 811.12 466.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "831.48 519.72 836.27 516.88 830.61 511.3 831.48 519.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M831.48,519.72v-24.09c0-8.44-5.18-18.33-11.5-21.98l-6-3.47c-6.33-3.65-11.5,.26-11.5,8.7v24.09l29.01,16.75Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M773.04,583.62c0,2.16-1.31,4.67-2.93,5.6-1.62,.93-2.93-.06-2.93-2.22s1.31-4.67,2.93-5.6c1.62-.93,2.93,.06,2.93,2.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "774.15 582.5 771.89 581.18 768.2 589.38 770.55 590.73 774.15 582.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M775.41,584.98c0,2.16-1.31,4.67-2.93,5.6-1.62,.93-2.93-.06-2.93-2.22s1.31-4.67,2.93-5.6c1.62-.93,2.93,.06,2.93,2.22Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M768.41,582.29h0c-.67-1.17-.27-2.66,.89-3.33l46.31-26.73c1.17-.67,2.66-.27,3.33,.89h0c.67,1.17,.27,2.66-.89,3.33l-46.31,26.73c-1.17,.67-2.66,.27-3.33-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M815.62,583.18l-46.31-26.73c-1.17-.67-1.57-2.17-.89-3.33h0c.67-1.17,2.17-1.57,3.33-.89l46.31,26.73c1.17,.67,1.57,2.17,.89,3.33h0c-.67,1.17-2.17,1.57-3.33,.89Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M818.44,556.87c0,2.16-1.31,4.67-2.93,5.6-1.62,.93-2.93-.06-2.93-2.22s1.31-4.67,2.93-5.6c1.62-.93,2.93,.06,2.93,2.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "819.55 555.75 817.29 554.43 813.6 562.62 815.96 563.98 819.55 555.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M820.81,558.23c0,2.16-1.31,4.67-2.93,5.6-1.62,.93-2.93-.06-2.93-2.22s1.31-4.67,2.93-5.6c1.62-.93,2.93,.06,2.93,2.22Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M815.59,584.3c0,2.16-1.31,4.67-2.93,5.6-1.62,.93-2.93-.06-2.93-2.22s1.31-4.67,2.93-5.6c1.62-.93,2.93,.06,2.93,2.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "816.7 583.19 814.44 581.86 810.75 590.06 813.1 591.42 816.7 583.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M817.96,585.67c0,2.16-1.31,4.67-2.93,5.6-1.62,.93-2.93-.06-2.93-2.22s1.31-4.67,2.93-5.6c1.62-.93,2.93,.06,2.93,2.22Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M771.19,558.39c0,2.16-1.31,4.67-2.93,5.6-1.62,.93-2.93-.06-2.93-2.22s1.31-4.67,2.93-5.6c1.62-.93,2.93,.06,2.93,2.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "772.3 557.28 770.04 555.95 766.35 564.15 768.7 565.51 772.3 557.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M773.56,559.76c0,2.16-1.31,4.67-2.93,5.6-1.62,.93-2.93-.06-2.93-2.22s1.31-4.67,2.93-5.6c1.62-.93,2.93,.06,2.93,2.22Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M765.16,531.09s-7.07,5.92-6.56,12.16c.28,3.41-.13,4.93,.41,9.17,.51,4,.79,19.95,.56,25.21-.23,5.26-3.69,9.99-4.98,11.83-1.29,1.84,2.37,4.99,5.4,2.37,3.03-2.63,3.36-3.15,5.03-3.94s3.07-4.47,1.98-8.68c-1.09-4.21-.06-12.36,1.66-19.45,1.03-4.26,.92-9.47,.86-13.41-.04-2.62,9.62-10.99,9.98-11.83,.91-2.1-14.34-3.42-14.34-3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M754.59,589.45s-3.71,2.79-4.97,4.19c-1.26,1.39,2.32,3.7,5.89,2.65,3.57-1.05,6.61-4.22,9.52-6.57,2.85-2.31,3.64-3.14,3.64-5.95,0-1.38-1.35-2.9-1.35-2.9,0,0-1.15,5.63-5.26,7.82-3.93,2.08-5.52,2.36-7.46,.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M771.37,540.29c-1.67,1.68-3.42,5.06-2.71,8.68,.66,3.36,1.18,5.91,1.19,9.47,.02,4.03,.79,20.64,.56,25.9-.23,5.26-3.69,9.99-4.98,11.83-1.29,1.84,2.37,4.99,5.4,2.37,3.03-2.63,3.36-3.15,5.03-3.94,1.68-.79,3.07-4.47,1.98-8.68-1.09-4.21-.06-12.36,1.66-19.45,1.72-7.1-.49-16.65,.98-18.41,2.96-3.55,9.16-6.63,9.38-10.23,.26-4.48-4.2-11.85-8.63-9.84-1.48,.67-4.34,6.79-9.86,12.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M765.43,596.16s-3.71,2.79-4.97,4.19,2.32,3.7,5.89,2.65c3.57-1.05,6.61-4.22,9.52-6.57,2.85-2.31,3.64-3.14,3.64-5.95,0-1.38-1.35-2.9-1.35-2.9,0,0-1.15,5.63-5.26,7.82-3.93,2.08-5.52,2.36-7.46,.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M803.35,514.29s3.25,10.41-.7,17.53c-3.25,5.87-20.21,14.51-20.21,14.51,0,0-2.41-7.64-10.15-10.4-4.54-1.62-9.33-2.65-9.33-2.65l17.52-22.31s9.11,11.24,22.87,3.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M779.23,485.84s-1-.5-2.44-1.81c-1.73-1.57-1.73-3.22-1.73-3.22,0,0,7.37-9.07,10.25-11.08s7.54,2.33,7.54,2.33l-13.62,13.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M810.04,484.58c-.54-2.72-8.5-8.77-8.5-8.77,0,0-4.78,3.44-6.46,4.63-1.61,1.14-4.35,4.13-4.58,4.39-.01,0-.03,0-.04,0,.06-.51,.57-4.61,2.39-8.92,.57-1.36,0-5.43,0-5.43,0,0-.64-.19-1.56-.4-1.48,1.48-4.43,5.46-6,7.1-1.52,1.58-7.36,6.44-6.05,11.83,.39,1.6,.9,3,1.64,5,.83,2.24,.57,6.42,.34,8.68-.26,2.6-3.02,9.36-3.02,9.36,0,0,5.65,7.22,12.07,7.25,7.5,.03,13.07-5,13.07-5,0,0-1.24-11.42-.77-16.08,0,0,9.27-4.64,7.47-13.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M790.3,474.63s-4.69,5.35-4.33,7.48c1.18,1.13,3.93,3.37,3.93,3.37l3.17-10.46-2.77-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M783.76,460.05s-.53,4.54-.22,8.34c.86,10.85,1.09,13.17,2.25,16.24,2.17-5.61,6.31-10.6,6.31-10.6l-8.34-13.98Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "678.45 578.81 657.99 566.98 657.99 500.52 678.45 512.35 678.45 578.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "678.45 578.81 681.56 577.02 681.56 510.56 678.45 512.35 678.45 578.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "678.45 548.37 782.05 608.19 782.05 579.78 678.45 519.49 678.45 548.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "785.16 640.86 833.69 613.01 833.69 546.55 785.16 574.41 785.16 640.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "785.16 640.86 782.05 639.07 782.05 572.61 785.16 574.41 785.16 640.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "832.14 613.91 835.25 612.12 835.25 545.66 832.14 547.45 832.14 613.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "785.26 583.15 657.99 509.28 657.99 505.96 785.26 579.83 785.26 583.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "785.26 579.83 843.35 546.28 843.35 549.39 785.26 582.95 785.26 579.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M736.21,487.32l-58.02-33.61-19.56,11.35c-17.08,9.91-17.05,34.57,.04,44.45l19.68,11.37,106.92,62.05v-3.1s-49.06-92.51-49.06-92.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M736.21,484.22l-58.02-33.61-19.56,11.35c-17.08,9.91-17.05,34.57,.04,44.45l19.68,11.37,106.92,62.05,58.09-33.56-107.14-62.06Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "777.51 518.77 753.54 504.9 744.66 510.01 768.68 523.88 777.51 518.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "768.68 525.14 777.51 520.01 777.51 518.77 768.68 523.88 768.68 525.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "768.68 523.88 768.68 525.14 744.66 511.19 744.66 510.01 768.68 523.88"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "765.57 522.09 765.12 521.83 773.96 516.72 774.42 516.98 765.57 522.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "762.07 520.07 761.62 519.81 770.47 514.7 770.92 514.96 762.07 520.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "758.58 518.05 758.13 517.79 766.98 512.68 767.43 512.94 758.58 518.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "755.12 516.03 754.67 515.77 763.51 510.66 763.96 510.92 755.12 516.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "775.8 519.76 776.25 519.5 752.24 505.63 751.79 505.88 775.8 519.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "774.06 520.81 774.51 520.56 750.47 506.67 750.01 506.93 774.06 520.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "772.24 521.83 772.69 521.57 748.68 507.69 748.23 507.95 772.24 521.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "770.43 522.92 770.92 522.69 746.83 508.76 746.38 509.02 770.43 522.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "751.71 514.06 751.26 513.8 760.1 508.69 760.56 508.94 751.71 514.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "748.34 512.11 747.89 511.85 756.73 506.75 757.19 507 748.34 512.11"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "671.58 449.83 652.78 460.72 666.29 468.47 685.15 457.61 671.58 449.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "662.3 456.6 655.45 460.6 666.29 466.8 673.19 462.83 662.3 456.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "665.03 455.04 663.99 455.66 674.84 461.86 675.92 461.27 665.03 455.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "667.26 453.74 666.22 454.36 677.07 460.56 678.15 459.97 667.26 453.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "666.29 468.47 666.29 472.65 685.15 461.78 685.15 457.61 666.29 468.47"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "652.78 460.72 652.78 461.7 665.51 469 665.51 471.37 652.78 464.07 652.78 464.9 666.29 472.65 666.29 468.47 652.78 460.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "665.51 469 652.78 461.7 652.78 464.07 665.51 471.37 665.51 469"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "687.29 464.18 668.48 475.07 681.99 482.82 700.85 471.95 687.29 464.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "678 470.94 671.15 474.95 681.99 481.15 688.89 477.17 678 470.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "680.73 469.38 679.7 470.01 690.54 476.21 691.62 475.61 680.73 469.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "682.97 468.08 681.93 468.71 692.77 474.91 693.86 474.32 682.97 468.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "681.99 482.82 681.99 487 700.85 476.13 700.85 471.95 681.99 482.82"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "668.48 475.07 668.48 476.05 681.22 483.35 681.22 485.72 668.48 478.42 668.48 479.25 681.99 487 681.99 482.82 668.48 475.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "681.22 483.35 668.48 476.05 668.48 478.42 681.22 485.72 681.22 483.35"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "687.29 459.26 668.48 470.16 681.99 477.91 700.85 467.04 687.29 459.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "678 466.03 671.15 470.03 681.99 476.24 688.89 472.26 678 466.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "680.73 464.47 679.7 465.09 690.54 471.3 691.62 470.7 680.73 464.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "682.97 463.17 681.93 463.79 692.77 470 693.86 469.4 682.97 463.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "681.99 477.91 681.99 482.08 700.85 471.22 700.85 467.04 681.99 477.91"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "668.48 470.16 668.48 471.13 681.22 478.44 681.22 480.81 668.48 473.51 668.48 474.34 681.99 482.08 681.99 477.9 668.48 470.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "681.22 478.44 668.48 471.13 668.48 473.51 681.22 480.81 681.22 478.44"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M800.72,495.59s-1.67,4.08-2.7,6.92c-1.02,2.84-3.59,4.85-5.09,5.73-1.19,.7-6.62,2.73-9.54,3.5-.61,.16-6.12,1.32-7.24,1.01-4.78-1.31-7.5-.5-9.65,.76-2.15,1.26-2.35,3.4,3.2,3.72,5.55,.32,9.62,.53,12.83,.42,3.31-.11,7.6-.61,13.11-1.99,5.52-1.38,7.22-4.58,8.74-7.08,1.52-2.51,4.83-10.15,4.83-10.15l-8.5-2.84Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M792.34,471.09s-.16,4.63-1.1,7.06c-.74,1.04-1.59,4.37-1.33,7.33,1.56-.79,4.18-3.29,5.67-4.58,1.81-1.56,6.53-4.61,6.53-4.61l-.16-13.72-9.61,8.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M797.86,454.79c-3.03-2.31-10.22-3.05-12.84,4.37-2.75,7.79,4.3,17.51,8.05,15.86,2.1-.93,6.52-4.21,7.77-8.31,1.4-4.61-.62-10.12-2.98-11.92Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M802.07,473.47s-2.95,1.8-5.54,4.49c-4.04,4.2-6.62,7.51-6.62,7.51,0,0,1.29,.91,6.08,1.32,3.88-3.74,7.21-6.03,8.56-8.54-.07-1.15-2.47-4.79-2.47-4.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M804.13,456.89c-1.26-2.32-4.21-5.49-6.38-6.38-4.35-1.79-7.34-.25-11.44,3.52-2.46,2.27-3.6,4.94-3.6,9.19,0,0,6.33,4.52,10.14,5.31,1.77,.37,4.21-.69,5.64-1.39,.17,1.95,.4,4.16,.34,5.2-.8,13.86-1.51,18.5-1.51,18.5,0,0,1.21-.03,2.93-3.06,.93-1.65,2.91-3.97,4.36-9.31,.78-2.88,1.8-17.38-.48-21.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M808.66,502.04c1.12-2.32,2.06-4.44,2.45-5.71,1.03-3.37,1.76-9.21-1.78-13.19-3.54-3.98-8.27,4.67-9.11,7.63-.91,3.21-1.77,5.88-2.32,7.7,.31,4.74,7.84,4.78,10.77,3.58Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M775.38,482.08s-3.51,4.12-5.16,5.91c-.61,.67-3.32,4.28-5.12,7.15-2.48,3.94-4.13,7.38-4.38,8.18-.66,2.07-2.08,5.95-1.16,7.68,.92,1.73,4.78,3.97,6.2,.08,.72-1.98,.16-6.25,.46-6.84,.68-1.35,5.48-7.37,6.63-8.64,1.15-1.27,6.29-7.23,6.29-7.23,0,0-.11-1.56,.1-2.52-2.38-1.21-3.85-3.76-3.85-3.76Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M753.87,498.03l-4.93-2.84h0c-.18-.11-.39-.19-.63-.19-3.54,0-7.5,6.31-7.5,6.31l5.01,2.87,8.29-5.55-.24-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M745.8,504.18l8.92-5.15s-.47-1.15-1.42-1.15c-3.54,0-7.5,6.31-7.5,6.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M742.74,502.41l.53,.3s.67-1.06,1.69-2.3l-.53-.3c-1.02,1.24-1.68,2.3-1.68,2.3Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M794.27,437.23l-14.33,8.27c-1.12,.64-3.08,.56-4.37-.18l-24.57-14.19c-1.29-.74-1.43-1.88-.31-2.52l14.33-8.27c1.12-.64,3.08-.56,4.37,.18l24.57,14.19c1.29,.74,1.43,1.88,.31,2.52Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 749.93,
    y: 428,
    width: 1.42,
    height: 1.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 793.6,
    y: 434.57,
    width: 1.42,
    height: 1.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M794.27,435.63l-14.33,8.27c-1.12,.64-3.08,.56-4.37-.18l-24.57-14.19c-1.29-.74-1.43-1.88-.31-2.52l14.33-8.27c1.12-.64,3.08-.56,4.37,.18l24.57,14.19c1.29,.74,1.43,1.88,.31,2.52Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "754.49 428.09 767.77 420.39 791.36 434.55 778.09 442.25 754.49 428.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M754.12,425.03l3.97,2.47,8.68-5.24-3.78-2.35s-1.16,.71-1.91,1.08-1.76-1.1-4.11,.15c-2.67,1.41,.08,2.22-.79,2.71-.64,.36-2.06,1.19-2.06,1.19Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "731.11 524.35 719.9 517.88 715.71 524.35 722.27 530.05 731.11 524.35"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M744.94,485.71v32.81c0,2.45-2.65,3.99-4.78,2.76l-38.61-22.29c-.99-.57-1.59-1.62-1.59-2.76v-32.81c0-2.45,2.65-3.99,4.78-2.76l38.61,22.29c.99,.57,1.59,1.62,1.59,2.76Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "743.37 521.28 741.23 522.52 738.73 519.91 743.68 516.88 743.37 521.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "701.35 460.79 699.51 461.86 703.19 461.92 701.35 460.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M742.88,486.92v32.81c0,2.45-2.65,3.99-4.78,2.76l-38.61-22.29c-.99-.57-1.59-1.62-1.59-2.76v-32.81c0-2.45,2.65-3.99,4.78-2.76l38.61,22.29c.99,.57,1.59,1.62,1.59,2.76Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "712.59 497.07 712.59 526.08 721.42 531.2 721.42 502.2 712.59 497.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "712.59 497.07 713.75 496.42 722.58 501.55 721.42 502.2 712.59 497.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "722.58 501.55 721.42 502.2 721.42 531.2 722.58 530.55 722.58 501.55"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "722.27 530.72 731.11 525.59 731.11 524.35 722.27 529.46 722.27 530.72"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "789.37 529.25 764.42 543.71 781.26 553.45 806.2 538.96 789.37 529.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "779.38 537.33 772.49 541.31 785.66 548.86 792.56 544.88 779.38 537.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "781.26 536.24 780.71 536.56 793.9 544.1 794.45 543.79 781.26 536.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "782.49 535.53 781.94 535.85 795.13 543.4 795.67 543.08 782.49 535.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "783.79 534.78 783.24 535.1 796.43 542.65 796.97 542.33 783.79 534.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "785.03 534.07 784.49 534.38 797.68 541.92 798.22 541.61 785.03 534.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "786.26 533.35 785.71 533.67 798.9 541.22 799.44 540.9 786.26 533.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "787.56 532.61 787.01 532.92 800.2 540.48 800.74 540.16 787.56 532.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "771.1 542.12 770.55 542.43 783.74 549.98 784.28 549.66 771.1 542.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "790.21 531.05 788.29 532.16 801.47 539.71 803.4 538.6 790.21 531.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "764.42 543.71 764.42 544.93 781.26 554.67 781.26 553.45 764.42 543.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "806.18 538.97 781.26 553.45 781.26 554.67 806.18 540.19 806.18 538.97"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "789.37 526.75 764.42 541.21 781.26 550.96 806.2 536.47 789.37 526.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "779.38 534.84 772.49 538.81 785.66 546.36 792.56 542.39 779.38 534.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "781.26 533.75 780.71 534.06 793.9 541.61 794.45 541.3 781.26 533.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "782.49 533.03 781.94 533.35 795.13 540.9 795.67 540.58 782.49 533.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "783.79 532.29 783.24 532.61 796.43 540.16 796.97 539.84 783.79 532.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "785.03 531.57 784.49 531.88 797.68 539.43 798.22 539.12 785.03 531.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "786.26 530.86 785.71 531.17 798.9 538.73 799.44 538.41 786.26 530.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "787.56 530.11 787.01 530.43 800.2 537.98 800.74 537.66 787.56 530.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "771.1 539.62 770.55 539.93 783.74 547.48 784.28 547.17 771.1 539.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "790.21 528.56 788.29 529.67 801.47 537.22 803.4 536.1 790.21 528.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "764.42 541.21 764.42 542.43 781.26 552.17 781.26 550.96 764.42 541.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "806.18 536.48 781.26 550.96 781.26 552.17 806.18 537.7 806.18 536.48"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "789.37 523.77 764.42 538.22 781.26 547.97 806.2 533.48 789.37 523.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "779.38 531.85 772.49 535.82 785.66 543.37 792.56 539.4 779.38 531.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "781.26 530.76 780.71 531.07 793.9 538.62 794.45 538.31 781.26 530.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "782.49 530.05 781.94 530.36 795.13 537.92 795.67 537.59 782.49 530.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "783.79 529.3 783.24 529.62 796.43 537.17 796.97 536.85 783.79 529.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "785.03 528.58 784.49 528.89 797.68 536.44 798.22 536.13 785.03 528.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "786.26 527.87 785.71 528.19 798.9 535.74 799.44 535.42 786.26 527.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "787.56 527.12 787.01 527.44 800.2 534.99 800.74 534.67 787.56 527.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "771.1 536.63 770.55 536.95 783.74 544.49 784.28 544.18 771.1 536.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "790.21 525.57 788.29 526.68 801.47 534.23 803.4 533.12 790.21 525.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "764.42 538.22 764.42 539.44 781.26 549.19 781.26 547.97 764.42 538.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "806.18 533.49 781.26 547.97 781.26 549.19 806.18 534.71 806.18 533.49"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M789.37,548.83c-2.79,0-5.06,1.2-5.06,2.69s2.26,2.69,5.06,2.69,5.06-1.2,5.06-2.69-2.26-2.69-5.06-2.69Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M788.48,545.71c-.39,0-.71-.17-.71-.38v12.82h1.43v-12.82c0,.21-.32,.38-.71,.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M787.77,543.47v1.87c0-.21,.32-.38,.71-.38s.71,.17,.71,.38v-1.87h-1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M788.48,544.95c-.39,0-.71,.17-.71,.38s.32,.38,.71,.38,.71-.17,.71-.38-.32-.38-.71-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M789.2,543.47c0,.21-.32,.38-.71,.38s-.71-.17-.71-.38,.32-.38,.71-.38,.71,.17,.71,.38Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M793.58,547.07c-.38-.09-.65-.33-.61-.53l-2.97,12.47,1.39,.33,2.97-12.47c-.05,.2-.4,.3-.78,.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M793.4,544.72l-.43,1.82c.05-.2,.4-.3,.78-.2,.38,.09,.65,.33,.61,.53l.43-1.82-1.39-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M793.75,546.33c-.38-.09-.73,0-.78,.2s.22,.44,.61,.53c.38,.09,.73,0,.78-.2s-.22-.44-.61-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M794.79,545.05c-.05,.2-.4,.3-.78,.2-.38-.09-.65-.33-.61-.53,.05-.2,.4-.3,.78-.2,.38,.09,.65,.33,.61,.53Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M784.78,547.65c-.38,.12-.73,.05-.79-.15l3.85,12.23,1.36-.43-3.85-12.23c.06,.2-.19,.46-.57,.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M783.42,545.72l.56,1.78c-.06-.2,.19-.46,.57-.58,.38-.12,.73-.05,.79,.15l-.56-1.78-1.36,.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M784.55,546.93c-.38,.12-.63,.38-.57,.58,.06,.2,.42,.27,.79,.15,.38-.12,.63-.38,.57-.58-.06-.2-.42-.27-.79-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M784.78,545.29c.06,.2-.19,.46-.57,.58s-.73,.05-.79-.15c-.06-.2,.19-.46,.57-.58,.38-.12,.73-.05,.79,.15Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M789.37,554.21c-2.79,0-5.06-1.2-5.06-2.69v13.31h10.12v-13.31c0,1.49-2.26,2.69-5.06,2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M794.42,564.83c0,1.49-2.26,2.69-5.06,2.69s-5.06-1.2-5.06-2.69,2.26-2.69,5.06-2.69,5.06,1.2,5.06,2.69Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M756.68,531.76l-8.95,5.17c-.44,.26-1.22,.22-1.73-.07l-4.34-2.51c-.51-.3-.57-.74-.12-1l8.95-5.17c.44-.26,1.22-.22,1.73,.07l4.34,2.51c.51,.3,.57,.74,.12,1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 741.23,
    y: 532.87,
    width: 0.95,
    height: 0.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 754.44,
    y: 530.4,
    width: 2.53,
    height: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M756.68,530.8l-8.95,5.17c-.44,.26-1.22,.22-1.73-.07l-4.34-2.51c-.51-.3-.57-.74-.12-1l8.95-5.17c.44-.26,1.22-.22,1.73,.07l4.34,2.51c.51,.3,.57,.74,.12,1Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "742.32 532.73 746.82 535.45 754.79 530.85 750.29 528.13 742.32 532.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M753.85,529.02c0,.17-.26,.3-.57,.3s-.57-.14-.57-.3,.25-.3,.57-.3,.57,.14,.57,.3Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M730.45,428.16l17.24,9.93c.92,.53,.93,1.85,.02,2.4l-14.71,8.86c-2,1.21-4.51,1.23-6.53,.06l-15.51-8.97c-1.41-.81-1.42-2.84-.03-3.68l14.19-8.54c1.64-.99,3.68-1.01,5.34-.05Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 745.99,
    y: 437.11,
    width: 2.39,
    height: 1.92,
    transform: "translate(1494.38 876.14) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 709.89,
    y: 436.2,
    width: 4.26,
    height: 2.25,
    transform: "translate(1424.03 874.65) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M730.45,426.05l17.24,9.93c.92,.53,.93,1.85,.02,2.4l-14.71,8.86c-2,1.21-4.51,1.23-6.53,.06l-15.51-8.97c-1.41-.81-1.42-2.84-.03-3.68l14.19-8.54c1.64-.99,3.68-1.01,5.34-.05Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M741.22,434.25l4.12,2.37c.22,.13,.22,.44,0,.57l-3.52,2.12c-.48,.29-1.08,.29-1.56,.01l-3.71-2.14c-.34-.19-.34-.68,0-.88l3.39-2.04c.39-.24,.88-.24,1.28-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M728.79,427.04l4.12,2.37c.22,.13,.22,.44,0,.57l-3.52,2.12c-.48,.29-1.08,.29-1.56,.01l-3.71-2.14c-.34-.19-.34-.68,0-.88l3.39-2.04c.39-.24,.88-.24,1.28-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M745.51,436.81s-2.13-5.18-7.27-8.49c-5.14-3.31-10.42-1.4-10.42-1.4v2.67s3.76-.24,6.68,1.75,5,6.31,5,6.31l6.02-.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M741.76,439.01s-2.13-5.18-7.27-8.49c-5.14-3.31-10.42-1.4-10.42-1.4l.41,.23,4.92,2.75s1.96-1.44,4.37,.22c2.91,2,2.56,4.33,2.56,4.33l5.44,2.36Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "723.46 431.9 714.52 437.33 712.19 435.99 721.14 430.6 723.46 431.9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "726.1 433.69 724.53 434.65 723.02 433.77 724.6 432.84 726.1 433.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "723.82 435.06 722.25 436.02 720.74 435.14 722.32 434.21 723.82 435.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "721.56 436.4 719.99 437.36 718.48 436.48 720.06 435.55 721.56 436.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "719.22 437.83 717.65 438.79 716.14 437.91 717.72 436.98 719.22 437.83"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "728.95 435.33 727.39 436.29 725.88 435.41 727.46 434.48 728.95 435.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "726.68 436.7 725.11 437.66 723.6 436.78 725.18 435.85 726.68 436.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "724.41 438.04 722.85 439 721.34 438.12 722.92 437.19 724.41 438.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "722.07 439.47 720.51 440.43 719 439.55 720.58 438.62 722.07 439.47"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "731.86 437 730.29 437.97 728.78 437.08 730.36 436.16 731.86 437"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "729.58 438.37 728.01 439.34 726.5 438.45 728.08 437.53 729.58 438.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "727.32 439.71 725.75 440.68 724.24 439.79 725.82 438.87 727.32 439.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "724.98 441.15 723.41 442.11 721.9 441.22 723.48 440.3 724.98 441.15"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "734.65 438.62 733.09 439.58 731.58 438.7 733.16 437.77 734.65 438.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "732.38 439.99 730.81 440.95 729.3 440.07 730.88 439.14 732.38 439.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "730.11 441.33 728.55 442.29 727.04 441.41 728.62 440.48 730.11 441.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "727.77 442.76 726.21 443.72 724.7 442.84 726.28 441.91 727.77 442.76"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "738.09 440.62 734.25 442.95 732.74 442.07 736.6 439.77 738.09 440.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "733.55 443.33 729.65 445.72 728.14 444.84 732.06 442.48 733.55 443.33"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M757.55,451.3h0c2.42,0,4.22-1.84,5.03-3.41,.78-1.51,.92-3.02,.41-4.47-1.01-2.89-4.56-5.62-11.17-8.59-3.22-1.45-6.45-3.88-9.31-6.02-4-3.01-7.46-5.6-10.11-5.05-1.02,.21-1.86,.89-2.49,2l1.06,.6c.45-.8,1-1.26,1.68-1.4,2.11-.43,5.52,2.12,9.13,4.84,2.9,2.18,6.2,4.66,9.54,6.16,6.2,2.79,9.64,5.36,10.52,7.88,.4,1.14,.29,2.29-.34,3.52-.65,1.27-2.08,2.75-3.95,2.75h0c-2.01,0-3.96-1.72-5.64-4.97-2.48-4.79-8.58-8.3-8.83-8.45l-.6,1.05c.06,.03,6.04,3.48,8.36,7.95,2.41,4.65,4.98,5.63,6.72,5.63Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M723.5,464.19l17.51,10.11c1.21,.7,3.33,.61,4.73-.2l11.27-6.5c1.39-.8,1.55-2.03,.34-2.73l-17.51-10.11c-1.21-.7-3.33-.61-4.73,.2l-11.27,6.5c-1.39,.8-1.55,2.03-.34,2.73Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 747.1,
    y: 465.1,
    width: 11.06,
    height: 1.04,
    transform: "translate(1505.26 931.23) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 722.69,
    y: 462.02,
    width: 11.06,
    height: 1.04,
    transform: "translate(1456.44 925.08) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M723.5,463.07l17.51,10.11c1.21,.7,3.33,.61,4.73-.2l11.27-6.5c1.39-.8,1.55-2.03,.34-2.73l-17.51-10.11c-1.21-.7-3.33-.61-4.73,.2l-11.27,6.5c-1.39,.8-1.55,2.03-.34,2.73Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "737.97 454.26 756.29 464.87 743.13 472.41 724.77 461.83 737.97 454.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M730.19,457.4c0,.18,.28,.33,.63,.33s.63-.15,.63-.33-.28-.33-.63-.33-.63,.15-.63,.33Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "783.18 533.21 596.45 425.34 599.7 423.46 786.4 531.37 783.18 533.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "782.84 533.03 782.84 652.75 596.45 545.06 596.45 425.34 782.84 533.03"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M521.25,651.65c0,.82,1.25,1.49,2.79,1.49s2.79-.67,2.79-1.49-1.25-1.49-2.79-1.49-2.79,.67-2.79,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M521.25,648.47c0,.82,1.25,1.49,2.79,1.49s2.79-.67,2.79-1.49-1.25-1.49-2.79-1.49-2.79,.67-2.79,1.49Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 521.25,
    y: 648.47,
    width: 5.59,
    height: 3.19,
    transform: "translate(1048.1 1300.12) rotate(180)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M556.36,631.39c0,.82,1.25,1.49,2.79,1.49s2.79-.67,2.79-1.49-1.25-1.49-2.79-1.49-2.79,.67-2.79,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M556.36,628.2c0,.82,1.25,1.49,2.79,1.49s2.79-.67,2.79-1.49-1.25-1.49-2.79-1.49-2.79,.67-2.79,1.49Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 556.36,
    y: 628.2,
    width: 5.59,
    height: 3.19,
    transform: "translate(1118.3 1259.59) rotate(180)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M486.45,631.49c0,.82,1.25,1.49,2.79,1.49s2.79-.67,2.79-1.49-1.25-1.49-2.79-1.49-2.79,.67-2.79,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M486.45,628.31c0,.82,1.25,1.49,2.79,1.49s2.79-.67,2.79-1.49-1.25-1.49-2.79-1.49-2.79,.67-2.79,1.49Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 486.45,
    y: 628.31,
    width: 5.59,
    height: 3.19,
    transform: "translate(978.49 1259.8) rotate(180)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "561.51 580.17 561.51 630.36 526.6 650.51 524.05 595.9 561.51 580.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "524.05 651.98 484.25 628.96 484.25 580.17 524.05 603.15 524.05 651.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "524.05 651.98 526.6 650.51 526.6 601.87 524.05 603.35 524.05 651.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "561.16 630.56 563.71 629.09 563.71 580.46 561.16 581.93 561.16 630.56"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "524.05 604.43 563.71 581.49 563.71 578.9 524.05 601.87 524.05 604.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "484.27 578.9 524.05 601.87 524.05 604.43 484.27 581.45 484.27 578.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "524.05 555.83 563.71 578.9 524.05 601.87 484.27 578.9 524.05 555.83"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "561.16 614.97 561.16 615.54 526.6 635.5 526.6 634.88 561.16 614.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "561.16 598.86 561.16 599.43 526.6 619.39 526.6 618.77 561.16 598.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "540 631.31 550.54 625.23 550.54 627.01 540 633.13 540 631.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "540 615.2 550.54 609.12 550.54 610.9 540 617.02 540 615.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "540 599.09 550.54 593.01 550.54 594.79 540 600.9 540 599.09"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "633.54 586.52 607.24 571.55 607.24 505.13 633.54 520.06 633.54 586.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "633.54 586.52 636.65 584.72 636.65 518.26 633.54 520.06 633.54 586.52"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "507.36 659.8 458.55 631.78 458.83 565.54 507.36 593.34 507.36 659.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "507.36 659.8 510.47 658 510.47 591.54 507.36 593.34 507.36 659.8"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "460.38 632.84 457.28 631.05 457.28 564.59 460.38 566.38 460.38 632.84"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "515.61 576.53 615.97 518.58 615.97 535.17 515.61 593.11 515.61 576.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "515.61 593.11 515.61 576.53 474.99 553.86 474.99 569.5 515.61 593.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "507.26 602.08 647.32 520.84 647.32 517.52 507.26 598.77 507.26 602.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "507.26 598.77 449.17 565.21 449.17 568.53 507.26 602.08 507.26 598.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M647.32,517.52h0c-35.91-20.78-80.2-20.75-116.09,.07l-82.06,47.62,58.09,33.56,140.06-81.25Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "664.77 655.07 713.58 627.06 713.3 560.81 664.77 588.61 664.77 655.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "664.77 655.07 661.66 653.27 661.66 586.82 664.77 588.61 664.77 655.07"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "672.77 590.01 672.77 646.43 712.74 670.48 712.74 613.12 672.77 590.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "672.74 615.66 672.74 616.35 711.21 639.51 711.21 638.75 672.74 615.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "672.74 630.67 672.74 631.37 711.21 654.52 711.21 653.76 672.74 630.67"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "711.77 683.3 760.58 655.28 760.3 589.03 711.77 616.84 711.77 683.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "711.77 683.3 708.66 681.5 708.66 615.04 711.77 616.84 711.77 683.3"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "758.75 656.34 761.86 654.55 761.86 588.09 758.75 589.88 758.75 656.34"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "703.52 600.03 603.16 542.08 603.16 558.66 703.52 616.61 703.52 600.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "703.52 616.61 703.52 600.03 744.14 577.36 744.14 593 703.52 616.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "711.87 625.58 587.68 553.63 589.31 551.17 711.87 622.26 711.87 625.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "711.87 622.26 769.96 588.71 769.96 592.03 711.87 625.58 711.87 622.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "571.81 541.02 646.25 516.92 769.96 588.71 711.87 622.26 571.81 541.02"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "665.85 570.5 641.88 556.63 633 561.74 657.02 575.62 665.85 570.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "657.02 576.87 665.85 571.75 665.85 570.5 657.02 575.62 657.02 576.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "657.02 575.62 657.02 576.87 633 562.93 633 561.74 657.02 575.62"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "653.91 573.82 653.46 573.56 662.3 568.45 662.76 568.71 653.91 573.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "650.41 571.8 649.96 571.54 658.8 566.43 659.26 566.69 650.41 571.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "646.92 569.78 646.47 569.52 655.31 564.41 655.77 564.67 646.92 569.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "643.46 567.77 643.01 567.51 651.85 562.4 652.3 562.65 643.46 567.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "664.14 571.49 664.59 571.23 640.58 557.36 640.13 557.62 664.14 571.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "662.4 572.55 662.85 572.29 638.81 558.4 638.35 558.66 662.4 572.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "660.58 573.56 661.03 573.3 637.02 559.43 636.56 559.69 660.58 573.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "658.77 574.66 659.26 574.42 635.17 560.5 634.72 560.76 658.77 574.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "640.05 565.79 639.6 565.53 648.44 560.42 648.9 560.68 640.05 565.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "636.68 563.85 636.23 563.59 645.07 558.48 645.53 558.74 636.68 563.85"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "664.34 582.61 669.35 585.48 677.65 579.93 677.4 579.33 672.48 576.49 664.34 582.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M664.34,582.61l8.92-5.15s-.47-1.16-1.42-1.15c-6.17,.08-7.5,6.31-7.5,6.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M669.33,585.48l8.92-5.15s-.47-1.14-1.42-1.15c-6.39-.1-7.5,6.31-7.5,6.31Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M552.16,563.66l-13.19,7.61c-1.03,.59-2.84,.52-4.02-.17l-22.61-13.06c-1.19-.68-1.32-1.73-.29-2.32l13.19-7.61c1.03-.59,2.84-.52,4.02,.17l22.61,13.06c1.19,.68,1.32,1.73,.29,2.32Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 511.35,
    y: 555.17,
    width: 1.31,
    height: 1.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 551.54,
    y: 561.22,
    width: 1.31,
    height: 1.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M552.16,562.19l-13.19,7.61c-1.03,.59-2.84,.52-4.02-.17l-22.61-13.06c-1.19-.68-1.32-1.73-.29-2.32l13.19-7.61c1.03-.59,2.84-.52,4.02,.17l22.61,13.06c1.19,.68,1.32,1.73,.29,2.32Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "515.55 555.25 527.77 548.16 549.48 561.2 537.27 568.29 515.55 555.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M515.21,552.43l3.65,2.27,7.99-4.82-3.47-2.17s-1.07,.65-1.76,.99c-.69,.34-1.62-1.01-3.78,.13-2.46,1.3,.07,2.04-.73,2.49-.59,.33-1.9,1.1-1.9,1.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M657.77,554.29s7.36-4.03,9.37-5.44c1.45-1.02,1-1.89,.11-4.79-.89-2.9-2.84-8.22-2.84-8.22l1.79-.29s2.09,6.41,2.83,8.86c.74,2.45,1.06,4.19-1.17,5.6-3.04,1.92-10.1,6-10.1,6v-1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M664.63,551.23c1.64-1.01,3.46-1.62,4.02-3.8,.55-2.13-.59-4.33-1.38-6.28-1.09-2.69-1.16-5.26-2.44-7.86,5.94,.59,11.88,5.04,12.29,5.57,.45,.56,3.74,12.79,4.19,14.38,.45,1.59,0,2.54-2.75,4.18-2.74,1.64-8.13,4.16-8.13,4.16l-12.24-6.92c1.96-1.16,4.45-2.21,6.44-3.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M670.43,561.58s7.51-4.24,9.47-5.47c1.5-.94,.9-2,0-4.9-.89-2.9-2.84-8.22-2.84-8.22l1.8-.29s2.09,6.41,2.83,8.86c.74,2.45,1.25,4.36-.98,5.77-3.04,1.92-10.29,5.96-10.29,5.96v-1.71Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "670.43 561.58 670.43 563.29 657.77 556 657.77 554.29 670.43 561.58"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M696.97,519.82v32.81c0,2.45-2.65,3.99-4.78,2.76l-38.61-22.29c-.99-.57-1.59-1.62-1.59-2.76v-32.81c0-2.45,2.65-3.99,4.78-2.76l38.61,22.29c.99,.57,1.59,1.62,1.59,2.76Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "695.39 555.39 693.25 556.62 690.76 554.01 695.7 550.99 695.39 555.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "653.37 494.9 651.53 495.96 655.21 496.03 653.37 494.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M694.9,521.03v32.81c0,2.45-2.65,3.99-4.78,2.76l-38.61-22.29c-.99-.57-1.59-1.62-1.59-2.76v-32.81c0-2.45,2.65-3.99,4.78-2.76l38.61,22.29c.99,.57,1.59,1.62,1.59,2.76Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "653.49 500.2 690.76 521.73 690.76 552.6 653.49 531.06 653.49 500.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M667.19,541.71l3.33,1.9c.4,.23,.75,.1,.78-.28h0c.02-.38-.29-.89-.69-1.12l-3.33-1.9c-.4-.23-.75-.1-.78,.28h0c-.02,.38,.29,.89,.69,1.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "689.31 549.73 689.31 548.4 654.65 528.37 654.65 529.65 689.31 549.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "689.31 525.18 689.31 523.84 654.65 503.81 654.65 505.09 689.31 525.18"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "697.83 634.77 684.98 627.05 684.98 629.22 697.83 636.99 697.83 634.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "697.83 619.36 684.98 611.65 684.98 613.82 697.83 621.58 697.83 619.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "697.83 649.35 684.98 641.63 684.98 643.8 697.83 651.57 697.83 649.35"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M486.73,555.57l17.24,9.93c.92,.53,.93,1.85,.02,2.4l-14.71,8.86c-2.01,1.21-4.51,1.23-6.53,.06l-15.51-8.97c-1.41-.81-1.42-2.84-.03-3.68l14.19-8.54c1.64-.99,3.68-1.01,5.34-.05Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 502.27,
    y: 564.52,
    width: 2.39,
    height: 1.92,
    transform: "translate(1006.93 1130.96) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 466.16,
    y: 563.61,
    width: 4.26,
    height: 2.25,
    transform: "translate(936.58 1129.47) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M486.73,553.46l17.24,9.93c.92,.53,.93,1.85,.02,2.4l-14.71,8.86c-2.01,1.21-4.51,1.23-6.53,.06l-15.51-8.97c-1.41-.81-1.42-2.84-.03-3.68l14.19-8.54c1.64-.99,3.68-1.01,5.34-.05Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M497.5,561.66l4.12,2.37c.22,.13,.22,.44,0,.57l-3.52,2.12c-.48,.29-1.08,.29-1.56,.01l-3.71-2.14c-.34-.19-.34-.68,0-.88l3.39-2.04c.39-.24,.88-.24,1.28-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M485.07,554.45l4.12,2.37c.22,.13,.22,.44,0,.57l-3.52,2.12c-.48,.29-1.08,.29-1.56,.01l-3.71-2.14c-.34-.19-.34-.68,0-.88l3.39-2.04c.39-.24,.88-.24,1.28-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M501.79,564.22s-2.13-5.18-7.27-8.49c-5.14-3.31-10.42-1.4-10.42-1.4v2.67s3.76-.24,6.68,1.75c2.92,1.99,5,6.31,5,6.31l6.02-.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M498.04,566.42s-2.13-5.18-7.27-8.49c-5.14-3.31-10.42-1.4-10.42-1.4l.41,.23,4.92,2.75s1.96-1.44,4.37,.22c2.91,2,2.56,4.33,2.56,4.33l5.44,2.36Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "479.74 559.31 470.8 564.74 468.46 563.4 477.42 558.01 479.74 559.31"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "482.37 561.1 480.81 562.06 479.3 561.18 480.88 560.25 482.37 561.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "480.09 562.47 478.53 563.43 477.02 562.55 478.6 561.62 480.09 562.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "477.83 563.81 476.27 564.77 474.76 563.89 476.34 562.96 477.83 563.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "475.49 565.24 473.93 566.2 472.42 565.32 474 564.39 475.49 565.24"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "485.23 562.74 483.67 563.7 482.15 562.82 483.74 561.89 485.23 562.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "482.95 564.11 481.39 565.07 479.88 564.19 481.46 563.26 482.95 564.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "480.69 565.45 479.13 566.41 477.62 565.53 479.2 564.6 480.69 565.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "478.35 566.88 476.79 567.84 475.27 566.96 476.86 566.03 478.35 566.88"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "488.13 564.41 486.57 565.38 485.06 564.49 486.64 563.57 488.13 564.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "485.85 565.78 484.29 566.74 482.78 565.86 484.36 564.94 485.85 565.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "483.59 567.12 482.03 568.09 480.52 567.2 482.1 566.28 483.59 567.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "481.25 568.56 479.69 569.52 478.18 568.63 479.76 567.71 481.25 568.56"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "490.93 566.03 489.37 566.99 487.85 566.11 489.44 565.18 490.93 566.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "488.65 567.4 487.09 568.36 485.58 567.48 487.16 566.55 488.65 567.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "486.39 568.74 484.83 569.7 483.31 568.82 484.9 567.89 486.39 568.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "484.05 570.17 482.49 571.13 480.97 570.25 482.56 569.32 484.05 570.17"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "494.37 568.03 490.53 570.36 489.02 569.48 492.88 567.18 494.37 568.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "489.83 570.74 485.93 573.13 484.41 572.25 488.34 569.89 489.83 570.74"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M513.83,578.71h0c2.42,0,4.22-1.84,5.03-3.41,.78-1.51,.92-3.02,.41-4.47-1.01-2.89-4.56-5.62-11.17-8.59-3.22-1.45-6.45-3.88-9.31-6.02-4-3.01-7.46-5.6-10.11-5.05-1.02,.21-1.86,.89-2.49,2l1.06,.6c.45-.8,1-1.26,1.68-1.4,2.11-.43,5.52,2.12,9.13,4.84,2.9,2.18,6.2,4.66,9.54,6.16,6.2,2.79,9.64,5.36,10.52,7.88,.4,1.14,.29,2.29-.34,3.52-.65,1.27-2.08,2.75-3.95,2.75h0c-2.01,0-3.96-1.72-5.64-4.97-2.48-4.79-8.58-8.3-8.83-8.45l-.6,1.05c.06,.03,6.04,3.48,8.36,7.95,2.41,4.65,4.98,5.63,6.72,5.63Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M703.24,562.64c-2.79,0-5.06,1.2-5.06,2.69s2.26,2.69,5.06,2.69,5.06-1.2,5.06-2.69-2.26-2.69-5.06-2.69Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M702.36,559.53c-.39,0-.71-.17-.71-.38v12.82h1.43v-12.82c0,.21-.32,.38-.71,.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M701.65,557.28v1.87c0-.21,.32-.38,.71-.38s.71,.17,.71,.38v-1.87h-1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M702.36,558.77c-.39,0-.71,.17-.71,.38s.32,.38,.71,.38,.71-.17,.71-.38-.32-.38-.71-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M703.08,557.28c0,.21-.32,.38-.71,.38s-.71-.17-.71-.38,.32-.38,.71-.38,.71,.17,.71,.38Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M707.45,560.88c-.38-.09-.65-.33-.61-.53l-2.97,12.47,1.39,.33,2.97-12.47c-.05,.2-.4,.3-.78,.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M707.28,558.53l-.43,1.82c.05-.2,.4-.3,.78-.2,.38,.09,.65,.33,.61,.53l.43-1.82-1.39-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M707.63,560.14c-.38-.09-.73,0-.78,.2-.05,.2,.22,.44,.61,.53,.38,.09,.73,0,.78-.2,.05-.2-.22-.44-.61-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M708.67,558.86c-.05,.2-.4,.3-.78,.2-.38-.09-.65-.33-.61-.53,.05-.2,.4-.3,.78-.2,.38,.09,.65,.33,.61,.53Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M698.66,561.46c-.38,.12-.73,.05-.79-.15l3.85,12.23,1.36-.43-3.85-12.23c.06,.2-.19,.46-.57,.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M697.3,559.54l.56,1.78c-.06-.2,.19-.46,.57-.58,.38-.12,.73-.05,.79,.15l-.56-1.78-1.36,.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M698.43,560.74c-.38,.12-.63,.38-.57,.58,.06,.2,.42,.27,.79,.15s.63-.38,.57-.58c-.06-.2-.42-.27-.79-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M698.66,559.11c.06,.2-.19,.46-.57,.58-.38,.12-.73,.05-.79-.15-.06-.2,.19-.46,.57-.58,.38-.12,.73-.05,.79,.15Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M703.24,568.02c-2.79,0-5.06-1.2-5.06-2.69v13.31h10.12v-13.31c0,1.49-2.26,2.69-5.06,2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M708.3,578.64c0,1.49-2.26,2.69-5.06,2.69s-5.06-1.2-5.06-2.69,2.26-2.69,5.06-2.69,5.06,1.2,5.06,2.69Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "723.01 590.35 706 599.99 722.84 609.73 739.84 600.07 723.01 590.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "731.12 579.35 714.12 588.98 730.96 598.72 747.96 589.06 731.12 579.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "652.85 532.66 652.85 542.28 661.19 547.36 661.19 537.6 652.85 532.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "678.16 547.65 678.16 557.27 686.51 562.36 686.51 552.59 678.16 547.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "692.79 528.14 692.79 537.77 701.14 542.85 701.14 533.09 692.79 528.14"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "634.24 540.87 625.72 535.94 635.56 530.26 644.09 535.18 634.24 540.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "644.09 535.18 644.09 540.05 634.24 545.73 634.24 540.87 644.09 535.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "625.72 535.94 625.72 540.81 634.24 545.73 634.24 540.87 625.72 535.94"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "629.81 540.6 634.24 542.99 634.24 542.41 629.81 540.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "634.24 544.56 634.24 543.98 628.99 541.39 634.24 544.56"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M625.72,536.77l5.32,3.25-5.32-2.87v-.38Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "627.72 525.49 619.19 520.57 629.04 514.88 637.56 519.81 627.72 525.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "637.56 519.81 637.56 524.67 627.72 530.35 627.72 525.49 637.56 519.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "619.19 520.57 619.19 525.43 627.72 530.35 627.72 525.49 619.19 520.57"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "623.29 525.22 627.72 527.62 627.72 527.03 623.29 525.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "627.72 529.19 627.72 528.6 622.46 526.01 627.72 529.19"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M619.19,521.39l5.32,3.25-5.32-2.87v-.38Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "729.05 572.14 704.1 586.6 720.94 596.34 745.88 581.85 729.05 572.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "719.06 580.22 712.17 584.2 725.35 591.75 732.25 587.77 719.06 580.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "720.94 579.13 720.4 579.45 733.59 586.99 734.13 586.68 720.94 579.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "722.17 578.42 721.62 578.74 734.81 586.29 735.36 585.97 722.17 578.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "723.47 577.67 722.92 577.99 736.11 585.54 736.65 585.22 723.47 577.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "724.72 576.96 724.17 577.27 737.36 584.81 737.9 584.5 724.72 576.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "725.95 576.24 725.4 576.56 738.58 584.11 739.13 583.79 725.95 576.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "727.24 575.5 726.69 575.81 739.88 583.37 740.43 583.05 727.24 575.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "710.78 585.01 710.23 585.32 723.42 592.87 723.97 592.55 710.78 585.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "729.9 573.94 727.98 575.05 741.15 582.6 743.08 581.49 729.9 573.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "704.1 586.6 704.1 587.82 720.94 597.56 720.94 596.34 704.1 586.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "745.87 581.86 720.94 596.34 720.94 597.56 745.87 583.08 745.87 581.86"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "561.36 511.44 561.36 500.81 551.12 494.64 551.12 517 570.69 528.78 570.69 517.08 561.36 511.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "570.69 517.08 572.04 516.29 572.04 527.99 570.69 528.78 570.69 517.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "561.36 500.81 562.71 500.02 562.71 510.65 561.36 511.44 561.36 500.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "562.71 510.65 561.36 511.44 570.69 517.08 572.04 516.29 562.71 510.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "552.47 493.85 551.12 494.64 561.36 500.81 562.71 500.02 552.47 493.85"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "552.42 495.42 552.42 506.43 543.59 500.02 552.42 495.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "547.55 488.52 566.48 499.92 566.48 530.16 547.55 518.63 547.55 488.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "545.83 490.23 564.76 501.63 564.76 531.87 545.83 520.34 545.83 490.23"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "552.76 516.45 552.76 505.82 542.53 499.65 542.53 522.01 562.1 533.78 562.1 522.09 552.76 516.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "562.1 522.09 571.79 516.43 571.79 528.13 562.1 533.78 562.1 522.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "552.76 505.82 554.11 505.03 554.11 515.66 552.76 516.45 552.76 505.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "554.11 515.66 552.76 516.45 562.1 522.09 563.45 521.3 554.11 515.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "543.88 498.86 542.53 499.65 552.76 505.82 554.11 505.03 543.88 498.86"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "542.53 499.65 545.83 497.72 545.83 499.22 543.78 500.4 542.53 499.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "561.5 520.79 570.22 515.78 571.51 516.59 562.71 521.73 561.5 520.79"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "547.09 512.07 554.19 508.1 554.19 538.24 547.09 542.35 547.09 512.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "549.25 517.08 552.03 515.53 552.03 531.69 549.25 533.3 549.25 517.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "547.09 513.63 554.19 509.68 554.19 511.84 547.09 515.85 547.09 513.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M549.25,537.03c0,1.02,.62,1.49,1.39,1.05,.77-.44,1.39-1.63,1.39-2.65s-.62-1.49-1.39-1.05c-.77,.44-1.39,1.63-1.39,2.65Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "547.09 512.07 547.09 542.35 524.45 529.32 524.45 499 547.09 512.07"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "525.51 498.39 547.25 510.94 552.23 508.06 530.65 495.45 531.35 495.05 554.19 508.1 547.09 512.07 524.45 499 525.51 498.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "547.25 510.94 525.51 498.39 530.65 495.45 552.23 508.06 547.25 510.94"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "536.67 517.82 543.77 513.85 543.77 544 536.67 548.1 536.67 517.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "538.83 522.84 541.61 521.28 541.61 537.44 538.83 539.05 538.83 522.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "536.67 519.39 543.77 515.43 543.77 517.59 536.67 521.6 536.67 519.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M538.83,542.78c0,1.02,.62,1.49,1.39,1.05,.77-.44,1.39-1.63,1.39-2.65s-.62-1.49-1.39-1.05c-.77,.44-1.39,1.63-1.39,2.65Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "536.67 517.82 536.67 548.1 514.03 535.07 514.03 504.75 536.67 517.82"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "515.09 504.14 536.83 516.69 541.8 513.82 520.22 501.2 520.92 500.8 543.77 513.85 536.67 517.82 514.03 504.75 515.09 504.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "536.83 516.69 515.09 504.14 520.22 501.2 541.8 513.82 536.83 516.69"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "658.7 517.01 656.19 515.54 656.19 527.23 658.7 528.7 658.7 517.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "674.47 532.21 671.96 530.74 671.96 536.29 674.47 537.76 674.47 532.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "685.44 538.61 682.92 537.14 682.92 542.69 685.44 544.16 685.44 538.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "664.01 515.67 661.5 514.21 661.5 530.29 664.01 531.76 664.01 515.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "680.11 524.96 677.59 523.49 677.59 539.57 680.11 541.04 680.11 524.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "669.01 525.18 666.49 523.71 666.49 533.21 669.01 534.68 669.01 525.18"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "726.57 598.61 704.25 611.48 680.47 597.66 702.73 584.84 726.57 598.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "724.44 598.07 704.18 609.76 682.6 597.21 702.8 585.57 724.44 598.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "726.57 597.41 704.25 605.97 680.47 592.15 702.73 583.64 726.57 597.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "704.25 605.97 704.25 611.48 680.47 597.66 680.47 592.15 704.25 605.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "684.72 596.21 702.16 606.39 702.16 608.68 684.72 598.51 684.72 596.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "681.68 592.85 683.05 593.65 683.05 599.16 681.68 598.36 681.68 592.85"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-30",
    cx: 589.17,
    cy: 514.43,
    rx: 6.19,
    ry: 3.29
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "578.95 504.7 583.03 514.88 595.14 515.3 600.05 504.7 578.95 504.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M589.54,498.16c-5.91,0-10.7,2.55-10.7,5.69s4.79,5.69,10.7,5.69,10.7-2.55,10.7-5.69-4.79-5.69-10.7-5.69Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M599.05,503.56c0-2.59-4.29-4.68-9.58-4.68s-9.58,2.1-9.58,4.68c0,.56,.24,1.09,.61,1.59,.67-2.65,4.55-5.41,12.31-4.36,2.93,.4,5.43,2.43,5.27,4.81,.61-.62,.99-1.3,.99-2.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M592.8,500.78c-7.77-1.05-11.64,1.72-12.31,4.36,1.34,1.8,4.83,3.09,8.98,3.09,3.8,0,7.05-1.09,8.6-2.65,.16-2.38-2.33-4.41-5.27-4.81Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M588.19,489.27c-.09-.36-.16-2.28,.5-4.54,.75-2.59,2.31-3.43,2.31-3.43,0,0-.6,2.4-.25,4.15,.35,1.75,.69,3.81,.69,3.81,0,0-2.25,3.89-3.25,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M585.1,482.98s1.18,4.44,.87,7.52,3.71,4.53,4.49,2.35c1.19-3.35-2.15-7.36-5.37-9.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M589.45,492.85c-.13-.43,.07-3.52,1.01-5.77,.94-2.26,3.2-3.68,3.2-3.68,0,0-.92,2.14-.58,4.16s1.07,4.43,1.07,4.43l-1.9,4.62-2.79-3.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M582.54,481.31s-.34,6.02,.71,9.11c1.05,3.09,4.17,7.82,4.17,7.82l2.03-4.06s-2.73-3.63-4.35-6.62c-1.63-2.99-2.55-6.25-2.55-6.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M581.05,493.84s-.74-3.46-1.29-6.29c-.55-2.82-.68-4.58-.68-4.58,0,0,3.55,4.56,4.8,6.79,1.25,2.24,3.54,8.1,3.54,8.1l-2.3,3.75-4.07-7.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M596.84,493.84s.74-3.46,1.29-6.29c.55-2.82,.68-4.58,.68-4.58,0,0-3.55,4.56-4.8,6.79-1.25,2.24-3.54,8.1-3.54,8.1l2.3,3.75,4.07-7.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M585.12,501.62c-.26-.39,1.6-7.05,2.3-8.93,.7-1.88,3.13-2.57,4.24,0,1.11,2.57,2.49,9.21,2.49,9.21,0,0-4.51,6.57-9.02-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M573.78,489.77s2.85-.28,4.27,3.11c1.41,3.39,3.09,10.55,6.71,13.2,2,1.46,6.91,.71,6.91,.71,0,0-4.69-7.37-8.11-12.04-3.42-4.67-6.6-7.13-9.77-4.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M605.3,489.77s-2.85-.28-4.27,3.11c-1.41,3.39-2.93,10.43-6.38,13.29-2.45,2.03-7.77,1.13-7.77,1.13,0,0,5.23-7.88,8.65-12.55,3.42-4.67,6.6-7.13,9.77-4.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M587.42,492.85s1.05,.75,1.49,1.54c.21,.38,.78,1.12,.78,1.12,0,0,.46-1.15,.82-1.6,.42-.52,1.14-1.07,1.14-1.07l-1.88,4.23s-1.28-1.67-1.56-2.38c-.38-.97-.8-1.84-.8-1.84Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M627.82,628.04l.77,7.54s3.56,3.81,8.49,.48c2.94-1.98,8.1-5.07,9.74-8.43,1.64-3.37,1.12-5.38-.31-6.27-1.43-.9-8.68,3.33-8.68,3.33l-10.01,3.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M638.39,622.08s-4.02-23.93-5.37-28.39c-1.88-6.2-3.39-8.71-7.39-10.31-2.36-.94-7.82-.19-13.47,1.03-.72,5.08-.03,10.81,2.7,15.17,1.92-1.04,3.81-2.07,5.6-3.05,.77,1.92,1.47,4.18,1.92,6.79,.68,3.87,1.81,9.95,2,13.96,.19,4.01,.57,9.95,.57,9.95,0,0,4.17,3.49,9.4,1.45,5.14-2.01,4.05-6.61,4.05-6.61Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M608.82,647.54h0c-1.83,0-3.33-1.5-3.33-3.33v-30.7c0-1.83,1.5-3.33,3.33-3.33h0c1.83,0,3.33,1.5,3.33,3.33v30.7c0,1.83-1.5,3.33-3.33,3.33Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 608.82,
    cy: 614.99,
    rx: 21.05,
    ry: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 587.78,
    y: 612.87,
    width: 42.09,
    height: 2.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M629.87,612.87c0,6.18-9.42,11.2-21.05,11.2s-21.05-5.01-21.05-11.2,9.42-11.19,21.05-11.19,21.05,5.01,21.05,11.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M628.87,611.66c0,5.89-8.98,10.67-20.05,10.67s-20.05-4.78-20.05-10.67,8.98-10.67,20.05-10.67,20.05,4.78,20.05,10.67Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "589.83 604.81 588.77 611.66 628.87 611.66 627.81 604.81 589.83 604.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M628.09,606.5c0,5.66-8.63,10.25-19.27,10.25s-19.27-4.59-19.27-10.25,8.63-10.25,19.27-10.25,19.27,4.59,19.27,10.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M628.09,606.5c0,5.66-8.63,10.25-19.27,10.25s-19.27-4.59-19.27-10.25,8.63-10.25,19.27-10.25,19.27,4.59,19.27,10.25Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M589.09,663.37c0,2.06-1.25,4.46-2.8,5.35-1.55,.89-2.8-.05-2.8-2.12s1.25-4.46,2.8-5.35c1.55-.89,2.8,.06,2.8,2.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "590.15 662.3 587.99 661.04 584.46 668.87 586.72 670.17 590.15 662.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M591.36,664.68c0,2.06-1.25,4.46-2.8,5.35-1.55,.89-2.8-.05-2.8-2.12s1.25-4.46,2.8-5.35c1.55-.89,2.8,.05,2.8,2.12Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M584.67,662.1h0c-.64-1.12-.26-2.54,.85-3.19l44.26-25.55c1.12-.64,2.54-.26,3.19,.85h0c.64,1.12,.26,2.54-.85,3.19l-44.26,25.55c-1.12,.64-2.54,.26-3.19-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M629.79,662.95l-44.26-25.55c-1.12-.64-1.5-2.07-.85-3.19h0c.64-1.12,2.07-1.5,3.19-.85l44.26,25.55c1.12,.64,1.5,2.07,.85,3.19h0c-.64,1.12-2.07,1.5-3.19,.85Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M632.49,637.8c0,2.06-1.25,4.46-2.8,5.35-1.55,.89-2.8-.06-2.8-2.12s1.25-4.46,2.8-5.35c1.55-.89,2.8,.06,2.8,2.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "633.55 636.74 631.38 635.47 627.86 643.3 630.11 644.6 633.55 636.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M634.75,639.11c0,2.06-1.25,4.46-2.8,5.35-1.55,.89-2.8-.05-2.8-2.12s1.25-4.46,2.8-5.35,2.8,.05,2.8,2.12Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M629.76,664.02c0,2.06-1.25,4.46-2.8,5.35-1.55,.89-2.8-.06-2.8-2.12s1.25-4.46,2.8-5.35c1.55-.89,2.8,.05,2.8,2.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "630.82 662.96 628.65 661.69 625.13 669.53 627.38 670.82 630.82 662.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M632.02,665.33c0,2.06-1.25,4.46-2.8,5.35-1.55,.89-2.8-.06-2.8-2.12s1.25-4.46,2.8-5.35c1.55-.89,2.8,.06,2.8,2.12Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M587.32,639.26c0,2.06-1.25,4.46-2.8,5.35s-2.8-.06-2.8-2.12,1.25-4.46,2.8-5.35c1.55-.89,2.8,.06,2.8,2.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "588.38 638.19 586.22 636.92 582.7 644.76 584.95 646.06 588.38 638.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M589.59,640.56c0,2.06-1.25,4.46-2.8,5.35-1.55,.89-2.8-.06-2.8-2.12s1.25-4.46,2.8-5.35c1.55-.89,2.8,.06,2.8,2.12Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M639.17,634.83l.77,7.54s3.56,3.81,8.49,.48c2.94-1.98,8.1-5.07,9.74-8.43,1.64-3.37,1.13-5.38-.31-6.27s-8.68,3.33-8.68,3.33l-10.01,3.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M580.8,574.94s2.14,2.33,8.95-1.07c7.92-3.96,12.52-4.91,12.52-4.91l-1.28-5.97-13.14,.75-7.05,11.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M598.89,543.28s-4.54-1.76-7.88,1.12c-3.35,2.88-9.65,18.11-10.76,20.17-1.11,2.06-4.12,6.46,.16,10.1,3.5,2.98,7.79-3.65,9.18-6.02,1.75-2.99,6.6-12.19,6.6-12.19l2.69-13.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M608.01,520.75c1.05,.73,5.08-.74,6.22,7.86,.76,5.78-.11,10.26-1.75,11.76-.68,.63-4.58,1.21-4.58,1.21l.12,6.44s-3.78,1.49-7.4,0l-3.62-1.49s1.41-2.44,1.18-6.66c-.29-5.24-2.15-12.69-.84-15.47,2.37-5.01,7.84-5.62,10.68-3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M649.73,628.86s-4.02-23.93-5.37-28.39c-1.88-6.2-3.39-8.7-7.39-10.31-5.78-2.32-30.24,5.57-30.24,5.57l-17.63,.92s-.9,7.16,4.15,10.81c5.06,3.65,17.11,7.27,25.83,2.7,4.16-2.18,8.71-4.65,12.72-6.84,.77,1.92,1.47,4.18,1.92,6.79,.68,3.87,1.81,9.95,2,13.96,.19,4.01,.57,9.95,.57,9.95,0,0,4.17,3.49,9.4,1.45,5.14-2.01,4.05-6.61,4.05-6.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M608.56,604.38c3.54-.95,5.97-4.61,8.35-7.52,2.61-3.2,3.97-10.91,.6-14.08-.42,.02-4.1-6.47,.27-15.8,2.14-4.56-2.71-12.84-4.07-15.82-1.36-2.98-5.71-4.79-5.71-4.79l-13.2-1.96s-5.77,10.05-6.54,16.04c-.54,4.2-.11,11.96,.12,22.62,.16,7.21-4.02,11.66-.97,14.8,4.63,4.78,15.23,8.1,21.16,6.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M594.67,545.06s1.86,2.59,5.54,3.76c3.68,1.17,7.01,.95,10.63-.84,.02-2.38-2.89-3.45-2.89-3.45,0,0-5.28,1.55-8.39-.87-4.4-3.43-4.89,1.4-4.89,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M612.71,551.16c-2.13-.2-4.35,3.67-4.13,8.52,.28,6.2,13.4,20.72,13.4,20.72,4.35,2.57,17.23-5.4,20.37-5.77,3.15-.37,7.16-3.09,8.82-5.18,1.58-1.97-4.47-4.69-7.45-2.78-2.25,1.44-1.67,3.25-3.47,3.52-8.05,1.19-15.41,3.38-15.41,3.38,0,0-8.05-22.03-12.13-22.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M637.5,570.22s2.11-.43,2.79-.65c2.19-.72,4.74,3.33,3.86,4.64s-4.75,2.65-4.75,2.65l-1.9-6.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M611.8,550.11c-2.25-.74-4.66,4.82-3.98,10.33,.59,4.75,5.04,11.77,7.62,15.87,1.5,2.38,4.97,7.6,10.05,6.33,6.7-1.67,12.03-2.04,15.38-4.99,2.19-1.93,2.95-6.8-2.92-7.87-3.09-.56-10.89,2.41-10.89,2.41,0,0-7.01-19.35-15.25-22.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M611.52,530.89c.43-1.44,1.42-4.79,1.66-6.14,.29-1.57,.37-3.9-1.77-6.12s-9.57-2.94-12.26-1.39c-2.69,1.55-8.4,4.39-6.41,13.66,1.61,7.49,3.18,8.33,5.44,10.09,1.98,1.54,5.46,1.92,5.46,1.92,0,0,1.94-1.4,2.29-4.24,.11-.89,0-3.6,0-3.6,0,0-1.98-3.92-.45-5.31,1.63-1.49,3.3,.88,3.69,1.83,1.34,3.35,.68,9.66,.68,9.66,0,0,1.99,1.28,3.96,.79,1.09-.27,.13-4.47,.13-4.47,0,0-2.1-1.05-2.42-6.66Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M598.89,609.01v-24.09c0-8.44-5.18-18.33-11.5-21.98l-6-3.47c-6.33-3.65-11.5,.26-11.5,8.7v24.09l29.01,16.75Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "573.74 558.96 568.82 561.88 573.22 564.8 573.74 558.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "594.1 611.85 598.89 609.01 593.22 603.43 594.1 611.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M594.1,611.85v-24.09c0-8.44-5.18-18.33-11.5-21.98l-6-3.47c-6.33-3.65-11.5,.26-11.5,8.7v24.09l29.01,16.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M575.99,585.69c0,5.1-.51,16.06-.43,18.6,.17,5.51-3.24,22.8,18.72,23.41,2.2,.06,11.18-.52,12.77-1.56-3.61-.17-9.81-1.51-14.75-4.22-14.26-1.31-12.73-12.21-12.53-19.01,.22-7.94,.03-14.41,0-17.07-.03-3.43-3.77-3.59-3.77-.15Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "501.36 291.89 501.36 315.07 481.26 327.31 481.26 303.8 501.36 291.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "530.54 257.05 530.54 266.67 522.19 271.76 522.19 261.99 530.54 257.05"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "497.86 282.91 517.07 271.76 517.07 301.59 497.86 312.69 497.86 282.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "500.34 285.22 514.97 276.72 514.97 278.34 500.34 286.79 500.34 285.22"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M511.68,285.64c1.43,.82,2.24,2.68,2.24,5.09,0,4.4-2.7,9.54-6.02,11.45-.08,.05-.16,.06-.25,.11v-16.46c1.46-.77,2.88-.85,4.02-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M503.64,302.49c-1.43-.82-2.24-2.68-2.24-5.09,0-4.4,2.7-9.54,6.02-11.45,.08-.05,.16-.07,.25-.11v16.46c-.79,.41-1.57,.65-2.29,.65-.62,0-1.2-.15-1.73-.45Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "757.25 547.04 757.25 558.1 737.85 546.94 737.85 535.84 757.25 547.04"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "739.38 539.2 755.77 548.67 755.77 549.81 739.38 540.31 739.38 539.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "739.38 542.16 755.77 551.63 755.77 552.77 739.38 543.27 739.38 542.16"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "722.71 530.53 722.71 540.15 731.06 545.23 731.06 535.47 722.71 530.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "755.11 554.85 755.11 564.48 763.46 569.56 763.46 559.8 755.11 554.85"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "735.54 521.55 735.54 532.61 716.15 521.44 716.15 510.35 735.54 521.55"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "717.67 513.7 734.06 523.17 734.06 524.32 717.67 514.81 717.67 513.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "717.67 516.66 734.06 526.13 734.06 527.28 717.67 517.77 717.67 516.66"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "682.01 388.02 682.01 413.96 701.41 402.79 701.41 376.82 682.01 388.02"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "699.89 380.17 683.49 389.64 683.49 390.79 699.89 381.29 699.89 380.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "699.89 383.13 683.49 392.6 683.49 393.75 699.89 384.25 699.89 383.13"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "699.89 386.52 683.49 396 683.49 397.14 699.89 387.64 699.89 386.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "699.89 389.48 683.49 398.96 683.49 400.1 699.89 390.6 699.89 389.48"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "699.89 392.63 683.49 402.11 683.49 403.25 699.89 393.75 699.89 392.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "699.89 395.59 683.49 405.07 683.49 406.21 699.89 396.71 699.89 395.59"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "655.55 418.37 655.55 444.31 674.95 433.14 674.95 407.17 655.55 418.37"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "673.43 410.52 657.03 419.99 657.03 421.13 673.43 411.63 673.43 410.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "673.43 413.48 657.03 422.95 657.03 424.09 673.43 414.59 673.43 413.48"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "673.43 416.87 657.03 426.35 657.03 427.49 673.43 417.99 673.43 416.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "673.43 419.83 657.03 429.31 657.03 430.45 673.43 420.95 673.43 419.83"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "673.43 422.98 657.03 432.46 657.03 433.6 673.43 424.1 673.43 422.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "673.43 425.94 657.03 435.42 657.03 436.56 673.43 427.06 673.43 425.94"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "683.63 384.57 667.6 393.83 667.6 400.9 683.63 391.67 683.63 384.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "713.78 376.29 713.78 385.91 705.43 391 705.43 381.23 713.78 376.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "686.61 407.92 686.61 417.55 678.26 422.63 678.26 412.87 686.61 407.92"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "606.8 453.29 606.8 462.91 615.14 467.99 615.14 458.23 606.8 453.29"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "641.51 462.29 613.72 446.15 613.72 489.33 641.51 505.39 641.51 462.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "623.36 465.59 620.63 463.98 620.63 487.31 623.36 488.9 623.36 465.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "628.2 463.91 625.47 462.3 625.47 490.19 628.2 491.77 628.2 463.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "633.29 479.08 630.55 477.47 630.55 493.27 633.29 494.85 633.29 479.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "638.46 497.37 618.93 486.09 618.93 455.16 617.95 454.5 617.95 486.66 638.46 498.52 638.46 497.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "638.46 489.03 634.51 486.74 634.51 487.88 638.46 490.17 638.46 489.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "638.46 481.86 634.51 479.57 634.51 480.72 638.46 483 638.46 481.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "638.46 474.69 634.51 472.41 634.51 473.55 638.46 475.83 638.46 474.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "638.46 467.52 634.51 465.24 634.51 466.38 638.46 468.67 638.46 467.52"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "396.85 336.37 396.85 367.79 369.59 384.4 369.59 352.51 396.85 336.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "373.61 378.99 373.03 378.79 378.97 361.85 382.9 365.95 386.46 353.6 389.82 357.16 393.52 345.28 394.1 345.46 390.09 358.34 386.75 354.8 383.19 367.13 379.21 362.99 373.61 378.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "373.01 379.43 373.01 352.78 373.62 352.78 373.62 378.35 395.4 365.08 395.72 365.6 373.01 379.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "375.41 350.84 353.67 363.39 353.67 372.99 375.41 360.47 375.41 350.84"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "459.98 364.95 459.98 374.57 468.33 379.66 468.33 369.89 459.98 364.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "455.8 354.64 419.8 333.77 419.8 362.71 455.8 383.51 455.8 354.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "451.16 377.77 422.94 361.46 422.94 361.33 422.98 339.68 423.43 339.68 423.39 361.2 451.39 377.38 451.16 377.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "449.23 374.49 449.23 384.11 457.58 389.19 457.58 379.43 449.23 374.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "428.36 349.56 425.84 348.1 425.84 359.79 428.36 361.26 428.36 349.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "444.13 364.77 441.61 363.3 441.61 368.85 444.13 370.32 444.13 364.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "433.67 348.23 431.15 346.76 431.15 362.85 433.67 364.32 433.67 348.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "449.76 357.52 447.25 356.05 447.25 372.13 449.76 373.6 449.76 357.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "438.66 357.73 436.15 356.27 436.15 365.77 438.66 367.24 438.66 357.73"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "788.12 354.84 785.01 353.05 785.01 180.34 788.12 182.14 788.12 354.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "838.2 153.39 788.12 182.14 788.12 354.84 835.09 327.88 835.09 327.89 836.93 326.83 836.93 326.83 836.93 326.83 838.2 326.09 838.2 153.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "785.01 180.34 788.12 182.14 838.2 153.39 834.96 151.45 785.01 180.34"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "788.12 296.25 834.51 269.32 902.34 308.38 857.26 336.29 788.12 296.25"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M800.52,297.79l13.19,7.61c1.03,.59,2.84,.52,4.02-.17l22.61-13.06c1.19-.68,1.32-1.73,.29-2.32l-13.19-7.61c-1.03-.59-2.84-.52-4.02,.17l-22.61,13.06c-1.19,.68-1.32,1.73-.29,2.32Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 840.01,
    y: 289.29,
    width: 1.31,
    height: 1.61,
    transform: "translate(1681.33 580.19) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 799.83,
    y: 295.34,
    width: 1.31,
    height: 1.35,
    transform: "translate(1600.96 592.04) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M800.52,296.32l13.19,7.61c1.03,.59,2.84,.52,4.02-.17l22.61-13.06c1.19-.68,1.32-1.73,.29-2.32l-13.19-7.61c-1.03-.59-2.84-.52-4.02,.17l-22.61,13.06c-1.19,.68-1.32,1.73-.29,2.32Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "837.13 289.38 824.9 282.29 803.19 295.33 815.4 302.41 837.13 289.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M837.47,286.56l-3.65,2.27-7.99-4.82,3.47-2.17s1.07,.65,1.76,.99c.69,.34,1.62-1.01,3.78,.13,2.46,1.3-.07,2.04,.73,2.49,.59,.33,1.9,1.1,1.9,1.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "841.67 294.77 822.86 305.66 836.37 313.41 855.23 302.55 841.67 294.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "832.38 301.54 825.53 305.54 836.37 311.74 843.27 307.77 832.38 301.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "835.12 299.98 834.08 300.6 844.92 306.8 846.01 306.21 835.12 299.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "837.35 298.68 836.31 299.3 847.15 305.5 848.24 304.91 837.35 298.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "836.37 313.41 836.37 317.59 855.23 306.72 855.23 302.55 836.37 313.41"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "822.86 305.66 822.86 306.64 835.6 313.94 835.6 316.31 822.86 309.01 822.86 309.84 836.37 317.59 836.37 313.41 822.86 305.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "835.6 313.94 822.86 306.64 822.86 309.01 835.6 316.31 835.6 313.94"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "841.67 289.52 822.86 300.42 836.37 308.16 855.23 297.3 841.67 289.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "832.38 296.29 825.53 300.29 836.37 306.49 843.27 302.52 832.38 296.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "835.12 294.73 834.08 295.35 844.92 301.55 846.01 300.96 835.12 294.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "837.35 293.43 836.31 294.05 847.15 300.26 848.24 299.66 837.35 293.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "836.37 308.16 836.37 312.34 855.23 301.48 855.23 297.3 836.37 308.16"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "822.86 300.42 822.86 301.39 835.6 308.69 835.6 311.07 822.86 303.76 822.86 304.59 836.37 312.34 836.37 308.16 822.86 300.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "835.6 308.69 822.86 301.39 822.86 303.76 835.6 311.07 835.6 308.69"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "857.38 303.87 838.57 314.76 852.08 322.51 870.94 311.65 857.38 303.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "848.09 310.63 841.24 314.64 852.08 320.84 858.98 316.87 848.09 310.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "850.82 309.07 849.78 309.7 860.63 315.9 861.71 315.31 850.82 309.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "853.05 307.78 852.02 308.4 862.86 314.6 863.94 314.01 853.05 307.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "852.08 322.51 852.08 326.69 870.94 315.82 870.94 311.65 852.08 322.51"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "838.57 314.76 838.57 315.74 851.3 323.04 851.3 325.41 838.57 318.11 838.57 318.94 852.08 326.69 852.08 322.51 838.57 314.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "851.3 323.04 838.57 315.74 838.57 318.11 851.3 325.41 851.3 323.04"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "857.38 298.96 838.57 309.85 852.08 317.6 870.94 306.73 857.38 298.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "848.09 305.72 841.24 309.72 852.08 315.93 858.98 311.95 848.09 305.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "850.82 304.16 849.78 304.78 860.63 310.99 861.71 310.39 850.82 304.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "853.05 302.86 852.02 303.49 862.86 309.69 863.94 309.09 853.05 302.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "852.08 317.6 852.08 321.77 870.94 310.91 870.94 306.73 852.08 317.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "838.57 309.85 838.57 310.82 851.3 318.13 851.3 320.5 838.57 313.2 838.57 314.03 852.08 321.77 852.08 317.6 838.57 309.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "851.3 318.13 838.57 310.82 838.57 313.2 851.3 320.5 851.3 318.13"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "788.12 299.3 788.12 354.77 821.17 373.88 857.26 394.88 857.26 339.17 788.12 299.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "857.26 339.41 788.12 299.41 788.12 296.24 857.26 336.29 857.26 339.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "788.12 260.36 834.51 233.43 902.34 272.49 857.26 300.4 788.12 260.36"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "829.77 250.99 822.67 247.02 822.67 277.17 829.77 281.27 829.77 250.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "827.61 256.01 824.83 254.45 824.83 270.62 827.61 272.22 827.61 256.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "829.77 252.56 822.67 248.6 822.67 250.76 829.77 254.77 829.77 252.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M827.61,275.95c0,1.02-.62,1.49-1.39,1.05s-1.39-1.63-1.39-2.65,.62-1.49,1.39-1.05c.77,.44,1.39,1.63,1.39,2.65Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "829.77 250.99 829.77 281.27 852.41 268.24 852.41 237.92 829.77 250.99"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "851.35 237.31 829.61 249.86 824.64 246.99 846.22 234.37 845.52 233.97 822.67 247.02 829.77 250.99 852.41 237.92 851.35 237.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "829.61 249.86 851.35 237.31 846.22 234.37 824.64 246.99 829.61 249.86"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "841.09 257.62 833.99 253.65 833.99 283.8 841.09 287.9 841.09 257.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "838.93 262.64 836.15 261.09 836.15 277.25 838.93 278.85 838.93 262.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "841.09 259.19 833.99 255.23 833.99 257.4 841.09 261.41 841.09 259.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M838.93,282.58c0,1.02-.62,1.49-1.39,1.05-.77-.44-1.39-1.63-1.39-2.65s.62-1.49,1.39-1.05c.77,.44,1.39,1.63,1.39,2.65Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "841.09 257.62 841.09 287.9 863.74 274.87 863.74 244.55 841.09 257.62"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "862.67 243.94 840.94 256.5 835.96 253.62 857.54 241.01 856.84 240.61 833.99 253.65 841.09 257.62 863.74 244.55 862.67 243.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "840.94 256.5 862.67 243.94 857.54 241.01 835.96 253.62 840.94 256.5"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "852.6 264.26 845.49 260.29 845.49 290.43 852.6 294.54 852.6 264.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "850.43 269.27 847.65 267.72 847.65 283.88 850.43 285.49 850.43 269.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "852.6 265.82 845.49 261.87 845.49 264.03 852.6 268.04 852.6 265.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M850.43,289.21c0,1.02-.62,1.49-1.39,1.05-.77-.44-1.39-1.63-1.39-2.65s.62-1.49,1.39-1.05c.77,.44,1.39,1.63,1.39,2.65Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "852.6 264.26 852.6 294.54 875.24 281.5 875.24 251.18 852.6 264.26"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "874.17 250.58 852.44 263.13 847.46 260.25 869.04 247.64 868.34 247.24 845.49 260.29 852.6 264.26 875.24 251.18 874.17 250.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "852.44 263.13 874.17 250.58 869.04 247.64 847.46 260.25 852.44 263.13"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "857.26 303.51 788.12 263.52 788.12 260.35 857.26 300.4 857.26 303.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "788.12 221.89 834.51 194.96 902.34 234.02 857.26 261.93 788.12 221.89"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "802.49 195.62 795.39 191.65 795.39 221.8 802.49 225.9 802.49 195.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "800.33 200.64 797.55 199.09 797.55 215.25 800.33 216.85 800.33 200.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "802.49 197.19 795.39 193.23 795.39 195.4 802.49 199.41 802.49 197.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M800.33,220.58c0,1.02-.62,1.49-1.39,1.05-.77-.44-1.39-1.63-1.39-2.65s.62-1.49,1.39-1.05c.77,.44,1.39,1.63,1.39,2.65Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "802.49 195.62 802.49 225.9 825.13 212.87 825.13 182.55 802.49 195.62"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "824.07 181.94 802.33 194.5 797.36 191.62 818.94 179.01 818.24 178.61 795.39 191.65 802.49 195.62 825.13 182.55 824.07 181.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "802.33 194.5 824.07 181.94 818.94 179.01 797.36 191.62 802.33 194.5"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "813.99 202.25 806.89 198.28 806.89 228.43 813.99 232.54 813.99 202.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "811.83 207.27 809.05 205.72 809.05 221.88 811.83 223.49 811.83 207.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "813.99 203.82 806.89 199.87 806.89 202.03 813.99 206.04 813.99 203.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M811.83,227.21c0,1.02-.62,1.49-1.39,1.05-.77-.44-1.39-1.63-1.39-2.65s.62-1.49,1.39-1.05c.77,.44,1.39,1.63,1.39,2.65Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "813.99 202.25 813.99 232.54 836.64 219.5 836.64 189.18 813.99 202.25"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "835.57 188.57 813.84 201.13 808.86 198.25 830.44 185.64 829.74 185.24 806.89 198.28 813.99 202.25 836.64 189.18 835.57 188.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "813.84 201.13 835.57 188.57 830.44 185.64 808.86 198.25 813.84 201.13"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "842.26 218.75 817.31 233.2 834.15 242.95 859.09 228.46 842.26 218.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "832.27 226.83 825.38 230.81 838.55 238.35 845.45 234.38 832.27 226.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "834.15 225.74 833.6 226.05 846.79 233.6 847.34 233.29 834.15 225.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "835.38 225.03 834.83 225.34 848.02 232.9 848.56 232.58 835.38 225.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "823.99 231.61 823.44 231.93 836.63 239.47 837.17 239.16 823.99 231.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "822.49 232.47 820.57 233.58 833.75 241.14 835.68 240.02 822.49 232.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "817.31 233.2 817.31 234.43 834.15 244.17 834.15 242.95 817.31 233.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "859.07 228.47 834.15 242.95 834.15 244.17 859.07 229.69 859.07 228.47"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "842.26 216.25 817.31 230.71 834.15 240.45 859.09 225.96 842.26 216.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "832.27 224.33 825.38 228.31 838.55 235.86 845.45 231.88 832.27 224.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "834.15 223.24 833.6 223.56 846.79 231.1 847.34 230.79 834.15 223.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "835.38 222.53 834.83 222.85 848.02 230.4 848.56 230.08 835.38 222.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "823.99 229.12 823.44 229.43 836.63 236.98 837.17 236.67 823.99 229.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "822.49 229.98 820.57 231.09 833.75 238.64 835.68 237.53 822.49 229.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "817.31 230.71 817.31 231.93 834.15 241.67 834.15 240.45 817.31 230.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "859.07 225.97 834.15 240.45 834.15 241.67 859.07 227.19 859.07 225.97"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "842.26 213.74 817.31 228.2 834.15 237.94 859.09 223.45 842.26 213.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "832.27 221.82 825.38 225.8 838.55 233.35 845.45 229.37 832.27 221.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "834.15 220.73 833.6 221.05 846.79 228.59 847.34 228.28 834.15 220.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "835.38 220.02 834.83 220.34 848.02 227.89 848.56 227.57 835.38 220.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "823.99 226.61 823.44 226.92 836.63 234.47 837.17 234.15 823.99 226.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "822.49 227.47 820.57 228.58 833.75 236.13 835.68 235.02 822.49 227.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "817.31 228.2 817.31 229.42 834.15 239.16 834.15 237.94 817.31 228.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "859.07 223.46 834.15 237.94 834.15 239.16 859.07 224.68 859.07 223.46"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "857.26 265.05 788.12 225.06 788.12 221.89 857.26 261.93 857.26 265.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "788.12 182.14 838.2 153.39 907.21 193.25 857.26 222.19 788.12 182.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "857.26 225.3 788.12 185.31 788.12 182.14 857.26 222.19 857.26 225.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "820.65 318.03 820.65 373.58 821.51 374.06 821.51 318.5 820.65 318.03"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "860.36 396.67 857.26 394.88 857.26 222.14 860.36 223.94 860.36 396.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "910.45 195.19 860.36 223.94 860.36 396.67 907.34 369.71 907.34 369.72 909.18 368.66 909.18 368.66 909.18 368.66 910.45 367.92 910.45 195.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "857.26 222.14 860.36 223.94 910.45 195.19 907.21 193.25 857.26 222.14"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "824.87 340.94 824.87 355.89 827.19 357.19 827.19 342.31 824.87 340.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "814.85 335.13 814.85 350.08 817.17 351.38 817.17 336.5 814.85 335.13"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M814.39,264.37c0,1.82-2.77,3.29-6.19,3.29s-6.19-1.47-6.19-3.29,2.77-3.29,6.19-3.29,6.19,1.47,6.19,3.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "797.99 253.4 802.08 264.79 814.33 264.96 819.09 253.4 797.99 253.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M808.57,246.86c-5.91,0-10.7,2.55-10.7,5.69s4.79,5.69,10.7,5.69,10.7-2.55,10.7-5.69-4.79-5.69-10.7-5.69Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M818.09,252.26c0-2.59-4.29-4.68-9.58-4.68s-9.58,2.1-9.58,4.68c0,.56,.24,1.09,.61,1.59,.67-2.65,4.55-5.41,12.31-4.36,2.93,.4,5.43,2.43,5.27,4.81,.61-.62,.99-1.3,.99-2.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M811.84,249.49c-7.77-1.05-11.64,1.72-12.31,4.36,1.34,1.8,4.83,3.09,8.98,3.09,3.8,0,7.05-1.09,8.6-2.65,.16-2.38-2.33-4.41-5.27-4.81Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M805.15,252.93s-3.33-2.38-6.61-.79c-3.27,1.6-2.1,5.39-1.11,7.68,.98,2.3,1.41,4.6,0,5.99-1.41,1.39-6.16,2.99-3.81,5.73,1.21,1.41,4.36,3.43,2.54,5.82-1.16,1.53-.7,5.33-.7,5.33,0,0-1.86-2.17-.63-4.81,.9-1.92,.89-3.05-1.01-4.83-1.9-1.78-3.13-4.19-.7-5.92,2.44-1.73,4.81-2.13,4.06-4.51-.75-2.38-2.6-7.68-.96-10.05,2.19-3.15,8.31-2.91,9.59-.45,.59,1.13-.25,1.23-.68,.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M796.07,257.26s-1.11,1.04-1.89,2.33c-.79,1.29,.27,3.04,.27,3.04,0,0,1.01-.85,1.23-1.86,.22-1.01,.39-3.51,.39-3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M794.39,272.81s-1.11,1.04-1.89,2.33c-.79,1.29,.27,3.04,.27,3.04,0,0,1.01-.85,1.23-1.86,.22-1.01,.39-3.51,.39-3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M794.87,267.28s-1.02-1.13-2.29-1.94c-1.27-.81-3.04,.2-3.04,.2,0,0,.83,1.03,1.84,1.27,1.01,.25,3.5,.47,3.5,.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M794.44,272.89s1.36-.68,2.84-.98,2.76,1.29,2.76,1.29c0,0-1.15,.66-2.17,.52-1.03-.14-3.43-.83-3.43-.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M798.39,251.37s-1.36-.68-2.84-.98-2.76,1.29-2.76,1.29c0,0,1.15,.66,2.17,.52,1.03-.14,3.43-.83,3.43-.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M796.53,253.47s1.11,1.04,1.89,2.33c.79,1.29-.27,3.04-.27,3.04,0,0-1.01-.85-1.23-1.86s-.39-3.51-.39-3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M796.72,265.37s1.11,1.04,1.89,2.33c.79,1.29-.27,3.04-.27,3.04,0,0-1.01-.85-1.23-1.86-.22-1.01-.39-3.51-.39-3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M796.07,275.98s1.11,1.04,1.89,2.33c.79,1.29-.27,3.04-.27,3.04,0,0-1.01-.85-1.23-1.86-.22-1.01-.39-3.51-.39-3.51Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M809.28,254.03c.29,2.97,1.18,5.82,.2,8.12-.98,2.3-1.41,4.6,0,5.99,1.41,1.39,6.16,2.99,3.81,5.73-1.21,1.41-4.36,3.43-2.54,5.82,1.16,1.53,.7,5.33,.7,5.33,0,0,1.86-2.17,.63-4.81-.9-1.92-.89-3.05,1.01-4.83,1.9-1.78,3.13-4.19,.7-5.92-2.44-1.73-4.81-2.13-4.06-4.51,.75-2.38,2.2-7.44,.96-10.05-.9-1.88,.45-3.62,1.85-2.96,1.12-1.73-3.65-2.13-3.24,2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M810.83,259.59s1.11,1.04,1.89,2.33c.79,1.29-.27,3.04-.27,3.04,0,0-1.01-.85-1.23-1.86s-.39-3.51-.39-3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M812.52,275.14s1.11,1.04,1.89,2.33c.79,1.29-.27,3.04-.27,3.04,0,0-1.01-.85-1.24-1.86-.22-1.01-.39-3.51-.39-3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M812.04,269.61s1.02-1.13,2.29-1.94c1.27-.81,3.04,.2,3.04,.2,0,0-.83,1.03-1.84,1.27-1.01,.25-3.5,.47-3.5,.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M812.47,275.22s-1.36-.68-2.84-.98c-1.48-.3-2.76,1.29-2.76,1.29,0,0,1.15,.66,2.17,.52,1.03-.14,3.43-.83,3.43-.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M810.42,256.09s-1.38,.64-2.53,1.62c-1.15,.98-.7,2.97-.7,2.97,0,0,1.23-.49,1.75-1.38,.53-.89,1.47-3.21,1.47-3.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M810.19,267.7s-1.11,1.04-1.89,2.33c-.79,1.29,.27,3.04,.27,3.04,0,0,1.01-.85,1.24-1.86,.22-1.01,.39-3.51,.39-3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M810.83,278.31s-1.11,1.04-1.89,2.33c-.79,1.29,.27,3.04,.27,3.04,0,0,1.01-.85,1.23-1.86s.39-3.51,.39-3.51Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M809.49,253.75s-2.47-.69-4.5,2.25c-2.07,3-1.36,5.78-.38,8.08,.98,2.3,1.41,4.6,0,5.99-1.41,1.39-6.16,2.99-3.81,5.73,1.21,1.41,4.36,3.43,2.54,5.82-1.16,1.53-.7,5.33-.7,5.33,0,0-1.86-2.17-.63-4.81,.9-1.92,.89-3.05-1.01-4.83-1.9-1.78-3.13-4.19-.7-5.92,2.44-1.73,4.81-2.13,4.06-4.51-.75-2.38-2.23-7.46-.96-10.05,2.02-4.1,5.35-4.83,6.35-3.82,.45,.46,.34,.73-.28,.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M803.25,261.52s-1.11,1.04-1.89,2.33c-.79,1.29,.27,3.04,.27,3.04,0,0,1.01-.85,1.23-1.86,.22-1.01,.39-3.51,.39-3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M801.57,277.07s-1.11,1.04-1.89,2.33,.27,3.04,.27,3.04c0,0,1.01-.85,1.24-1.86s.39-3.51,.39-3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M802.05,271.54s-1.02-1.13-2.29-1.94-3.04,.2-3.04,.2c0,0,.83,1.03,1.84,1.27,1.01,.25,3.5,.47,3.5,.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M801.62,277.15s1.36-.68,2.84-.98,2.76,1.29,2.76,1.29c0,0-1.15,.66-2.17,.52-1.03-.14-3.43-.83-3.43-.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M804.42,256.08s-1.36-.68-2.84-.98c-1.48-.3-2.76,1.29-2.76,1.29,0,0,1.15,.66,2.17,.52,1.03-.14,3.43-.83,3.43-.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M803.9,257.26s1.11,1.04,1.89,2.33c.79,1.29-.27,3.04-.27,3.04,0,0-1.01-.85-1.24-1.86-.22-1.01-.39-3.51-.39-3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M803.9,269.63s1.11,1.04,1.89,2.33c.79,1.29-.27,3.04-.27,3.04,0,0-1.01-.85-1.24-1.86-.22-1.01-.39-3.51-.39-3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M803.25,280.24s1.11,1.04,1.89,2.33-.27,3.04-.27,3.04c0,0-1.01-.85-1.24-1.86s-.39-3.51-.39-3.51Z"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "771.75 691.95 768.86 690.28 768.86 608.58 771.75 610.24 771.75 691.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "809.4 589.09 771.75 610.64 771.75 691.95 809.4 670.4 809.4 589.09"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "840.9 723.24 771.75 683.25 771.75 680.08 840.9 720.12 840.9 723.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "873.17 701.39 840.9 720.12 840.9 723.24 873.17 704.51 873.17 701.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "873.17 695.21 809.21 658.16 771.75 680.08 840.9 720.12 873.17 701.39 873.17 695.21"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "800.17 684.64 800.26 692.78 826.41 677.77 826.44 669.57 800.17 684.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "805.6 684.02 805.63 687.2 819.65 679.16 819.66 675.95 805.6 684.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "801.53 683.86 801.63 691.99 803.51 690.91 803.45 682.76 801.53 683.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M822.89,674.1c.89-.51,1.6-.2,1.6,.68s-.72,2.02-1.61,2.53c-.89,.51-1.61,.2-1.6-.68,0-.89,.72-2.02,1.61-2.53Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "800.17 684.64 826.44 669.57 803.87 656.42 777.57 671.51 800.17 684.64"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "777.57 672.73 799.27 685.34 799.25 691.09 777.58 678.65 777.58 679.45 800.26 692.78 800.17 684.64 777.57 671.51 777.57 672.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "799.27 685.34 777.57 672.73 777.58 678.65 799.25 691.09 799.27 685.34"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "828.95 701.24 829.04 709.38 855.19 694.38 855.21 686.18 828.95 701.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "834.38 700.62 834.41 703.81 848.43 695.76 848.44 692.55 834.38 700.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "830.31 700.46 830.41 708.59 832.29 707.52 832.23 699.36 830.31 700.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M851.67,690.7c.89-.51,1.6-.2,1.6,.68,0,.89-.72,2.02-1.61,2.53-.89,.51-1.6,.2-1.6-.68,0-.89,.72-2.02,1.61-2.53Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "828.95 701.24 855.21 686.18 832.64 673.02 806.34 688.11 828.95 701.24"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "806.34 689.33 828.05 701.94 828.03 707.69 806.35 695.25 806.35 696.06 829.04 709.38 828.95 701.24 806.34 688.11 806.34 689.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "828.05 701.94 806.34 689.33 806.35 695.25 828.03 707.69 828.05 701.94"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "840.9 689.18 771.75 649.19 771.75 646.02 840.9 686.07 840.9 689.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "873.17 667.34 840.9 686.07 840.9 689.18 873.17 670.45 873.17 667.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "873.17 661.15 809.21 624.1 771.75 646.02 840.9 686.07 873.17 667.34 873.17 661.15"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "828.59 648.44 860.2 666.76 841.97 677.21 810.3 658.92 828.59 648.44"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 810.3,
    y: 647.31,
    width: 18.29,
    height: 11.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "828.59 636.84 860.2 655.16 841.97 665.61 810.3 647.31 828.59 636.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "841.97 665.61 841.97 677.21 860.2 666.77 860.2 655.16 841.97 665.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "810.3 649.54 822.96 657.14 810.3 650.28 810.3 649.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "810.3 654.47 822.96 662.07 810.3 655.21 810.3 654.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "826.26 661.18 841.97 670.17 841.97 669.37 826.26 661.18"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "837.96 729.78 835.07 728.11 835.07 646.41 837.96 648.08 837.96 729.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "875.62 626.93 837.96 648.47 837.96 729.78 875.62 708.23 875.62 626.93"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "838.01 649.52 768.86 609.54 768.86 606.37 838.01 646.41 838.01 649.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "875.62 624.58 838.01 646.41 838.01 649.52 875.62 627.7 875.62 624.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "806.32 584.44 768.86 606.37 838.01 646.41 875.62 624.58 806.32 584.44"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "802.16 612.31 803 614.95 859.56 622.7 860.52 619.92 802.16 612.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M835.1,634.14l-31.04-17.92c-1.63-.94-1.43-2.6,.46-3.69l16.59-9.58c1.88-1.09,4.76-1.21,6.39-.26l31.04,17.92c1.63,.94,1.43,2.6-.46,3.69l-16.59,9.58c-1.88,1.09-4.76,1.21-6.39,.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M835.22,631.91l-32.05-18.5c-1.68-.97-1.47-2.69,.47-3.81l17.12-9.89c1.95-1.12,4.91-1.25,6.6-.27l32.05,18.5c1.68,.97,1.47,2.69-.47,3.81l-17.12,9.89c-1.95,1.12-4.91,1.25-6.6,.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "802.04 605 802.05 611.73 860.56 619.59 860.56 612.75 802.04 605"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M835.22,625.18l-32.05-18.5c-1.68-.97-1.47-2.69,.47-3.81l17.12-9.89c1.95-1.12,4.91-1.25,6.6-.27l32.05,18.5c1.68,.97,1.47,2.69-.47,3.81l-17.12,9.89c-1.95,1.12-4.91,1.25-6.6,.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "805.12 607.75 805.12 614.53 805.93 615 805.93 608.22 805.12 607.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "831.55 623.07 831.55 629.8 832.36 630.27 832.36 623.53 831.55 623.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "852.66 618.64 852.66 625.38 851.85 625.85 851.85 619.11 852.66 618.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "824.89 594.12 856.5 612.44 838.27 622.89 806.6 604.59 824.89 594.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "822.91 620.73 814.68 615.96 814.68 617.47 822.91 622.25 822.91 620.73"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M802.57,590.61l22.67,.63,35.31,20.47-18.98,.04c-2.93-.03-5.79-.82-8.33-2.28l-30.95-17.89c-.47-.27-.26-.99,.28-.97Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "860.56 610.49 860.56 611.71 856.9 610.51 857.25 609.79 860.56 610.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "802.04 589.9 802.04 591.14 805.27 591.58 802.04 589.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M802.57,589.37l22.67,.63,35.31,20.49-18.98,.02c-2.93-.03-5.79-.82-8.33-2.28l-30.95-17.89c-.47-.27-.26-.99,.28-.97Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M802.85,650.46c0,1.98-3.03,3.59-6.76,3.59s-6.76-1.61-6.76-3.59,3.03-3.59,6.76-3.59,6.76,1.61,6.76,3.59Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "784.94 638.47 789.41 650.91 802.79 651.1 807.98 638.47 784.94 638.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M796.5,631.33c-6.46,0-11.69,2.78-11.69,6.22s5.23,6.22,11.69,6.22,11.69-2.78,11.69-6.22-5.23-6.22-11.69-6.22Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M806.89,637.23c0-2.83-4.69-5.12-10.47-5.12s-10.47,2.29-10.47,5.12c0,.61,.26,1.19,.66,1.74,.74-2.89,4.96-5.91,13.45-4.77,3.21,.43,5.93,2.65,5.75,5.25,.67-.67,1.08-1.42,1.08-2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M800.06,634.2c-8.48-1.14-12.71,1.87-13.45,4.77,1.46,1.97,5.28,3.38,9.81,3.38,4.15,0,7.7-1.19,9.39-2.9,.17-2.6-2.55-4.82-5.75-5.25Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M792.76,637.96s-3.64-2.6-7.21-.86c-3.58,1.74-2.29,5.88-1.22,8.39,1.07,2.51,1.54,5.03,0,6.55-1.54,1.52-6.73,3.27-4.16,6.26,1.33,1.54,4.76,3.74,2.78,6.36-1.26,1.67-.77,5.82-.77,5.82,0,0-2.03-2.37-.68-5.25,.98-2.09,.97-3.33-1.1-5.27s-3.42-4.57-.76-6.47c2.66-1.89,5.26-2.33,4.44-4.93-.82-2.6-2.84-8.38-1.05-10.98,2.39-3.44,9.08-3.18,10.47-.49,.64,1.24-.28,1.35-.74,.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M782.84,642.69s-1.21,1.14-2.07,2.55c-.86,1.41,.29,3.32,.29,3.32,0,0,1.1-.93,1.35-2.03,.25-1.1,.43-3.83,.43-3.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M781,659.67s-1.21,1.14-2.07,2.55c-.86,1.41,.29,3.32,.29,3.32,0,0,1.1-.93,1.35-2.03,.25-1.1,.43-3.83,.43-3.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M781.53,653.64s-1.11-1.23-2.5-2.12c-1.39-.89-3.32,.22-3.32,.22,0,0,.91,1.12,2.01,1.39s3.82,.51,3.82,.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M781.06,659.76s1.48-.75,3.1-1.07c1.62-.32,3.02,1.41,3.02,1.41,0,0-1.25,.72-2.37,.57s-3.75-.91-3.75-.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M785.38,636.26s-1.48-.75-3.1-1.07c-1.62-.32-3.02,1.41-3.02,1.41,0,0,1.25,.72,2.37,.57s3.75-.91,3.75-.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M783.35,638.55s1.21,1.14,2.07,2.55c.86,1.41-.29,3.32-.29,3.32,0,0-1.1-.93-1.35-2.03-.25-1.1-.43-3.83-.43-3.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M783.55,651.55s1.21,1.14,2.07,2.55c.86,1.41-.29,3.32-.29,3.32,0,0-1.1-.93-1.35-2.03-.25-1.1-.43-3.83-.43-3.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M782.84,663.14s1.21,1.14,2.07,2.55c.86,1.41-.29,3.32-.29,3.32,0,0-1.1-.93-1.35-2.03-.25-1.1-.43-3.83-.43-3.83Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M797.27,639.17c.32,3.24,1.29,6.36,.21,8.87s-1.54,5.03,0,6.55c1.54,1.52,6.73,3.27,4.16,6.26-1.33,1.54-4.76,3.74-2.78,6.36,1.26,1.67,.77,5.82,.77,5.82,0,0,2.03-2.37,.68-5.25-.98-2.09-.97-3.33,1.1-5.27,2.07-1.94,3.42-4.57,.76-6.47-2.66-1.89-5.26-2.33-4.44-4.93,.82-2.6,2.41-8.13,1.05-10.98-.98-2.06,.49-3.96,2.02-3.24,1.23-1.89-3.98-2.32-3.53,2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M798.97,645.24s1.21,1.14,2.07,2.55c.86,1.41-.29,3.32-.29,3.32,0,0-1.1-.93-1.35-2.03-.25-1.1-.43-3.83-.43-3.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M800.81,662.22s1.21,1.14,2.07,2.55c.86,1.41-.29,3.32-.29,3.32,0,0-1.1-.93-1.35-2.03-.25-1.1-.43-3.83-.43-3.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M800.28,656.18s1.11-1.23,2.5-2.12c1.39-.89,3.32,.22,3.32,.22,0,0-.91,1.12-2,1.39-1.1,.27-3.82,.51-3.82,.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M800.75,662.31s-1.48-.75-3.1-1.07c-1.62-.32-3.02,1.41-3.02,1.41,0,0,1.25,.72,2.37,.57s3.75-.91,3.75-.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M798.51,641.42s-1.5,.7-2.76,1.77c-1.26,1.07-.76,3.24-.76,3.24,0,0,1.34-.54,1.92-1.51,.58-.97,1.6-3.51,1.6-3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M798.27,654.09s-1.21,1.14-2.07,2.55c-.86,1.41,.29,3.32,.29,3.32,0,0,1.1-.93,1.35-2.03s.43-3.83,.43-3.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M798.97,665.68s-1.21,1.14-2.07,2.55c-.86,1.41,.29,3.32,.29,3.32,0,0,1.1-.93,1.35-2.03,.25-1.1,.43-3.83,.43-3.83Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M797.5,638.86s-2.7-.75-4.92,2.45c-2.26,3.27-1.49,6.32-.42,8.83,1.07,2.51,1.54,5.03,0,6.55-1.54,1.52-6.73,3.27-4.16,6.26,1.33,1.54,4.76,3.74,2.78,6.36-1.26,1.67-.77,5.82-.77,5.82,0,0-2.03-2.37-.68-5.25,.98-2.09,.97-3.33-1.1-5.27-2.07-1.94-3.42-4.57-.76-6.47,2.66-1.89,5.26-2.33,4.44-4.93-.82-2.6-2.44-8.15-1.05-10.98,2.21-4.48,5.85-5.27,6.94-4.17,.49,.5,.37,.79-.31,.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M790.69,647.35s-1.21,1.14-2.07,2.55c-.86,1.41,.29,3.32,.29,3.32,0,0,1.1-.93,1.35-2.03,.25-1.1,.43-3.83,.43-3.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M788.85,664.33s-1.21,1.14-2.07,2.55c-.86,1.41,.29,3.32,.29,3.32,0,0,1.1-.93,1.35-2.03,.25-1.1,.43-3.83,.43-3.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M789.37,658.29s-1.11-1.23-2.5-2.12c-1.39-.89-3.32,.22-3.32,.22,0,0,.91,1.12,2,1.39,1.1,.27,3.82,.51,3.82,.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M788.9,664.42s1.48-.75,3.1-1.07c1.62-.32,3.02,1.41,3.02,1.41,0,0-1.25,.72-2.37,.57-1.12-.15-3.75-.91-3.75-.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M791.96,641.4s-1.48-.75-3.1-1.07c-1.62-.32-3.02,1.41-3.02,1.41,0,0,1.25,.72,2.37,.57,1.12-.15,3.75-.91,3.75-.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M791.39,642.69s1.21,1.14,2.07,2.55c.86,1.41-.29,3.32-.29,3.32,0,0-1.1-.93-1.35-2.03s-.43-3.83-.43-3.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M791.39,656.2s1.21,1.14,2.07,2.55c.86,1.41-.29,3.32-.29,3.32,0,0-1.1-.93-1.35-2.03s-.43-3.83-.43-3.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M790.69,667.79s1.21,1.14,2.07,2.55c.86,1.41-.29,3.32-.29,3.32,0,0-1.1-.93-1.35-2.03-.25-1.1-.43-3.83-.43-3.83Z"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M737.55,325.11c0,1-1.53,1.81-3.41,1.81s-3.41-.81-3.41-1.81,1.53-1.81,3.41-1.81,3.41,.81,3.41,1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M737.55,321.22c0,1-1.53,1.81-3.41,1.81s-3.41-.81-3.41-1.81,1.53-1.81,3.41-1.81,3.41,.81,3.41,1.81Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 730.74,
    y: 321.22,
    width: 6.82,
    height: 3.89
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 691.33,
    cy: 300.4,
    rx: 3.41,
    ry: 1.81
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 691.33,
    cy: 296.51,
    rx: 3.41,
    ry: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 687.93,
    y: 296.51,
    width: 6.82,
    height: 3.89
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M779.99,300.53c0,1-1.53,1.81-3.41,1.81s-3.41-.81-3.41-1.81,1.53-1.81,3.41-1.81,3.41,.81,3.41,1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M779.99,296.64c0,1-1.53,1.81-3.41,1.81s-3.41-.81-3.41-1.81,1.53-1.81,3.41-1.81,3.41,.81,3.41,1.81Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 773.17,
    y: 296.64,
    width: 6.82,
    height: 3.89
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "688.46 237.94 688.46 299.15 731.03 323.72 734.14 257.12 688.46 237.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "734.14 325.51 782.67 297.44 782.67 237.94 734.14 265.97 734.14 325.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "734.14 325.51 731.03 323.72 731.03 264.41 734.14 266.2 734.14 325.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "688.88 299.39 685.77 297.6 685.77 238.29 688.88 240.08 688.88 299.39"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "734.14 267.52 685.77 239.56 685.77 236.39 734.14 264.41 734.14 267.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "782.65 236.39 734.14 264.41 734.14 267.52 782.65 239.5 782.65 236.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "734.14 208.26 685.77 236.39 734.14 264.41 782.65 236.39 734.14 208.26"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "688.88 280.38 688.88 281.08 731.03 305.41 731.03 304.65 688.88 280.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "688.88 260.73 688.88 261.43 731.03 285.76 731.03 285.01 688.88 260.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "714.69 300.3 701.84 292.89 701.84 295.07 714.69 302.52 714.69 300.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "714.69 280.66 701.84 273.25 701.84 275.42 714.69 282.87 714.69 280.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "714.69 261.01 701.84 253.6 701.84 255.77 714.69 263.22 714.69 261.01"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "706.04 237.39 733.25 253.09 762.25 236.24 735.11 220.6 706.04 237.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "708.63 236.74 733.33 250.99 759.66 235.69 735.02 221.49 708.63 236.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "706.04 235.93 733.25 246.37 762.25 229.52 735.11 219.14 706.04 235.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "733.25 246.37 733.25 253.09 762.25 236.24 762.25 229.52 733.25 246.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "757.07 234.47 735.8 246.88 735.8 249.67 757.07 237.27 757.07 234.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "760.78 230.37 759.11 231.34 759.11 238.07 760.78 237.09 760.78 230.37"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 186.04,
    y: 723.28,
    width: 6.34,
    height: 20.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M192.38,723.53c0,.93-1.42,1.69-3.17,1.69s-3.17-.75-3.17-1.69,1.42-1.69,3.17-1.69,3.17,.76,3.17,1.69Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M227.76,723.83c0,.93-1.42,1.69-3.17,1.69s-3.17-.76-3.17-1.69,1.42-1.69,3.17-1.69,3.17,.75,3.17,1.69Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 221.42,
    y: 702.98,
    width: 6.34,
    height: 20.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M227.76,703.23c0,.93-1.42,1.69-3.17,1.69s-3.17-.76-3.17-1.69,1.42-1.69,3.17-1.69,3.17,.76,3.17,1.69Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M119.38,701.92c0,.93-1.42,1.69-3.17,1.69s-3.17-.76-3.17-1.69,1.42-1.69,3.17-1.69,3.17,.76,3.17,1.69Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 113.04,
    y: 681.07,
    width: 6.34,
    height: 20.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M119.38,681.32c0,.93-1.42,1.69-3.17,1.69s-3.17-.75-3.17-1.69,1.42-1.69,3.17-1.69,3.17,.76,3.17,1.69Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M154.76,681.62c0,.93-1.42,1.69-3.17,1.69s-3.17-.76-3.17-1.69,1.42-1.69,3.17-1.69,3.17,.75,3.17,1.69Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 148.42,
    y: 660.77,
    width: 6.34,
    height: 20.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M154.76,661.02c0,.93-1.42,1.69-3.17,1.69s-3.17-.76-3.17-1.69,1.42-1.69,3.17-1.69,3.17,.76,3.17,1.69Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "150.97 653.98 105.77 680.44 189.21 728.75 234.59 702.42 150.97 653.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "105.77 680.44 105.77 684.41 189.21 732.72 189.21 728.75 105.77 680.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "189.21 728.75 189.21 732.72 234.59 706.39 234.59 702.42 189.21 728.75"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M199.86,703.84c0,1.69-2.58,3.06-5.76,3.06s-5.76-1.37-5.76-3.06,2.58-3.06,5.76-3.06,5.76,1.37,5.76,3.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "184.6 694.78 188.38 704.25 199.65 704.65 204.22 694.78 184.6 694.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M194.44,688.7c-5.5,0-9.96,2.37-9.96,5.3s4.46,5.3,9.96,5.3,9.96-2.37,9.96-5.3-4.46-5.3-9.96-5.3Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M203.3,693.72c0-2.41-3.99-4.36-8.92-4.36s-8.92,1.95-8.92,4.36c0,.52,.22,1.02,.56,1.48,.63-2.46,4.23-5.03,11.45-4.06,2.73,.37,5.05,2.26,4.9,4.47,.57-.57,.92-1.21,.92-1.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M197.48,691.14c-7.23-.97-10.83,1.6-11.45,4.06,1.24,1.67,4.5,2.88,8.35,2.88,3.53,0,6.56-1.01,8-2.47,.15-2.21-2.17-4.1-4.9-4.47Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M193.18,680.43c-.09-.33-.15-2.12,.46-4.22,.7-2.41,2.15-3.19,2.15-3.19,0,0-.56,2.23-.23,3.86,.32,1.63,.64,3.55,.64,3.55,0,0-2.1,3.62-3.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M190.31,674.57s1.09,4.13,.81,7c-.28,2.87,3.46,4.22,4.18,2.18,1.11-3.12-2-6.84-4.99-9.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M194.36,683.76c-.12-.4,.07-3.27,.94-5.37,.88-2.1,2.98-3.42,2.98-3.42,0,0-.86,1.99-.54,3.87s.99,4.12,.99,4.12l-1.77,4.3-2.6-3.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M187.94,673.02s-.32,5.6,.66,8.47c.98,2.88,3.88,7.28,3.88,7.28l1.89-3.78s-2.54-3.38-4.05-6.16c-1.51-2.78-2.37-5.81-2.37-5.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M186.54,684.68s-.68-3.22-1.2-5.85c-.51-2.63-.63-4.26-.63-4.26,0,0,3.3,4.24,4.47,6.32,1.17,2.08,3.29,7.54,3.29,7.54l-2.14,3.49-3.79-7.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M201.24,684.68s.69-3.22,1.2-5.85c.51-2.63,.63-4.26,.63-4.26,0,0-3.3,4.24-4.47,6.32-1.17,2.08-3.29,7.54-3.29,7.54l2.14,3.49,3.79-7.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M190.33,691.92c-.24-.36,1.49-6.56,2.14-8.31s2.91-2.39,3.94,0,2.31,8.57,2.31,8.57c0,0-4.2,6.12-8.4-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M179.78,680.89s2.65-.26,3.97,2.89c1.32,3.15,2.87,9.82,6.24,12.28,1.86,1.36,6.43,.66,6.43,.66,0,0-4.36-6.86-7.54-11.2-3.18-4.34-6.14-6.63-9.09-4.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M209.1,680.89s-2.65-.26-3.97,2.89c-1.32,3.15-2.72,9.71-5.94,12.37-2.28,1.88-7.23,1.05-7.23,1.05,0,0,4.86-7.33,8.05-11.67,3.18-4.34,6.14-6.63,9.09-4.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M192.48,683.76s.97,.7,1.39,1.43c.2,.35,.73,1.05,.73,1.05,0,0,.42-1.07,.77-1.48,.39-.48,1.06-.99,1.06-.99l-1.74,3.93s-1.19-1.55-1.45-2.22c-.35-.9-.75-1.72-.75-1.72Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "165.91 679.91 145.15 691.89 123.02 679.03 143.73 667.1 165.91 679.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "163.93 679.41 145.08 690.28 125 678.61 143.8 667.78 163.93 679.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "165.91 678.8 145.15 686.76 123.02 673.9 143.73 665.98 165.91 678.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "145.15 686.76 145.15 691.89 123.02 679.03 123.02 673.9 145.15 686.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "126.98 677.68 143.2 687.15 143.2 689.28 126.98 679.82 126.98 677.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "124.14 674.56 125.42 675.3 125.42 680.43 124.14 679.68 124.14 674.56"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M270.48,696.2c0,.93-1.42,1.69-3.17,1.69s-3.17-.76-3.17-1.69,1.42-1.69,3.17-1.69,3.17,.76,3.17,1.69Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 264.14,
    y: 681.3,
    width: 6.34,
    height: 14.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M171.88,639.28c0,.93-1.42,1.69-3.17,1.69s-3.17-.76-3.17-1.69,1.42-1.69,3.17-1.69,3.17,.76,3.17,1.69Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 165.54,
    y: 624.37,
    width: 6.34,
    height: 14.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M317.38,669.02c0,.93-1.42,1.69-3.17,1.69s-3.17-.76-3.17-1.69,1.42-1.69,3.17-1.69,3.17,.75,3.17,1.69Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 311.04,
    y: 654.12,
    width: 6.34,
    height: 14.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M214.39,531.27c-3.77,.12-9.47,6.89-10.39,17.64-1.14,13.32,1.32,50.12,1.32,50.12l9.08-5.24v-62.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M208.75,594.21s-1.59-31-1.59-39.93,7.23-23.01,7.23-23.01l105.17,60.67s-5.95,10.82-7.64,16.98c-1.69,6.16-1.43,46.09-1.43,46.09l-101.73-60.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M205.54,541.45l105.56,60.7,5.36-6.82-106.43-61.6s-1.49,1.45-2.62,3.54c-1.25,2.3-1.88,4.19-1.88,4.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M253.68,626.67c-.04-.31-3.68-31.3-2.93-45.21,.71-13.3,8.82-19.51,12.88-21.79,.48,.29,1.18,.67,1.71,.98-3.2,1.52-12.18,7-12.92,20.89-.74,13.77,2.88,44.62,2.92,44.93l-1.66,.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M319.56,591.94c-3.77,.12-9.47,6.89-10.39,17.64-1.14,13.32,1.32,50.12,1.32,50.12l9.08-5.24v-62.51Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "204.64 589.08 310.64 650.46 264.72 673.38 165.01 613.79 204.64 589.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M204.64,589.08c-5.93,1.79-34.98,13.5-41.37,17.29-7.11,4.22-2.34,17.06-2.34,17.06l43.71-24.85v-9.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "266.93 684.81 160.94 623.44 160.94 610.78 267.31 667.86 266.93 684.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M159.5,612.69l106.46,61.22,5.36-6.82-106.43-61.6s-2.67,1.14-3.87,2.98c-1.44,2.19-1.52,4.23-1.52,4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M310.64,650.46c-5.93,1.79-34.98,13.5-41.37,17.29-7.11,4.22-2.34,17.06-2.34,17.06l43.71-25.19v-9.16Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M208.26,650.82c-.94-4.48-1.75-11.69,1.8-14.99,8.11-7.54,34.69-16.51,42.47-19.03,.41,.25,1.24,.76,1.95,1.13-4.82,1.54-34.92,11.34-43.28,19.12-3.11,2.89-2.07,10.44-.97,14.91-.88-.48-1.52-.93-1.97-1.14Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "279.26 636.74 261.76 646.87 274.33 654.08 291.88 643.97 279.26 636.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "274.6 640.55 268.22 644.28 278.31 650.05 284.73 646.35 274.6 640.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "277.14 639.1 276.17 639.68 286.26 645.45 287.27 644.9 277.14 639.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "279.22 637.89 278.25 638.47 288.34 644.25 289.35 643.69 279.22 637.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "274.33 654.08 274.33 657.97 291.88 647.86 291.88 643.97 274.33 654.08"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "261.76 646.87 261.76 647.78 273.61 654.57 273.61 656.78 261.76 649.99 261.76 650.76 274.33 657.97 274.33 654.08 261.76 646.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "273.61 654.57 261.76 647.78 261.76 649.99 273.61 656.78 273.61 654.57"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M78.69,676.29c0,.93,1.42,1.69,3.17,1.69s3.17-.76,3.17-1.69-1.42-1.69-3.17-1.69-3.17,.75-3.17,1.69Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 78.69,
    y: 661.39,
    width: 6.34,
    height: 14.9,
    transform: "translate(163.73 1337.67) rotate(180)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M130.59,646.39c0,.93,1.42,1.69,3.17,1.69s3.17-.75,3.17-1.69-1.42-1.69-3.17-1.69-3.17,.76-3.17,1.69Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 130.59,
    y: 631.49,
    width: 6.34,
    height: 14.9,
    transform: "translate(267.52 1277.87) rotate(180)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 34.96,
    cy: 649.11,
    rx: 3.17,
    ry: 1.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 31.79,
    y: 634.21,
    width: 6.34,
    height: 14.9,
    transform: "translate(69.93 1283.32) rotate(180)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M84.86,540.05c3.77,.12,9.47,6.89,10.39,17.64,1.14,13.32-1.32,50.12-1.32,50.12l-9.08-5.24v-62.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M90.5,602.99s1.59-31,1.59-39.93-7.23-23.01-7.23-23.01l-55.24,31.97s5.95,10.82,7.64,16.98c1.69,6.16,1.43,46.09,1.43,46.09l51.81-32.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M93.78,550.44l-55.71,31.79-5.36-6.82,56.65-32.78s1.46,1.51,2.59,3.6c1.25,2.3,1.83,4.21,1.83,4.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M29.62,572.03c3.77,.12,9.47,6.89,10.39,17.64,1.14,13.32-1.32,50.12-1.32,50.12l-9.08-5.24v-62.51Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "94.49 598.13 38.54 630.54 84.46 653.47 139.2 620.68 94.49 598.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M94.49,598.13c5.93,1.79,34.98,13.5,41.37,17.29,7.11,4.22,2.34,17.06,2.34,17.06l-43.71-24.85v-9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M76.79,659.92c-1.19-1.77-2.27-3.61-3.33-5.46l65.38-35.08-.65,13.1-55.96,32.41c-1.81-1.65-4.52-3.57-5.45-4.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M139.63,621.79l-56.42,32.21-5.36-6.82,56.38-32.59s2.67,1.14,3.87,2.98c1.44,2.19,1.52,4.23,1.52,4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M38.54,630.54c5.93,1.79,34.98,13.5,41.37,17.29,7.11,4.22,2.34,17.06,2.34,17.06l-43.71-25.19v-9.16Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUsRightEx);
export default __webpack_public_path__ + "static/media/about-us-right-ex.f8343203447e51c34bb020f884d25197.svg";
export { ForwardRef as ReactComponent };